"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1931],{

/***/ 69463:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Qk": function() { return /* binding */ cookies; },
/* harmony export */   "WC": function() { return /* binding */ accountPages; },
/* harmony export */   "_j": function() { return /* binding */ routes; },
/* harmony export */   "co": function() { return /* binding */ analytics; },
/* harmony export */   "lI": function() { return /* binding */ contactInformation; },
/* harmony export */   "t7": function() { return /* binding */ kwikStatePlansToHide; }
/* harmony export */ });
/* unused harmony exports staticRoutes, affiliates */
function objectToParams(obj) {
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(obj)){
        params.set(key, value);
    }
    return params;
}
const routes = {
    CHECKOUT: {
        SUCCESS: (payload)=>"/checkout/success?".concat(objectToParams(payload).toString()),
        CHECKOUT: "/checkout",
        CHECKOUT_WITH_OFFER: (params)=>"/checkout?".concat(params.toString())
    },
    NUCALM: "https://nucalm.com/",
    NUCALM_JOIN: "https://nucalm.com/#join",
    LOGIN: "/login",
    SIGNUP: "/signup",
    "404": "/404",
    "500": "/500",
    FORGOT_PASSWORD: "/forgot-password",
    STORE: "https://store.nucalm.com/",
    HOME: "/",
    ACCOUNT: {
        ACCOUNT: "/account",
        AVAILABLE_PLANS: "/account/plans",
        PAYMENT_PROFILES: "/account/payment-profiles",
        CREATE_PAYMENT_PROFILE: "/account/payment-profiles/create",
        CHARGIFY_SUBSCRIPTION_PAYMENT: (id, token)=> false ? 0 : "https://staging-solace-lifesciences-inc.chargifypay.com/update_payment/".concat(id, "/").concat(token),
        SHIPPING_ADDRESS: "/account/shipping-address",
        ACCOUNT_DETAILS: "/account/account-details",
        INVOICES: "/account/invoices",
        INVOICE: (id)=>"".concat(routes.ACCOUNT.INVOICES, "/").concat(id),
        REFER: "/account/refer",
        PURCHASE_DISCS: "/account/purchase-discs",
        MANAGE_PLAN: (subscriptionId)=>"/account/plans/".concat(subscriptionId, "/manage"),
        MANAGE_PLAN_PAYMENT: (subscriptionId)=>"/account/plans/".concat(subscriptionId, "/payment"),
        CHANGE_PLAN: (subscriptionId, handle)=>"/account/plans/".concat(subscriptionId, "/change/").concat(handle),
        CANCEL_PLAN: (subscriptionId)=>"/account/plans/".concat(subscriptionId, "/cancel"),
        REACTIVATE_PLAN: (subscriptionId)=>"/account/plans/".concat(subscriptionId, "/reactivate"),
        PROMOTIONS: "/account/promotions",
        FAMILY_PLAN: "/account/family-plan",
        PAUSE_DISCS: (id)=>"/account/plans/".concat(id, "/pause-discs"),
        RETRY: (id)=>"/account/plans/".concat(id, "/retry"),
        DELETE: "/account/delete"
    },
    PRODUCTS: {
        GIFT_CARDS: "https://nucalm.com/products/gift-cards"
    },
    PRIVACY_POLICY: "https://nucalm.com/privacy-policy",
    PROGRAM_CREDITS: "https://nucalm.com/program-credits",
    TERMS_OF_SERVICE: "https://nucalm.com/terms-of-service",
    SUPPORT: "https://support.nucalm.com/",
    PHONE_NUMBER: "tel:+18008101701",
    SUPPORT_EMAIL: "mailto:support@nucalm.com",
    WEBSITE: {
        PRODUCTS_PRICING: "https://nucalm.com/products-pricing#subscriptionPlan"
    },
    MEETING_LINKS: {
        BETHANY: "https://meetings.hubspot.com/bethany-piziks"
    }
};
const objectToString = (obj)=>{
    return Object.keys(obj).map((key)=>{
        if (typeof obj[key] === "object") {
            const value = obj[key];
            return objectToString(value);
        }
        return "".concat(key, "=").concat(obj[key]);
    }).join("&");
};
const staticRoutes = ()=>{
    const invalidRoutes = [
        "BLOG",
        "RELEASES",
        "ACCOUNT",
        "PHONE_NUMBER",
        "SUPPORT_EMAIL",
        "SUPPORT",
        "PODCASTS"
    ];
    let obj = {};
    Object.keys(routes).map((k)=>{
        if (!invalidRoutes.includes(k)) {
            // @ts-ignore
            obj[k] = routes[k];
        }
    });
    const staticPagesStr = objectToString(obj);
    const ret = staticPagesStr.split("&").map((str)=>{
        const [_key, value] = str.split("=");
        return value;
    });
    return ret;
};
const contactInformation = {
    PHONE_NUMBER: "1.800.810.1701",
    EMAIL: "support@nucalm.com"
};
var ACCOUNT_PAGES;
(function(ACCOUNT_PAGES) {
    ACCOUNT_PAGES["ACCOUNT"] = "Account Overview";
    ACCOUNT_PAGES["AVAILABLE_PLANS"] = "Available Plans";
    ACCOUNT_PAGES["PURCHASE_DISCS"] = "Purchase Discs";
    ACCOUNT_PAGES["PAYMENT_PROFILES"] = "Billing Details";
    ACCOUNT_PAGES["ACCOUNT_DETAILS"] = "Account Details";
    ACCOUNT_PAGES["INVOICES"] = "Invoices";
    ACCOUNT_PAGES[// SUBSCRIPTIONS = "Subscriptions",
    "SHIPPING_ADDRESSES"] = "Shipping Address";
    ACCOUNT_PAGES["PROMOTIONS"] = "Promotions";
    ACCOUNT_PAGES["FAMILY_PLAN"] = "Family Plan";
    ACCOUNT_PAGES["PAUSE_DISCS"] = "Pause Discs";
    ACCOUNT_PAGES["STORE"] = "Store";
})(ACCOUNT_PAGES || (ACCOUNT_PAGES = {}));
const accountPages = new Map([
    [
        ACCOUNT_PAGES.ACCOUNT,
        routes.ACCOUNT.ACCOUNT
    ],
    [
        ACCOUNT_PAGES.AVAILABLE_PLANS,
        routes.ACCOUNT.AVAILABLE_PLANS
    ],
    [
        ACCOUNT_PAGES.ACCOUNT_DETAILS,
        routes.ACCOUNT.ACCOUNT_DETAILS
    ],
    [
        ACCOUNT_PAGES.INVOICES,
        routes.ACCOUNT.INVOICES
    ],
    [
        ACCOUNT_PAGES.STORE,
        routes.STORE
    ],
    [
        ACCOUNT_PAGES.PURCHASE_DISCS,
        routes.ACCOUNT.PURCHASE_DISCS
    ],
    // [ACCOUNT_PAGES.SUBSCRIPTIONS, routes.ACCOUNT.SUBSCRIPTIONS],
    [
        ACCOUNT_PAGES.SHIPPING_ADDRESSES,
        routes.ACCOUNT.SHIPPING_ADDRESS
    ],
    [
        ACCOUNT_PAGES.PROMOTIONS,
        routes.ACCOUNT.PROMOTIONS
    ],
    [
        ACCOUNT_PAGES.FAMILY_PLAN,
        routes.ACCOUNT.FAMILY_PLAN
    ]
]);
const cookies = {
    COOKIE_CONSENT: "cookie-consent",
    COOKIE_USER: "cookie-user",
    SESSION: "session"
};
const analytics = {
    GOOGLE_TAG_MANAGER_ID: "GTM-PMX7PVG",
    UA_ID: "UA-15199707-2",
    GA4_ID: "G-RJXWH5SK70"
};
const affiliates = {
    SHARE_A_SALE: {
        MERCHANT_ID: "100346",
        URL: "https://shareasale.com/sale.cfm"
    }
};
const kwikStatePlansToHide = [
    "kwikstate_annual"
];


/***/ }),

/***/ 63521:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(34406);

var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all)=>{
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of __getOwnPropNames(from))if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var __toESM = (mod, isNodeMode, target)=>(target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod));
var __toCommonJS = (mod)=>__copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
// index.ts
var content_exports = {};
__export(content_exports, {
    client: ()=>client,
    urlFor: ()=>urlFor
});
module.exports = __toCommonJS(content_exports);
// images/images.ts
var import_image_url = __toESM(__webpack_require__(53116));
// sanity-client/sanity-client.ts
var import_client = __toESM(__webpack_require__(50640));
var config = {
    projectId: "0jcqmme0",
    dataset: process.env.NEXT_PUBLIC_SANITY_DATASET,
    apiVersion: "v2021-03-25",
    useCdn: false
};
var client = (0, import_client.default)(config);
// images/images.ts
var builder = (0, import_image_url.default)(client);
function urlFor(source) {
    return builder.image(source).format("webp");
}
// Annotate the CommonJS export names for ESM import in node:
0 && (0);


/***/ }),

/***/ 98727:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var errorCodes = __webpack_require__(19121);
var types = __webpack_require__(9359);
var _ = Object.defineProperty;
var X = Object.getOwnPropertyDescriptor;
var q = Object.getOwnPropertyNames;
var Q = Object.prototype.hasOwnProperty;
var y = (e, n)=>()=>(e && (n = e(e = 0)), n);
var $ = (e, n)=>{
    for(var i in n)_(e, i, {
        get: n[i],
        enumerable: !0
    });
}, aa = (e, n, i, o)=>{
    if (n && typeof n == "object" || typeof n == "function") for (let r of q(n))!Q.call(e, r) && r !== i && _(e, r, {
        get: ()=>n[r],
        enumerable: !(o = X(n, r)) || o.enumerable
    });
    return e;
};
var ea = (e)=>aa(_({}, "__esModule", {
        value: !0
    }), e);
exports.emailIsValid = void 0;
exports.phoneIsValid = void 0;
exports.passwordIsValid = void 0;
var Aa, Sa;
exports.passwordValidatorsWithErrorMsg = void 0;
exports.inputIsRequired = void 0;
exports.wordMatch = void 0;
exports.returnsTrue = void 0;
var C;
exports.formInputValidators = void 0;
exports.passwordCriteriaValidator = void 0;
exports.checkAndSetFormErrors = void 0;
var w = y(()=>{
    exports.emailIsValid = (e)=>/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e), exports.phoneIsValid = (e)=>/^\s*(?:\+?(\d{1,3}))?[- (]*(\d{1,3})[- )]*(\d{3})[- ]*(\d{1,4})(?: *[x/#]{1}(\d+))?\s*$/.test(e), exports.passwordIsValid = (e)=>/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%.*?&]{8,}$/.test(e), Aa = [
        "greaterThan8",
        "includeUpperCaseLetter",
        "includeOneNumber",
        "includeOneSpecialChar"
    ], Sa = (e)=>{
        let n = !0;
        return e ? (Aa.forEach((i)=>{
            let o = exports.passwordValidatorsWithErrorMsg[i].regex;
            e.match(o) || (n = !1);
        }), n) : (n = !1, n);
    }, exports.passwordValidatorsWithErrorMsg = {
        greaterThan8: {
            regex: /.{8,}$/,
            errorMessage: errorCodes.errorCodeToMessage(errorCodes.formCodeErrors.VALIDATION.GREATER_THAN_8).message
        },
        includeUpperCaseLetter: {
            regex: /.*[A-Z].*/,
            errorMessage: errorCodes.errorCodeToMessage(errorCodes.formCodeErrors.VALIDATION.INCLUDE_UPPER_CASE_LETTER).message
        },
        includeOneNumber: {
            regex: /\d/,
            errorMessage: errorCodes.errorCodeToMessage(errorCodes.formCodeErrors.VALIDATION.INCLUDE_ONE_NUMBER).message
        },
        includeOneSpecialChar: {
            regex: /[!@#$%]+/,
            errorMessage: errorCodes.errorCodeToMessage(errorCodes.formCodeErrors.VALIDATION.INCLUDE_ONE_SPECIAL_CHAR).message
        }
    }, exports.inputIsRequired = (e)=>!!e, exports.wordMatch = (e, n)=>e === n, exports.returnsTrue = ()=>!0, C = {
        emailValidator: {
            method: exports.emailIsValid,
            errorMessage: errorCodes.errorCodeToMessage(errorCodes.formCodeErrors.INPUT.EMAIL).message
        },
        phoneValidator: {
            method: exports.phoneIsValid,
            errorMessage: errorCodes.errorCodeToMessage(errorCodes.formCodeErrors.INPUT.PHONE).message
        },
        passwordValidator: {
            method: Sa,
            errorMessage: errorCodes.errorCodeToMessage(errorCodes.formCodeErrors.INPUT.PASSWORD).message
        },
        requiredValidator: {
            method: exports.inputIsRequired,
            errorMessage: errorCodes.errorCodeToMessage(errorCodes.formCodeErrors.INPUT.REQUIRED).message
        },
        passwordMatchValidator: {
            method: exports.wordMatch,
            errorMessage: errorCodes.errorCodeToMessage(errorCodes.formCodeErrors.INPUT.PASSWORD_MATCH).message
        },
        optionalValidator: {
            method: exports.returnsTrue,
            errorMessage: ""
        }
    }, exports.formInputValidators = (e)=>{
        let n;
        switch(e){
            case "createEmail":
            case "email":
                n = C.emailValidator;
                break;
            case "phone":
                n = C.phoneValidator;
                break;
            case "createPassword":
                n = C.passwordValidator;
                break;
            case "wordMatch":
                n = C.passwordMatchValidator;
                break;
            case "optional":
            case "loginForm":
            case "signupForm":
            case "accountInfoForm":
            case "submit":
                n = C.optionalValidator;
                break;
            case "password":
            default:
                n = C.requiredValidator;
                break;
        }
        return n;
    }, exports.passwordCriteriaValidator = (e)=>[
            {
                regexName: "greaterThan8",
                isValid: !1,
                message: ""
            },
            {
                regexName: "includeUpperCaseLetter",
                isValid: !1,
                message: ""
            },
            {
                regexName: "includeOneNumber",
                isValid: !1,
                message: ""
            },
            {
                regexName: "includeOneSpecialChar",
                isValid: !1,
                message: ""
            }
        ].map((o)=>{
            let r = exports.passwordValidatorsWithErrorMsg[o.regexName].regex, h = exports.passwordValidatorsWithErrorMsg[o.regexName].errorMessage, S = o;
            return e.match(r) ? S = {
                ...S,
                isValid: !0
            } : S = {
                ...S,
                message: h
            }, S;
        }), exports.checkAndSetFormErrors = (e, n, i)=>{
        let o = !1;
        return Object.keys(e).forEach((r)=>{
            let h = n[r], { method: S , errorMessage: j  } = exports.formInputValidators(r);
            S(h) || (i("set", r, j), o = !0);
        }), o;
    };
});
var J = {};
$(J, {
    checkAndSetFormErrors: ()=>exports.checkAndSetFormErrors,
    emailIsValid: ()=>exports.emailIsValid,
    formInputValidators: ()=>exports.formInputValidators,
    inputIsRequired: ()=>exports.inputIsRequired,
    passwordCriteriaValidator: ()=>exports.passwordCriteriaValidator,
    passwordIsValid: ()=>exports.passwordIsValid,
    passwordValidatorsWithErrorMsg: ()=>exports.passwordValidatorsWithErrorMsg,
    phoneIsValid: ()=>exports.phoneIsValid,
    returnsTrue: ()=>exports.returnsTrue,
    wordMatch: ()=>exports.wordMatch
});
var U = y(()=>{
    w();
});
var Ua = new Map([
    [
        "mastermind_lifetime_nucalm",
        "Mastermind"
    ]
]), Oa = new Map([
    [
        "mastermind_lifetime_nucalm",
        199500
    ],
    [
        "standard_monthly",
        4990
    ],
    [
        "standard_annual",
        1
    ],
    [
        "premium_annual",
        1
    ],
    [
        "premium_monthly",
        4990
    ],
    [
        "pro_monthly",
        4990
    ],
    [
        "pro_lifetime_nucalm",
        1
    ],
    [
        "lifetime_lifetime_nucalm",
        1
    ],
    [
        "military_lifetime_nucalm",
        1
    ]
]), ya = new Map([
    [
        "mastermind_lifetime_nucalm",
        "Mastermind"
    ],
    [
        "standard_monthly",
        "NuCalm Monthly"
    ],
    [
        "standard_annual",
        "NuCalm Annual"
    ],
    [
        "premium_annual",
        "Premium Annual"
    ],
    [
        "premium_monthly",
        "Premium Monthly"
    ],
    [
        "pro_monthly",
        "Professional Monthly"
    ],
    [
        "pro_lifetime_nucalm",
        "Professional Lifetime"
    ],
    [
        "lifetime_lifetime_nucalm",
        "NuCalm Lifetime"
    ],
    [
        "military_lifetime_nucalm",
        "Military Package"
    ],
    [
        "demo_monthly",
        "Demo Subscription"
    ],
    [
        "mastermind_fiveyears_nucalm",
        "Mastermind"
    ]
]), Ka = new Map([
    [
        "mastermind_lifetime_nucalm",
        "This is a description for Mastermind"
    ],
    [
        "military_lifetime_nucalm",
        "This is a description for the military package"
    ],
    [
        "standard_monthly",
        "This is a description for nucalm monthly"
    ]
]), ka = {
    premium_monthly_family_plan: {
        title: "Premium Monthly Family Plan",
        price: 4999,
        itemsIncluded: [
            "NuCalm Software**",
            "Ignite Warrior Brain Software",
            "DEEP SLEEP Software"
        ]
    },
    monthly_family_plan: {
        title: "Monthly Family Plan",
        price: 2999,
        itemsIncluded: [
            "NuCalm Software**"
        ]
    }
};
var a = {
    MASTERMIND: "mastermind_lifetime_nucalm",
    NUCALM_MONTHLY: "standard_monthly",
    NUCALM_ANNUAL: "standard_annual",
    NUCALM_LIFETIME: "lifetime_lifetime_nucalm",
    PREMIUM_MONTHLY: "premium_monthly",
    PREMIUM_ANNUAL: "premium_annual",
    PROFESSIONAL_MONTHLY: "pro_monthly",
    PROFESSIONAL_LIFETIME: "pro_lifetime_nucalm",
    MILITARY_PACKAGE: "military_lifetime_nucalm",
    DEMO: "demo_monthly",
    MASTERMIND_CURRENT: "mastermind_fiveyears_nucalm"
}, t = {
    NUCALM_MONTHLY_PREMIUM_MONTHLY: a.NUCALM_MONTHLY + "_" + a.PREMIUM_MONTHLY,
    PREMIUM_MONTHLY_NUCALM_MONTHLY: a.PREMIUM_MONTHLY + "_" + a.NUCALM_MONTHLY,
    NUCALM_MONTHLY_NUCALM_ANNUAL: a.NUCALM_MONTHLY + "_" + a.NUCALM_ANNUAL,
    NUCALM_ANNUAL_NUCALM_MONTHLY: a.NUCALM_ANNUAL + "_" + a.NUCALM_MONTHLY,
    NUCALM_MONTHLY_PREMIUM_ANNUAL: a.NUCALM_MONTHLY + "_" + a.PREMIUM_ANNUAL,
    PREMIUM_ANNUAL_NUCALM_MONTHLY: a.PREMIUM_ANNUAL + "_" + a.NUCALM_MONTHLY,
    NUCALM_MONTHLY_MASTERMIND: a.NUCALM_MONTHLY + "_" + a.MASTERMIND,
    PREMIUM_MONTHLY_NUCALM_ANNUAL: a.PREMIUM_MONTHLY + "_" + a.NUCALM_ANNUAL,
    NUCALM_ANNUAL_PREMIUM_MONTHLY: a.NUCALM_ANNUAL + "_" + a.PREMIUM_MONTHLY,
    PREMIUM_MONTHLY_PREMIUM_ANNUAL: a.PREMIUM_MONTHLY + "_" + a.PREMIUM_ANNUAL,
    PREMIUM_ANNUAL_PREMIUM_MONTHLY: a.PREMIUM_ANNUAL + "_" + a.PREMIUM_MONTHLY,
    PREMIUM_MONTHLY_MASTERMIND: a.PREMIUM_MONTHLY + "_" + a.MASTERMIND,
    NUCALM_ANNUAL_PREMIUM_ANNUAL: a.NUCALM_ANNUAL + "_" + a.PREMIUM_ANNUAL,
    PREMIUM_ANNUAL_NUCALM_ANNUAL: a.PREMIUM_ANNUAL + "_" + a.NUCALM_ANNUAL,
    NUCALM_ANNUAL_MASTERMIND: a.NUCALM_ANNUAL + "_" + a.MASTERMIND,
    PREMIUM_ANNUAL_MASTERMIND: a.PREMIUM_ANNUAL + "_" + a.MASTERMIND,
    NUCALM_MONTHLY_MASTERMIND_CURRENT: a.NUCALM_MONTHLY + "_" + a.MASTERMIND_CURRENT,
    PREMIUM_MONTHLY_MASTERMIND_CURRENT: a.PREMIUM_MONTHLY + "_" + a.MASTERMIND_CURRENT,
    NUCALM_ANNUAL_MASTERMIND_CURRENT: a.NUCALM_ANNUAL + "_" + a.MASTERMIND_CURRENT,
    PREMIUM_ANNUAL_MASTERMIND_CURRENT: a.PREMIUM_ANNUAL + "_" + a.MASTERMIND_CURRENT
}, s = {
    NUCALM_SUBSCRIPTION: 1379083,
    DEEP_SLEEP_SOFTWARE: 1379070,
    EXPEDITED_SHIPPING: 1379081,
    FARADAY_BAGS_5_PACK: 1379079,
    IGNITE_DEEP_SLEEP_BUNDLE: 1505996,
    IGNITE_SOFTWARE: 1379069,
    NUCALM_ONE_TIME_DISCS_10: 1379870,
    NUCALM_RECURRING_DISCS_10: 1379063,
    NUCALM_ONE_TIME_DISCS_100: 1430084,
    NUCALM_ONE_TIME_DISCS_20: 1379072,
    NUCALM_RECURRING_DISCS_20: 1379071,
    NUCALM_RECURRING_DISCS_120: 1379062,
    NUCALM_EYE_MASK: 1379073,
    NUCALM_LEASE_KIT: 1379869,
    NUCALM_LIFETIME: 1379077,
    NUCALM_PRO_LIFETIME: 1379078,
    NUCALM_PRO_SUBSCRIPTION: 1379075,
    NUCALM_RELAX_CALMING_CREAM: 1379074,
    NUCALM_SOFTWARE: 1379868,
    NUCALM_SUBSCRIPTION_KIT: 1379076,
    ONE_MONTH_HOLD: 1462662,
    SHIPPING: 1506488,
    STANDARD_SHIPPING: 1379080,
    NO_SHIP: 1603160,
    NO_SHIP_ONE_TIME: 1609500,
    MASTERMIND: 1695832,
    FOCUS_SOFTWARE: 1702864
}, d = {
    NUCALM_SUBSCRIPTION: 1389381,
    DEEP_SLEEP_SOFTWARE: 1389369,
    EXPEDITED_SHIPPING: 1389380,
    FARADAY_BAGS_5_PACK: 1389378,
    IGNITE_DEEP_SLEEP_BUNDLE: 1499607,
    IGNITE_SOFTWARE: 1389368,
    NUCALM_ONE_TIME_DISCS_10: 1389384,
    NUCALM_RECURRING_DISCS_10: 1389367,
    NUCALM_ONE_TIME_DISCS_100: 1529956,
    NUCALM_ONE_TIME_DISCS_20: 1389371,
    NUCALM_RECURRING_DISCS_20: 1389370,
    NUCALM_RECURRING_DISCS_120: 1389366,
    NUCALM_EYE_MASK: 1389372,
    NUCALM_LEASE_KIT: 1389383,
    NUCALM_LIFETIME: 1389376,
    NUCALM_PRO_LIFETIME: 1389377,
    NUCALM_PRO_SUBSCRIPTION: 1389374,
    NUCALM_SOFTWARE: 1389382,
    NUCALM_SUBSCRIPTION_KIT: 1389375,
    SHIPPING: 1499606,
    STANDARD_SHIPPING: 1389379,
    NO_SHIP: 1601215,
    NO_SHIP_ONE_TIME: 1609499,
    MASTERMIND: 1695831,
    FOCUS_SOFTWARE: 1702865
}, Ya = {
    DEEP_SLEEP_SOFTWARE: "deepsleep_software",
    EXPEDITED_SHIPPING: "expedited_shipping",
    FARADAY_BAGS_5_PACK: "faradaybags_5",
    IGNITE_DEEP_SLEEP_BUNDLE: "ignite_deepsleep_software",
    IGNITE_SOFTWARE: "ignite_software",
    NUCALM_ONE_TIME_DISCS_10: "nucalm_onetime_discs_10",
    NUCALM_RECURRING_DISCS_10: "nucalm_recurring_discs_10",
    NUCALM_ONE_TIME_DISCS_20: "nucalm_onetime_discs_20",
    NUCALM_RECURRING_DISCS_20: "nucalm_recurring_discs_20",
    NUCALM_ONE_TIME_DISCS_100: "nucalm_onetime_discs_100",
    NUCALM_RECURRING_DISCS_120: "nucalm_recurring_discs_120",
    NUCALM_EYE_MASK: "nucalm_eyemask",
    NUCALM_LEASE_KIT: "nucalm_lease_kit",
    NUCALM_LIFETIME: "nucalm_lifetime",
    NUCALM_PRO_LIFETIME: "nucalm_lifetime_pro",
    NUCALM_PRO_SUBSCRIPTION: "nucalm_subscription_pro",
    NUCALM_SOFTWARE: "nucalm_software",
    NUCALM_SUBSCRIPTION: "nucalm_subscription",
    NUCALM_SUBSCRIPTION_KIT: "nucalm_subscription_kit",
    STANDARD_SHIPPING: "shipping_standard",
    SHIPPING: "onetime_shipping",
    NO_SHIP: "no_ship",
    ONE_MONTH_HOLD: "hold_month_1",
    MASTERMIND: "mastermind",
    FOCUS_SOFTWARE: "focus_software"
}, Wa = new Map([
    [
        a.MASTERMIND,
        !1
    ],
    [
        a.MASTERMIND_CURRENT,
        !1
    ],
    [
        a.NUCALM_MONTHLY,
        !0
    ],
    [
        a.NUCALM_ANNUAL,
        !0
    ],
    [
        a.NUCALM_LIFETIME,
        !1
    ],
    [
        a.PREMIUM_MONTHLY,
        !0
    ],
    [
        a.PREMIUM_ANNUAL,
        !0
    ],
    [
        a.PROFESSIONAL_MONTHLY,
        !0
    ],
    [
        a.PROFESSIONAL_LIFETIME,
        !1
    ],
    [
        a.MILITARY_PACKAGE,
        !1
    ],
    [
        a.DEMO,
        !0
    ]
]), N = new Map([
    [
        a.NUCALM_MONTHLY,
        {
            staging: 1433704,
            prod: 1421827
        }
    ],
    [
        a.NUCALM_ANNUAL,
        {
            staging: 1433705,
            prod: 1421828
        }
    ],
    [
        a.PREMIUM_MONTHLY,
        {
            staging: 1433704,
            prod: 1421827
        }
    ],
    [
        a.PREMIUM_ANNUAL,
        {
            staging: 1433705,
            prod: 1421828
        }
    ]
]), T = new Map([
    [
        a.NUCALM_MONTHLY,
        {
            staging: 1433676,
            prod: 1421798
        }
    ],
    [
        a.PREMIUM_MONTHLY,
        {
            staging: 1433676,
            prod: 1421798
        }
    ],
    [
        a.NUCALM_ANNUAL,
        {
            staging: 1433677,
            prod: 1421799
        }
    ],
    [
        a.PREMIUM_ANNUAL,
        {
            staging: 1433677,
            prod: 1421799
        }
    ],
    [
        a.MASTERMIND,
        {
            staging: 1433680,
            prod: 1421800
        }
    ],
    [
        a.MASTERMIND_CURRENT,
        {
            staging: 1433680,
            prod: 1421800
        }
    ]
]), m = new Map([
    [
        a.NUCALM_MONTHLY,
        {
            staging: 1433682,
            prod: 1421802
        }
    ],
    [
        a.PREMIUM_MONTHLY,
        {
            staging: 1433682,
            prod: 1421802
        }
    ],
    [
        a.NUCALM_ANNUAL,
        {
            staging: 1433683,
            prod: 1421803
        }
    ],
    [
        a.PREMIUM_ANNUAL,
        {
            staging: 1433683,
            prod: 1421803
        }
    ],
    [
        a.MASTERMIND,
        {
            staging: 1433686,
            prod: 1421804
        }
    ],
    [
        a.MASTERMIND_CURRENT,
        {
            staging: 1433686,
            prod: 1421804
        }
    ]
]), p = new Map([
    [
        a.NUCALM_MONTHLY,
        {
            staging: 1838141,
            prod: 1838139
        }
    ],
    [
        a.PREMIUM_MONTHLY,
        {
            staging: 1838141,
            prod: 1838139
        }
    ],
    [
        a.NUCALM_ANNUAL,
        {
            staging: 1839201,
            prod: 1839200
        }
    ],
    [
        a.PREMIUM_ANNUAL,
        {
            staging: 1839201,
            prod: 1839200
        }
    ],
    [
        a.MASTERMIND,
        {
            staging: 1839202,
            prod: 1838990
        }
    ],
    [
        a.MASTERMIND_CURRENT,
        {
            staging: 1839202,
            prod: 1838990
        }
    ]
]), K = new Map([
    [
        a.MASTERMIND,
        {
            staging: 1825493,
            prod: 1825490
        }
    ]
]), k = new Map([
    [
        a.MASTERMIND_CURRENT,
        {
            staging: 1829966,
            prod: 1829967
        }
    ]
]), wa = new Map([
    [
        a.NUCALM_MONTHLY,
        {
            staging: [
                {
                    component_id: d.NUCALM_SUBSCRIPTION,
                    price_point_id: N.get(a.NUCALM_MONTHLY).staging,
                    quantity: 1
                }
            ],
            prod: [
                {
                    component_id: s.NUCALM_SUBSCRIPTION,
                    price_point_id: N.get(a.NUCALM_MONTHLY).prod,
                    quantity: 1
                }
            ]
        }
    ],
    [
        a.NUCALM_ANNUAL,
        {
            staging: [
                {
                    component_id: d.NUCALM_SUBSCRIPTION,
                    price_point_id: N.get(a.NUCALM_ANNUAL).staging,
                    quantity: 1
                }
            ],
            prod: [
                {
                    component_id: s.NUCALM_SUBSCRIPTION,
                    price_point_id: N.get(a.NUCALM_ANNUAL).prod,
                    quantity: 1
                }
            ]
        }
    ],
    [
        a.PREMIUM_ANNUAL,
        {
            staging: [
                {
                    component_id: d.NUCALM_SUBSCRIPTION,
                    price_point_id: N.get(a.PREMIUM_ANNUAL).staging,
                    quantity: 1
                },
                {
                    component_id: d.IGNITE_SOFTWARE,
                    price_point_id: T.get(a.PREMIUM_ANNUAL).staging,
                    quantity: 1,
                    accrue_charge: !1
                },
                {
                    component_id: d.DEEP_SLEEP_SOFTWARE,
                    price_point_id: m.get(a.PREMIUM_ANNUAL).staging,
                    quantity: 1,
                    accrue_charge: !1
                }
            ],
            prod: [
                {
                    component_id: s.NUCALM_SUBSCRIPTION,
                    price_point_id: N.get(a.PREMIUM_ANNUAL).prod,
                    quantity: 1
                },
                {
                    component_id: s.IGNITE_SOFTWARE,
                    price_point_id: T.get(a.PREMIUM_ANNUAL).prod,
                    quantity: 1,
                    accrue_charge: !1
                },
                {
                    component_id: s.DEEP_SLEEP_SOFTWARE,
                    price_point_id: m.get(a.PREMIUM_ANNUAL).prod,
                    quantity: 1,
                    accrue_charge: !1
                }
            ]
        }
    ],
    [
        a.PREMIUM_MONTHLY,
        {
            staging: [
                {
                    component_id: d.NUCALM_SUBSCRIPTION,
                    price_point_id: N.get(a.PREMIUM_MONTHLY).staging,
                    quantity: 1
                },
                {
                    component_id: d.IGNITE_SOFTWARE,
                    price_point_id: T.get(a.PREMIUM_MONTHLY).staging,
                    quantity: 1,
                    accrue_charge: !1
                },
                {
                    component_id: d.DEEP_SLEEP_SOFTWARE,
                    price_point_id: m.get(a.PREMIUM_MONTHLY).staging,
                    quantity: 1,
                    accrue_charge: !1
                }
            ],
            prod: [
                {
                    component_id: s.NUCALM_SUBSCRIPTION,
                    price_point_id: N.get(a.PREMIUM_MONTHLY).prod,
                    quantity: 1
                },
                {
                    component_id: s.IGNITE_SOFTWARE,
                    price_point_id: T.get(a.PREMIUM_MONTHLY).prod,
                    quantity: 1,
                    accrue_charge: !1
                },
                {
                    component_id: s.DEEP_SLEEP_SOFTWARE,
                    price_point_id: m.get(a.PREMIUM_MONTHLY).prod,
                    quantity: 1,
                    accrue_charge: !1
                }
            ]
        }
    ],
    [
        a.MASTERMIND,
        {
            staging: [
                {
                    component_id: d.NUCALM_LIFETIME,
                    price_point_id: K.get(a.MASTERMIND).staging,
                    quantity: 1,
                    accrue_charge: !1
                },
                {
                    component_id: d.IGNITE_SOFTWARE,
                    price_point_id: T.get(a.MASTERMIND).staging,
                    quantity: 1,
                    accrue_charge: !1
                },
                {
                    component_id: d.DEEP_SLEEP_SOFTWARE,
                    price_point_id: m.get(a.MASTERMIND).staging,
                    quantity: 1,
                    accrue_charge: !1
                },
                {
                    component_id: s.FOCUS_SOFTWARE,
                    price_point_id: p.get(a.MASTERMIND).staging,
                    quantity: 1,
                    accrue_charge: !1
                }
            ],
            prod: [
                {
                    component_id: s.NUCALM_LIFETIME,
                    price_point_id: K.get(a.MASTERMIND).prod,
                    quantity: 1,
                    accrue_charge: !1
                },
                {
                    component_id: s.IGNITE_SOFTWARE,
                    price_point_id: T.get(a.MASTERMIND).prod,
                    quantity: 1,
                    accrue_charge: !1
                },
                {
                    component_id: s.DEEP_SLEEP_SOFTWARE,
                    price_point_id: m.get(a.MASTERMIND).prod,
                    quantity: 1,
                    accrue_charge: !1
                },
                {
                    component_id: s.FOCUS_SOFTWARE,
                    price_point_id: p.get(a.MASTERMIND).prod,
                    quantity: 1,
                    accrue_charge: !1
                }
            ]
        }
    ],
    [
        a.MASTERMIND_CURRENT,
        {
            staging: [
                {
                    component_id: d.MASTERMIND,
                    price_point_id: k.get(a.MASTERMIND_CURRENT).staging,
                    quantity: 1,
                    accrue_charge: !1
                },
                {
                    component_id: d.IGNITE_SOFTWARE,
                    price_point_id: T.get(a.MASTERMIND_CURRENT).staging,
                    quantity: 1,
                    accrue_charge: !1
                },
                {
                    component_id: d.DEEP_SLEEP_SOFTWARE,
                    price_point_id: m.get(a.MASTERMIND_CURRENT).staging,
                    quantity: 1,
                    accrue_charge: !1
                },
                {
                    component_id: s.FOCUS_SOFTWARE,
                    price_point_id: p.get(a.MASTERMIND_CURRENT).staging,
                    quantity: 1,
                    accrue_charge: !1
                }
            ],
            prod: [
                {
                    component_id: s.MASTERMIND,
                    price_point_id: k.get(a.MASTERMIND_CURRENT).prod,
                    quantity: 1,
                    accrue_charge: !1
                },
                {
                    component_id: s.IGNITE_SOFTWARE,
                    price_point_id: T.get(a.MASTERMIND_CURRENT).prod,
                    quantity: 1,
                    accrue_charge: !1
                },
                {
                    component_id: s.DEEP_SLEEP_SOFTWARE,
                    price_point_id: m.get(a.MASTERMIND_CURRENT).prod,
                    quantity: 1,
                    accrue_charge: !1
                },
                {
                    component_id: s.FOCUS_SOFTWARE,
                    price_point_id: p.get(a.MASTERMIND_CURRENT).prod,
                    quantity: 1,
                    accrue_charge: !1
                }
            ]
        }
    ]
]), Ja = new Map([
    [
        a.NUCALM_MONTHLY,
        [
            a.NUCALM_ANNUAL,
            a.PREMIUM_ANNUAL,
            a.MASTERMIND_CURRENT
        ]
    ],
    [
        a.NUCALM_ANNUAL,
        [
            a.PREMIUM_ANNUAL,
            a.MASTERMIND_CURRENT
        ]
    ],
    [
        a.PREMIUM_MONTHLY,
        [
            a.PREMIUM_ANNUAL,
            a.NUCALM_ANNUAL,
            a.MASTERMIND_CURRENT
        ]
    ],
    [
        a.PREMIUM_ANNUAL,
        [
            a.NUCALM_ANNUAL,
            a.MASTERMIND_CURRENT
        ]
    ],
    [
        a.MASTERMIND,
        []
    ],
    [
        a.MASTERMIND_CURRENT,
        []
    ],
    [
        a.PROFESSIONAL_MONTHLY,
        []
    ],
    [
        a.PROFESSIONAL_LIFETIME,
        []
    ],
    [
        a.MILITARY_PACKAGE,
        []
    ],
    [
        a.DEMO,
        []
    ],
    [
        a.NUCALM_LIFETIME,
        []
    ]
]), za = new Map([
    [
        a.NUCALM_MONTHLY,
        [
            a.PREMIUM_MONTHLY,
            a.MASTERMIND_CURRENT
        ]
    ],
    [
        a.NUCALM_ANNUAL,
        [
            a.MASTERMIND_CURRENT,
            a.PREMIUM_ANNUAL
        ]
    ],
    [
        a.PREMIUM_MONTHLY,
        [
            a.MASTERMIND_CURRENT,
            a.NUCALM_MONTHLY
        ]
    ],
    [
        a.PREMIUM_ANNUAL,
        [
            a.MASTERMIND_CURRENT,
            a.NUCALM_ANNUAL
        ]
    ],
    [
        a.MASTERMIND,
        []
    ],
    [
        a.MASTERMIND_CURRENT,
        []
    ],
    [
        a.PROFESSIONAL_MONTHLY,
        []
    ],
    [
        a.PROFESSIONAL_LIFETIME,
        []
    ],
    [
        a.MILITARY_PACKAGE,
        []
    ],
    [
        a.DEMO,
        []
    ],
    [
        a.NUCALM_LIFETIME,
        []
    ]
]), xa = new Set([
    a.MASTERMIND,
    a.NUCALM_LIFETIME,
    a.PROFESSIONAL_LIFETIME,
    a.MILITARY_PACKAGE
]), ja = new Map([
    [
        a.NUCALM_MONTHLY,
        [
            a.NUCALM_ANNUAL,
            a.PREMIUM_ANNUAL,
            a.PREMIUM_MONTHLY,
            a.MASTERMIND_CURRENT
        ]
    ],
    [
        a.NUCALM_ANNUAL,
        [
            a.MASTERMIND_CURRENT,
            a.PREMIUM_ANNUAL,
            a.PREMIUM_MONTHLY,
            a.NUCALM_MONTHLY
        ]
    ],
    [
        a.PREMIUM_MONTHLY,
        [
            a.MASTERMIND_CURRENT,
            a.PREMIUM_ANNUAL,
            a.NUCALM_ANNUAL,
            a.NUCALM_MONTHLY
        ]
    ],
    [
        a.PREMIUM_ANNUAL,
        [
            a.MASTERMIND_CURRENT,
            a.PREMIUM_MONTHLY,
            a.NUCALM_ANNUAL,
            a.NUCALM_MONTHLY
        ]
    ],
    [
        a.MASTERMIND,
        []
    ],
    [
        a.MASTERMIND_CURRENT,
        []
    ],
    [
        a.PROFESSIONAL_MONTHLY,
        []
    ],
    [
        a.PROFESSIONAL_LIFETIME,
        []
    ],
    [
        a.MILITARY_PACKAGE,
        []
    ],
    [
        a.DEMO,
        []
    ],
    [
        a.NUCALM_LIFETIME,
        []
    ]
]), na = ((r)=>(r.STANDARD = "standard", r.EXPEDITED = "expedited", r.STANDARD_KIT = "standard_kit", r.EXPEDITED_KIT = "expedited_kit", r))(na || {}), R = new Map([
    [
        "standard",
        "600"
    ],
    [
        "expedited",
        "2900"
    ],
    [
        "standard_kit",
        "600"
    ],
    [
        "expedited_kit",
        "2900"
    ]
]), c = new Map([
    [
        "standard",
        "600"
    ],
    [
        "expedited",
        "2900"
    ],
    [
        "standard_kit",
        "600"
    ],
    [
        "expedited_kit",
        "2900"
    ]
]), L = new Map([
    [
        "standard",
        "1800"
    ],
    [
        "expedited",
        "4800"
    ],
    [
        "standard_kit",
        "1800"
    ],
    [
        "expedited_kit",
        "4800"
    ]
]), B = new Map([
    [
        "standard",
        "600"
    ],
    [
        "expedited",
        "2900"
    ],
    [
        "standard_kit",
        "600"
    ],
    [
        "expedited_kit",
        "2900"
    ]
]), E = new Map([
    [
        "standard",
        "4900"
    ],
    [
        "expedited",
        "8000"
    ],
    [
        "standard_kit",
        "4900"
    ],
    [
        "expedited_kit",
        "8000"
    ]
]), Xa = new Map([
    [
        "standard",
        "600"
    ],
    [
        "expedited",
        "1500"
    ]
]), qa = new Map([
    [
        "standard",
        "4900"
    ],
    [
        "expedited",
        "7900"
    ]
]), l = new Map([
    [
        "standard_kit",
        "0"
    ],
    [
        "expedited_kit",
        "2900"
    ]
]), A = new Map([
    [
        "standard_kit",
        "4900"
    ],
    [
        "expedited_kit",
        "8000"
    ]
]), G = new Map([
    [
        "standard",
        "4900"
    ],
    [
        "expedited",
        "8000"
    ],
    [
        "standard_kit",
        "4900"
    ],
    [
        "expedited_kit",
        "8000"
    ]
]), P = new Map([
    [
        "standard",
        "4900"
    ],
    [
        "expedited",
        "8000"
    ],
    [
        "standard_kit",
        "4900"
    ],
    [
        "expedited_kit",
        "8000"
    ]
]), Qa = new Map([
    [
        a.NUCALM_MONTHLY,
        {
            standard: R.get("standard"),
            expedited: R.get("expedited"),
            standard_kit: R.get("standard_kit"),
            expedited_kit: R.get("expedited_kit")
        }
    ],
    [
        a.NUCALM_ANNUAL,
        {
            standard: c.get("standard"),
            expedited: c.get("expedited"),
            standard_kit: c.get("standard_kit"),
            expedited_kit: c.get("expedited_kit")
        }
    ],
    [
        a.PREMIUM_MONTHLY,
        {
            standard: R.get("standard"),
            expedited: R.get("expedited"),
            standard_kit: R.get("standard_kit"),
            expedited_kit: R.get("expedited_kit")
        }
    ],
    [
        a.PREMIUM_ANNUAL,
        {
            standard: c.get("standard"),
            expedited: c.get("expedited"),
            standard_kit: c.get("standard_kit"),
            expedited_kit: c.get("expedited_kit")
        }
    ],
    [
        a.MASTERMIND,
        {
            standard: l.get("standard"),
            standard_kit: l.get("standard_kit"),
            expedited: l.get("expedited"),
            expedited_kit: l.get("expedited_kit")
        }
    ],
    [
        types.ProductHandle.LifetimeLifetimeNucalm,
        {
            standard: l.get("standard"),
            standard_kit: l.get("standard_kit"),
            expedited: l.get("expedited"),
            expedited_kit: l.get("expedited_kit")
        }
    ],
    [
        a.MASTERMIND_CURRENT,
        {
            standard: l.get("standard"),
            expedited: l.get("expedited"),
            standard_kit: l.get("standard_kit"),
            expedited_kit: l.get("expedited_kit")
        }
    ],
    [
        a.PROFESSIONAL_LIFETIME,
        {
            standard: L.get("standard"),
            standard_kit: L.get("standard_kit"),
            expedited: L.get("expedited"),
            expedited_kit: L.get("expedited_kit")
        }
    ],
    [
        a.PROFESSIONAL_MONTHLY,
        {
            standard: B.get("standard"),
            standard_kit: B.get("standard_kit"),
            expedited: B.get("expedited"),
            expedited_kit: B.get("expedited_kit")
        }
    ]
]), $a = new Map([
    [
        a.NUCALM_ANNUAL,
        {
            standard: E.get("standard"),
            expedited: E.get("expedited"),
            standard_kit: E.get("standard_kit"),
            expedited_kit: E.get("expedited_kit")
        }
    ],
    [
        a.PREMIUM_ANNUAL,
        {
            standard: E.get("standard"),
            expedited: E.get("expedited"),
            standard_kit: E.get("standard_kit"),
            expedited_kit: E.get("expedited_kit")
        }
    ],
    [
        a.MASTERMIND,
        {
            standard: A.get("standard"),
            expedited: A.get("expedited"),
            standard_kit: A.get("standard_kit"),
            expedited_kit: A.get("expedited_kit")
        }
    ],
    [
        a.MASTERMIND_CURRENT,
        {
            standard: A.get("standard"),
            expedited: A.get("expedited"),
            standard_kit: A.get("standard_kit"),
            expedited_kit: A.get("expedited_kit")
        }
    ],
    [
        types.ProductHandle.LifetimeLifetimeNucalm,
        {
            standard: A.get("standard"),
            expedited: A.get("expedited"),
            standard_kit: A.get("standard_kit"),
            expedited_kit: A.get("expedited_kit")
        }
    ],
    [
        a.PROFESSIONAL_LIFETIME,
        {
            standard: G.get("standard"),
            standard_kit: G.get("standard_kit"),
            expedited: G.get("expedited"),
            expedited_kit: G.get("expedited_kit")
        }
    ],
    [
        a.PROFESSIONAL_MONTHLY,
        {
            standard: P.get("standard"),
            standard_kit: P.get("standard_kit"),
            expedited: P.get("expedited"),
            expedited_kit: P.get("expedited_kit")
        }
    ]
]);
var ae = new Map([
    [
        t.NUCALM_MONTHLY_PREMIUM_MONTHLY,
        {
            productChange: "immediate",
            renewalDate: null
        }
    ],
    [
        t.PREMIUM_MONTHLY_NUCALM_MONTHLY,
        {
            productChange: "delayed",
            renewalDate: null
        }
    ],
    [
        t.NUCALM_MONTHLY_NUCALM_ANNUAL,
        {
            productChange: "delayed",
            renewalDate: null
        }
    ],
    [
        t.NUCALM_ANNUAL_NUCALM_MONTHLY,
        {
            productChange: "delayed",
            renewalDate: null
        }
    ],
    [
        t.NUCALM_MONTHLY_PREMIUM_ANNUAL,
        {
            productChange: "immediate",
            renewalDate: new Date
        }
    ],
    [
        t.PREMIUM_ANNUAL_NUCALM_MONTHLY,
        {
            productChange: "delayed",
            renewalDate: null
        }
    ],
    [
        t.NUCALM_MONTHLY_MASTERMIND,
        {
            productChange: "immediate",
            renewalDate: new Date
        }
    ],
    [
        t.NUCALM_MONTHLY_MASTERMIND_CURRENT,
        {
            productChange: "immediate",
            renewalDate: new Date
        }
    ],
    [
        t.PREMIUM_MONTHLY_NUCALM_ANNUAL,
        {
            productChange: "delayed",
            renewalDate: null
        }
    ],
    [
        t.NUCALM_ANNUAL_PREMIUM_MONTHLY,
        {
            productChange: "delayed",
            renewalDate: null
        }
    ],
    [
        t.PREMIUM_MONTHLY_PREMIUM_ANNUAL,
        {
            productChange: "delayed",
            renewalDate: null
        }
    ],
    [
        t.PREMIUM_ANNUAL_PREMIUM_MONTHLY,
        {
            productChange: "delayed",
            renewalDate: null
        }
    ],
    [
        t.PREMIUM_MONTHLY_MASTERMIND,
        {
            productChange: "immediate",
            renewalDate: new Date
        }
    ],
    [
        t.PREMIUM_MONTHLY_MASTERMIND_CURRENT,
        {
            productChange: "immediate",
            renewalDate: new Date
        }
    ],
    [
        t.NUCALM_ANNUAL_PREMIUM_ANNUAL,
        {
            productChange: "immediate",
            renewalDate: null
        }
    ],
    [
        t.PREMIUM_ANNUAL_NUCALM_ANNUAL,
        {
            productChange: "delayed",
            renewalDate: null
        }
    ],
    [
        t.NUCALM_ANNUAL_MASTERMIND,
        {
            productChange: "immediate",
            renewalDate: new Date
        }
    ],
    [
        t.NUCALM_ANNUAL_MASTERMIND_CURRENT,
        {
            productChange: "immediate",
            renewalDate: new Date
        }
    ],
    [
        t.PREMIUM_ANNUAL_MASTERMIND,
        {
            productChange: "immediate",
            renewalDate: new Date
        }
    ],
    [
        t.PREMIUM_ANNUAL_MASTERMIND_CURRENT,
        {
            productChange: "immediate",
            renewalDate: new Date
        }
    ]
]), ee = new Map([
    [
        "standard",
        {
            staging: {
                component_id: d.SHIPPING,
                quantity: 1,
                accrue_charge: !1
            },
            prod: {
                component_id: s.SHIPPING,
                quantity: 1,
                accrue_charge: !1
            }
        }
    ]
]), ne = new Map([
    [
        "standard",
        {
            staging: {
                component_id: d.STANDARD_SHIPPING,
                price_point_id: 1433702,
                quantity: 1,
                accrue_charge: !0,
                upgrade_charge: "none"
            },
            prod: {
                component_id: s.STANDARD_SHIPPING,
                quantity: 1,
                price_point_id: 1421822,
                accrue_charge: !0,
                upgrade_charge: "none"
            }
        }
    ],
    [
        "expedited",
        {
            staging: {
                component_id: d.EXPEDITED_SHIPPING,
                price_point_id: 1433703,
                quantity: 1,
                accrue_charge: !0,
                upgrade_charge: "none"
            },
            prod: {
                component_id: s.EXPEDITED_SHIPPING,
                quantity: 1,
                price_point_id: 1421823,
                accrue_charge: !0,
                upgrade_charge: "none"
            }
        }
    ]
]), ie = {
    METERED_COMPONENT: "metered_component",
    QUANTITY_BASED_COMPONENT: "quantity_based_component",
    ON_OFF_COMPONENT: "on_off_component",
    PREPAID_USAGE_COMPONENT: "prepaid_usage_component"
}, g = {
    ACTIVE: "active",
    CANCELLED: "cancelled",
    EXPIRED: "expired",
    ON_HOLD: "on_hold",
    PAST_DUE: "past_due",
    SOFT_FAILURE: "soft_failure",
    TRAILING: "trailing",
    TRIAL_ENDED: "trial_ended",
    UNPAID: "unpaid",
    SUSPENDED: "suspended"
}, oe = new Map([
    [
        g.ACTIVE,
        "Active"
    ],
    [
        g.CANCELLED,
        "Cancelled"
    ],
    [
        g.EXPIRED,
        "Expired"
    ],
    [
        g.SUSPENDED,
        "Suspended"
    ],
    [
        g.PAST_DUE,
        "Past Due"
    ],
    [
        g.UNPAID,
        "Unpaid"
    ]
]);
var le = {
    countryCode: "",
    phone: "",
    firstName: "",
    lastName: "",
    email: ""
}, Ae = {
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    countryCode: ""
}, Se = {
    addressOne: "",
    addressTwo: "",
    country: "",
    city: "",
    importDuties: "",
    state: "",
    zip: "",
    canShowShippingText: !0
}, Me = "accountInfo", ue = {
    ACCOUNT_INFO: "accountInfo"
}, Ne = {
    firstNameBilling: "",
    lastNameBilling: "",
    sameAsAddress: !1,
    addressOneBilling: "",
    addressTwoBilling: "",
    cityBilling: "",
    stateBilling: "",
    zipBilling: "",
    countryBilling: ""
}, Te = {
    fistNameBilling: "",
    lastNameBilling: "",
    sameAsAddress: !1,
    addressOneBilling: "",
    addressTwoBilling: "",
    cityBilling: "",
    stateBilling: "",
    zipBilling: "",
    countryBilling: ""
}, oa = types.PaymentProfileCardTypes.Visa, me = {
    promoCode: "",
    isPromoCodeValid: !1,
    paymentMethod: "card",
    token: "",
    stripeDetails: {
        vaultToken: "",
        card: {
            brand: oa,
            exp_month: "",
            exp_year: "",
            last4: ""
        }
    }
}, Re = [
    1,
    44,
    61,
    52,
    41,
    49,
    33
], ce = [
    1379081,
    1506488,
    1379080,
    1389380,
    1499606,
    1389379
];
var ra = function(e) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en-US", i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        day: "numeric",
        month: "short",
        year: "numeric"
    };
    return new Date(e).toLocaleDateString(n, i);
};
var De = (e)=>{
    let n = [];
    return e.offer_items.forEach((i)=>{
        var h;
        let o = i.component_id, r = n.findIndex((S)=>S.component_id === o);
        r === -1 && n.push({
            component_id: o,
            allocated_quantity: Number(i.starting_quantity || i.quantity),
            price_point_id: i.price_point_id
        }), r !== -1 && ((h = n[r]) == null ? void 0 : h.allocated_quantity) !== i.quantity && (n[r].allocated_quantity = i.quantity);
    }), n;
}, _e = (e)=>e.map((n)=>({
            product_id: n.component_id,
            name: n.memo,
            price: n.amount_in_cents,
            quantity: 1,
            category: n.kind
        }));
var b = (e, n, i)=>e.split(n).filter((o)=>!i.includes(o)).join(" "), sa = (e, n)=>"".concat(e, " ").concat(n.join(" ")), ta = (e)=>({
        space: " ",
        comma: ",",
        semi: ":"
    })[e], Oe = function(e, n, i) {
    let o = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
        parser: "space"
    };
    let r = ta(o.parser);
    switch(n){
        case "remove":
            return b(e, r, i);
        case "add":
            return sa(e, i);
        default:
            return b(e, r, i);
    }
}, ye = (e, n)=>{
    let i;
    switch(n){
        case "stripe":
            i = [
                "amex",
                "diners",
                "discover",
                "jcb",
                "mastercard",
                "visa"
            ];
            break;
        default:
            i = [
                "amex",
                "diners",
                "discover",
                "jcb",
                "mastercard",
                "visa"
            ];
            break;
    }
    return i.includes(e);
}, Ke = (e)=>({
        amex: "american_express",
        diners: "diners_club",
        discover: "discover",
        jcb: "jcb",
        mastercard: "master",
        visa: "visa"
    })[e], ke = (e)=>da(e).toString(), da = (e)=>{
    let n = new URLSearchParams;
    return Object.keys(e).forEach((i)=>{
        let o = e[i];
        Array.isArray(o) ? o.forEach((r)=>n.append(i, r)) : n.set(i, o);
    }), n;
}, F = (e)=>({
        accountInfo: "Account Information",
        paymentInfo: "Payment Information"
    })[e], He = (e, n)=>{
    let i = {};
    return Object.keys(n).forEach((o)=>{
        !e[o] || (i = {
            ...i,
            [o]: e[o]
        });
    }), i;
}, be = (e)=>{
    let n = Math.floor(e / 1e3), i = Math.floor(n / 60);
    return n = n % 60, i = i % 60, "".concat(i, ":").concat(n.toString().padStart(2, "0"));
};
U();
function Na(e) {
    return e == null ? void 0 : e.map((n)=>n.message).join(", ");
}
var ze = (e)=>{
    let n = errorCodes.firebaseAuthErrors[e] ? errorCodes.firebaseAuthErrors[e] : errorCodes.firebaseAuthErrors.general;
    return errorCodes.errorCodeToMessage(n).message;
}, xe = (e)=>{
    let n = {
        isStepsCompleted: !0,
        steps: []
    };
    return Object.keys(e).forEach((i)=>{
        let o = e[i];
        (!o.isCompleted || !o.hasFinishedOnce) && (n.isStepsCompleted = !1, n.steps.push(F(i)));
    }), n;
};
var I = {
    AF: {
        name: "Afghanistan",
        divisions: {
            "AF-BDS": "Badakhshān",
            "AF-BDG": "Bādghīs",
            "AF-BGL": "Baghlān",
            "AF-BAL": "Balkh",
            "AF-BAM": "Bāmīān",
            "AF-FRA": "Farāh",
            "AF-FYB": "Fāryāb",
            "AF-GHA": "Ghaznī",
            "AF-GHO": "Ghowr",
            "AF-HEL": "Helmand",
            "AF-HER": "Herāt",
            "AF-JOW": "Jowzjān",
            "AF-KAB": "Kabul (Kābol)",
            "AF-KAN": "Kandahār",
            "AF-KAP": "Kāpīsā",
            "AF-KNR": "Konar (Kunar)",
            "AF-KDZ": "Kondoz (Kunduz)",
            "AF-LAG": "Laghmān",
            "AF-LOW": "Lowgar",
            "AF-NAN": "Nangrahār (Nangarhār)",
            "AF-NIM": "Nīmrūz",
            "AF-ORU": "Orūzgān (Urūzgā",
            "AF-PIA": "Paktīā",
            "AF-PKA": "Paktīkā",
            "AF-PAR": "Parwān",
            "AF-SAM": "Samangān",
            "AF-SAR": "Sar-e Pol",
            "AF-TAK": "Takhār",
            "AF-WAR": "Wardak (Wardag)",
            "AF-ZAB": "Zābol (Zābul)"
        }
    },
    AL: {
        name: "Albania",
        divisions: {
            "AL-BR": "Berat",
            "AL-BU": "Bulqiz\xeb",
            "AL-DL": "Delvin\xeb",
            "AL-DV": "Devoll",
            "AL-DI": "Dib\xebr",
            "AL-DR": "Durr\xebs",
            "AL-EL": "Elbasan",
            "AL-FR": "Fier",
            "AL-GR": "Gramsh",
            "AL-GJ": "Gjirokast\xebr",
            "AL-HA": "Has",
            "AL-KA": "Kavaj\xeb",
            "AL-ER": "Kolonj\xeb",
            "AL-KO": "Korc\xeb",
            "AL-KR": "Kruj\xeb",
            "AL-KC": "Kucov\xeb",
            "AL-KU": "Kuk\xebs",
            "AL-LA": "La\xe7",
            "AL-LE": "Lezh\xeb",
            "AL-LB": "Librazhd",
            "AL-LU": "Lushnj\xeb",
            "AL-MM": "Mal\xebsia e Madhe",
            "AL-MK": "Mallakast\xebr",
            "AL-MT": "Mat",
            "AL-MR": "Mirdit\xeb",
            "AL-PQ": "Peqin",
            "AL-PR": "P\xebrmet",
            "AL-PG": "Pogradec",
            "AL-PU": "Puk\xeb",
            "AL-SR": "Sarand\xeb",
            "AL-SK": "Skrapar",
            "AL-SH": "Shkod\xebr",
            "AL-TE": "Tepelen\xeb",
            "AL-TR": "Tiran\xeb",
            "AL-TP": "Tropoj\xeb",
            "AL-VL": "Vlor\xeb"
        }
    },
    DZ: {
        name: "Algeria",
        divisions: {
            "DZ-01": "Adrar",
            "DZ-44": "A\xefn Defla",
            "DZ-46": "A\xefn T\xe9mouchent",
            "DZ-16": "Alger",
            "DZ-05": "Batna",
            "DZ-08": "B\xe9char",
            "DZ-06": "B\xe9ja\xefa",
            "DZ-07": "Biskra",
            "DZ-09": "Blida",
            "DZ-34": "Bordj Bou Arr\xe9ridj",
            "DZ-10": "Bouira",
            "DZ-35": "Boumerd\xe8s",
            "DZ-02": "Chlef",
            "DZ-25": "Constantine",
            "DZ-17": "Djelfa",
            "DZ-32": "El Bayadh",
            "DZ-39": "El Oued",
            "DZ-36": "El Tarf",
            "DZ-47": "Gharda\xefa",
            "DZ-24": "Guelma",
            "DZ-33": "Illizi",
            "DZ-18": "Jijel",
            "DZ-40": "Khenchela",
            "DZ-03": "Laghouat",
            "DZ-29": "Mascara",
            "DZ-26": "M\xe9d\xe9a",
            "DZ-43": "Mila",
            "DZ-27": "Mostaganem",
            "DZ-28": "Msila",
            "DZ-45": "Naama",
            "DZ-31": "Oran",
            "DZ-30": "Ouargla",
            "DZ-04": "Oum el Bouaghi",
            "DZ-48": "Relizane",
            "DZ-20": "Sa\xefda",
            "DZ-19": "S\xe9tif",
            "DZ-22": "Sidi Bel Abb\xe8s",
            "DZ-21": "Skikda",
            "DZ-41": "Souk Ahras",
            "DZ-11": "Tamanghasset",
            "DZ-12": "T\xe9bessa",
            "DZ-14": "Tiaret",
            "DZ-37": "Tindouf",
            "DZ-42": "Tipaza",
            "DZ-38": "Tissemsilt",
            "DZ-15": "Tizi Ouzou",
            "DZ-13": "Tlemcen"
        }
    },
    AS: {
        name: "American Samoa",
        divisions: {
            "AS-AS": "American Samoa"
        }
    },
    AD: {
        name: "Andorra",
        divisions: {
            "AD-AD": "Andorra"
        }
    },
    AO: {
        name: "Angola",
        divisions: {
            "AO-BGO": "Bengo",
            "AO-BGU": "Benguela",
            "AO-BIE": "Bi\xe9",
            "AO-CAB": "Cabinda",
            "AO-CCU": "Cuando-Cubango",
            "AO-CNO": "Cuanza Norte",
            "AO-CUS": "Cuanza Sul",
            "AO-CNN": "Cunene",
            "AO-HUA": "Huambo",
            "AO-HUI": "Hu\xedla",
            "AO-LUA": "Luanda",
            "AO-LNO": "Lunda Norte",
            "AO-LSU": "Lunda Sul",
            "AO-MAL": "Malange",
            "AO-MOX": "Moxico",
            "AO-NAM": "Namibe",
            "AO-UIG": "U\xedge",
            "AO-ZAI": "Za\xefre"
        }
    },
    AI: {
        name: "Anguilla",
        divisions: {
            "AI-AI": "Anguilla"
        }
    },
    AQ: {
        name: "Antarctica",
        divisions: {
            "AQ-AQ": "Antarctica"
        }
    },
    AG: {
        name: "Antigua & Barbuda",
        divisions: {
            "AG-AG": "Antigua & Barbuda"
        }
    },
    AR: {
        name: "Argentina",
        divisions: {
            "AR-C": "Capital federal",
            "AR-B": "Buenos Aires",
            "AR-K": "Catamarca",
            "AR-X": "C\xf3rdoba",
            "AR-W": "Corrientes",
            "AR-H": "Chaco",
            "AR-U": "Chubut",
            "AR-E": "Entre R\xedos",
            "AR-P": "Formosa",
            "AR-Y": "Jujuy",
            "AR-L": "La Pampa",
            "AR-F": "La Rioja",
            "AR-M": "Mendoza",
            "AR-N": "Misiones",
            "AR-Q": "Neuqu\xe9n",
            "AR-R": "R\xedo Negro",
            "AR-A": "Salta",
            "AR-J": "San Juan",
            "AR-D": "San Luis",
            "AR-Z": "Santa Cruz",
            "AR-S": "Santa Fe",
            "AR-G": "Santiago del Estero",
            "AR-V": "Tierra del Fuego",
            "AR-T": "Tucum\xe1n"
        }
    },
    AM: {
        name: "Armenia",
        divisions: {
            "AM-ER": "Erevan",
            "AM-AG": "Aragacotn",
            "AM-AR": "Ararat",
            "AM-AV": "Armavir",
            "AM-GR": "Geģark'unik'",
            "AM-KT": "Kotayk'",
            "AM-LO": "Loŕy",
            "AM-SH": "Širak",
            "AM-SU": "Syunik'",
            "AM-TV": "Tavuš",
            "AM-VD": "Vayoc Jor"
        }
    },
    AW: {
        name: "Aruba",
        divisions: {
            "AW-AW": "Aruba"
        }
    },
    AU: {
        name: "Australia",
        divisions: {
            "AU-NSW": "New South Wales",
            "AU-QLD": "Queensland",
            "AU-SA": "South Australia",
            "AU-TAS": "Tasmania",
            "AU-VIC": "Victoria",
            "AU-WA": "Western Australia",
            "AU-ACT": "Australian Capital Territory",
            "AU-NT": "Northern Territory"
        }
    },
    AT: {
        name: "Austria",
        divisions: {
            "AT-1": "Burgenland",
            "AT-2": "K\xe4rnten",
            "AT-3": "Nieder\xf6sterreich",
            "AT-4": "Ober\xf6sterreich",
            "AT-5": "Salzburg",
            "AT-6": "Steiermark",
            "AT-7": "Tirol",
            "AT-8": "Vorarlberg",
            "AT-9": "Wien"
        }
    },
    AZ: {
        name: "Azerbaijan",
        divisions: {
            "AZ-MM": "Nax\xe7ivan",
            "AZ-AB": "\xc4li Bayramli",
            "AZ-BA": "Baki",
            "AZ-GA": "G\xe4nc\xe4",
            "AZ-LA": "L\xe4nk\xe4ran",
            "AZ-MI": "Ming\xe4\xe7evir",
            "AZ-NA": "Naftalan",
            "AZ-SA": "Ş\xe4ki",
            "AZ-SM": "Sumqayit",
            "AZ-SS": "Şuşa",
            "AZ-XA": "Xank\xe4ndi",
            "AZ-YE": "Yevlax",
            "AZ-ABS": "Abşeron",
            "AZ-AGC": "Ağcab\xe4di",
            "AZ-AGM": "Ağdam",
            "AZ-AGS": "Ağdas",
            "AZ-AGA": "Ağstafa",
            "AZ-AGU": "Ağsu",
            "AZ-AST": "Astara",
            "AZ-BAB": "Bab\xe4k",
            "AZ-BAL": "Balak\xe4n",
            "AZ-BAR": "B\xe4rd\xe4",
            "AZ-BEY": "Beyl\xe4qan",
            "AZ-BIL": "Bil\xe4suvar",
            "AZ-CAB": "C\xe4brayil",
            "AZ-CAL": "C\xe4lilabad",
            "AZ-CUL": "Culfa",
            "AZ-DAS": "Daşk\xe4s\xe4n",
            "AZ-DAV": "D\xe4v\xe4\xe7i",
            "AZ-FUZ": "F\xfczuli",
            "AZ-GAD": "G\xe4d\xe4b\xe4y",
            "AZ-GOR": "Goranboy",
            "AZ-GOY": "G\xf6y\xe7ay",
            "AZ-HAC": "Haciqabul",
            "AZ-IMI": "Imişli",
            "AZ-ISM": "Ismayilli",
            "AZ-KAL": "K\xe4lb\xe4c\xe4r",
            "AZ-KUR": "K\xfcrd\xe4mir",
            "AZ-LAC": "La\xe7in",
            "AZ-LAN": "L\xe4nk\xe4ran",
            "AZ-LER": "Lerik",
            "AZ-MAS": "Masalli",
            "AZ-NEF": "Neft\xe7ala",
            "AZ-OGU": "Oğuz",
            "AZ-ORD": "Ordubad",
            "AZ-QAB": "Q\xe4b\xe4l\xe4",
            "AZ-QAX": "Qax",
            "AZ-QAZ": "Qazax",
            "AZ-QOB": "Qobustan",
            "AZ-QBA": "Quba",
            "AZ-QBI": "Qubadlı",
            "AZ-QUS": "Qusar",
            "AZ-SAT": "Saatli",
            "AZ-SAB": "Sabirabad",
            "AZ-SAD": "S\xe4d\xe4r\xe4k",
            "AZ-SAH": "Şahbuz",
            "AZ-SAK": "Ş\xe4ki",
            "AZ-SAL": "Salyan",
            "AZ-SMI": "Şamaxı",
            "AZ-SKR": "Ş\xe4mkir",
            "AZ-SMX": "Samux",
            "AZ-SAR": "Ş\xe4rur",
            "AZ-SIY": "Siy\xe4z\xe4n",
            "AZ-SUS": "Şuşa",
            "AZ-TAR": "T\xe4rt\xe4r",
            "AZ-TOV": "Tovuz",
            "AZ-UCA": "Ucar",
            "AZ-XAC": "Xa\xe7maz",
            "AZ-XAN": "Xanlar",
            "AZ-XIZ": "Xizi",
            "AZ-XCI": "Xocalı",
            "AZ-XVD": "Xocav\xe4nd",
            "AZ-YAR": "Yardimli",
            "AZ-YEV": "Yevlax",
            "AZ-ZAN": "Z\xe4ngılan",
            "AZ-ZAQ": "Zaqatala",
            "AZ-ZAR": "Z\xe4rdab"
        }
    },
    BS: {
        name: "Bahamas",
        divisions: {
            "BS-AC": "Acklins and Crooked Islands",
            "BS-BI": "Bimini",
            "BS-CI": "Cat Island",
            "BS-EX": "Exuma",
            "BS-FP": "Freeport",
            "BS-FC": "Fresh Creek",
            "BS-GH": "Governor's Harbour",
            "BS-GT": "Green Turtle Cay",
            "BS-HI": "Harbour Island",
            "BS-HR": "High Rock",
            "BS-IN": "Inagua",
            "BS-KB": "Kemps Bay",
            "BS-LI": "Long Island",
            "BS-MH": "Marsh Harbour",
            "BS-MG": "Mayaguana",
            "BS-NP": "New Providence",
            "BS-NB": "Nicholls Town and Berry Islands",
            "BS-RI": "Ragged Island",
            "BS-RS": "Rock Sound",
            "BS-SP": "Sandy Point",
            "BS-SR": "San Salvador and Rum Cay"
        }
    },
    BH: {
        name: "Bahrain",
        divisions: {
            "BH-01": "Al Ḩadd",
            "BH-03": "Al Manāmah",
            "BH-10": "Al Minţaqah al Gharbīyah",
            "BH-07": "Al Minţaqah al Wusţa",
            "BH-05": "Al Minţaqah ash Shamālīyah",
            "BH-02": "Al Muḩarraq",
            "BH-09": "Ar Rifā‘",
            "BH-04": "Jidd Ḩafş",
            "BH-12": "Madīnat Ḩamad",
            "BH-08": "Madīnat ‘Īs\xe1",
            "BH-11": "Minţaqat Juzur Ḩawār",
            "BH-06": "Sitrah"
        }
    },
    BD: {
        name: "Bangladesh",
        divisions: {
            "BD-1": "Barisal bibhag",
            "BD-1B": "Barisal anchal",
            "BD-1Q": "Patuakhali anchal",
            "BD-2": "Chittagong bibhag",
            "BD-2A": "Bandarban anchal",
            "BD-2D": "Chittagong anchal",
            "BD-2E": "Chittagong Hill Tracts",
            "BD-2F": "Comilla anchal",
            "BD-2O": "Noakhali anchal",
            "BD-2T": "Sylhet anchal",
            "BD-3": "Dhaka bibhag",
            "BD-3G": "Dhaka anchal",
            "BD-3I": "Faridpur anchal",
            "BD-3J": "Jamalpur anchal",
            "BD-3N": "Mymensingh anchal",
            "BD-3U": "Tangail anchal",
            "BD-4": "Khulna bibhag",
            "BD-4K": "Jessore anchal",
            "BD-4L": "Khulna anchal",
            "BD-4M": "Khustia anchal",
            "BD-5": "Rajshahi bibhag",
            "BD-5C": "Bogra anchal",
            "BD-5H": "Dinajpur anchal",
            "BD-5P": "Pabna anchal",
            "BD-5R": "Rajshahi anchal",
            "BD-5S": "Rangpur anchal"
        }
    },
    BB: {
        name: "Barbados",
        divisions: {
            "BB-BB": "Barbados"
        }
    },
    BY: {
        name: "Belarus",
        divisions: {
            "BY-BR": "Brestskaya voblasts'",
            "BY-HO": "Homyel'skaya voblasts’",
            "BY-HR": "Hrodnenskaya voblasts'",
            "BY-MA": "Mahilyowskaya voblasts'",
            "BY-MI": "Minskaya voblasts'",
            "BY-VI": "Vitsyebskaya voblasts'"
        }
    },
    BE: {
        name: "Belgium",
        divisions: {
            "BE-BRU": "Bruxelles-Capitale, Region de (fr), Brussels Hoofdstedelijk Gewest (nl)",
            "BE-VLG": "Vlaamse Gewest (nl)",
            "BE-VAN": "Antwerpen (nl)",
            "BE-VLI": "Limburg (nl)",
            "BE-VOV": "Oost-Vlaanderen (nl)",
            "BE-VBR": "Vlaams Brabant (nl)",
            "BE-VWV": "West-Vlaanderen (nl)",
            "BE-WAL": "Wallonne, Region (fr)",
            "BE-WBR": "Brabant Wallon (fr)",
            "BE-WHT": "Hainaut (fr)",
            "BE-WLG": "Li\xe8ge (fr)",
            "BE-WLX": "Luxembourg (fr)",
            "BE-WNA": "Namur (fr)"
        }
    },
    BZ: {
        name: "Belize",
        divisions: {
            "BZ-BZ": "Belize",
            "BZ-CY": "Cayo",
            "BZ-CZL": "Corozal",
            "BZ-OW": "Orange Walk",
            "BZ-SC": "Stann Creek",
            "BZ-TOL": "Toledo"
        }
    },
    BJ: {
        name: "Benin",
        divisions: {
            "BJ-AK": "Atakora",
            "BJ-AQ": "Atlantique",
            "BJ-BO": "Borgou",
            "BJ-MO": "Mono",
            "BJ-OU": "Ou\xe9m\xe9",
            "BJ-ZO": "Zou"
        }
    },
    BM: {
        name: "Bermuda",
        divisions: {
            "BM-BM": "Bermuda"
        }
    },
    BT: {
        name: "Bhutan",
        divisions: {
            "BT-33": "Bumthang",
            "BT-12": "Chhukha",
            "BT-22": "Dagana",
            "BT-GA": "Gasa",
            "BT-13": "Ha",
            "BT-44": "Lhuentse",
            "BT-42": "Monggar",
            "BT-11": "Paro",
            "BT-43": "Pemagatshel",
            "BT-23": "Punakha",
            "BT-45": "Samdrup Jongkha",
            "BT-14": "Samtse",
            "BT-31": "Sarpang",
            "BT-15": "Thimphu",
            "BT-41": "Trashigang",
            "BT-TY": "Trashi Yangtse",
            "BT-32": "Trongsa",
            "BT-21": "Tsirang",
            "BT-24": "Wangdue Phodrang",
            "BT-34": "Zhemgang"
        }
    },
    BO: {
        name: "Bolivia",
        divisions: {
            "BO-C": "Cochabamba",
            "BO-H": "Chuquisaca",
            "BO-B": "El Beni",
            "BO-L": "La Paz",
            "BO-O": "Oruro",
            "BO-N": "Pando",
            "BO-P": "Potosi",
            "BO-S": "Santa Cruz",
            "BO-T": "Tarija"
        }
    },
    BA: {
        name: "Bosnia & Herzegovina",
        divisions: {
            "BA-BIH": "Federacija Bosna i Hercegovina",
            "BA-SRP": "Republika Srpska"
        }
    },
    BW: {
        name: "Botswana",
        divisions: {
            "BW-CE": "Central [Serowe-Palapye]",
            "BW-CH": "Chobe",
            "BW-GH": "Ghanzi",
            "BW-KG": "Kgalagadi",
            "BW-KL": "Kgatleng",
            "BW-KW": "Kweneng",
            "BW-NG": "Ngamiland [North-West]",
            "BW-NE": "North-East",
            "BW-SE": "South-East",
            "BW-SO": "Southern [Ngwaketse]"
        }
    },
    BV: {
        name: "Bouvet Island",
        divisions: {
            "BV-BV": "Bouvet Island"
        }
    },
    BR: {
        name: "Brazil",
        divisions: {
            "BR-DF": "Distrito Federal",
            "BR-AC": "Acre",
            "BR-AL": "Alagoas",
            "BR-AP": "Amap\xe1",
            "BR-AM": "Amazonas",
            "BR-BA": "Bahia",
            "BR-CE": "Cear\xe1",
            "BR-ES": "Esp\xedrito Santo",
            "BR-GO": "Goi\xe1s",
            "BR-MA": "Maranhāo",
            "BR-MT": "Mato Grosso",
            "BR-MS": "Mato Grosso do Sul",
            "BR-MG": "Minas Gerais",
            "BR-PA": "Par\xe1",
            "BR-PB": "Para\xedba",
            "BR-PR": "Paran\xe1",
            "BR-PE": "Pernambuco",
            "BR-PI": "Piau\xed",
            "BR-RJ": "Rio de Janeiro",
            "BR-RN": "Rio Grande do Norte",
            "BR-RS": "Rio Grande do Sul",
            "BR-R0": "Rond\xf4nia",
            "BR-RR": "Roraima",
            "BR-SC": "Santa Catarina",
            "BR-SP": "S\xe3o Paulo",
            "BR-SE": "Sergipe",
            "BR-TO": "Tocantins"
        }
    },
    IO: {
        name: "British Indian Ocean Territory",
        divisions: {
            "IO-IO": "British Indian Ocean Territory"
        }
    },
    BN: {
        name: "Brunei Darussalam",
        divisions: {
            "BN-BE": "Belait",
            "BN-BM": "Brunei-Muara",
            "BN-TE": "Temburong",
            "BN-TU": "Tutong"
        }
    },
    BG: {
        name: "Bulgaria",
        divisions: {
            "BG-02": "Burgas",
            "BG-09": "Haskovo",
            "BG-04": "Loveč",
            "BG-05": "Montana",
            "BG-06": "Plovdiv",
            "BG-07": "Ruse",
            "BG-08": "Sofija",
            "BG-01": "Sofija-Grad",
            "BG-03": "Varna"
        }
    },
    BF: {
        name: "Burkina Faso",
        divisions: {
            "BF-BAL": "Bal\xe9",
            "BF-BAM": "Bam",
            "BF-BAN": "Banwa",
            "BF-BAZ": "Baz\xe8ga",
            "BF-BGR": "Bougouriba",
            "BF-BLG": "Boulgou",
            "BF-BLK": "Boulkiemd\xe9",
            "BF-COM": "Como\xe9",
            "BF-GAN": "Ganzourgou",
            "BF-GNA": "Gnagna",
            "BF-GOU": "Gourma",
            "BF-HOU": "Houet",
            "BF-IOB": "Ioba",
            "BF-KAD": "Kadiogo",
            "BF-KEN": "K\xe9n\xe9dougou",
            "BF-KMD": "Komondjari",
            "BF-KMP": "Kompienga",
            "BF-KOS": "Kossi",
            "BF-KOP": "Koulp\xe9logo",
            "BF-KOT": "Kouritenga",
            "BF-KOW": "Kourw\xe9ogo",
            "BF-LER": "L\xe9raba",
            "BF-LOR": "Loroum",
            "BF-MOU": "Mouhoun",
            "BF-NAO": "Nahouri",
            "BF-NAM": "Namentenga",
            "BF-NAY": "Nayala",
            "BF-NOU": "Noumbiel",
            "BF-OUB": "Oubritenga",
            "BF-OUD": "Oudalan",
            "BF-PAS": "Passor\xe9",
            "BF-PON": "Poni",
            "BF-SNG": "Sangui\xe9",
            "BF-SMT": "Sanmatenga",
            "BF-SEN": "S\xe9no",
            "BF-SIS": "Sissili",
            "BF-SOM": "Soum",
            "BF-SOR": "Sourou",
            "BF-TAP": "Tapoa",
            "BF-TUI": "Tui",
            "BF-YAG": "Yagha",
            "BF-YAT": "Yatenga",
            "BF-ZIR": "Ziro",
            "BF-ZON": "Zondoma",
            "BF-ZOU": "Zoundw\xe9ogo"
        }
    },
    BI: {
        name: "Burundi",
        divisions: {
            "BI-BB": "Bubanza",
            "BI-BJ": "Bujumbura",
            "BI-BR": "Bururi",
            "BI-CA": "Cankuzo",
            "BI-CI": "Cibitoke",
            "BI-GI": "Gitega",
            "BI-KR": "Karuzi",
            "BI-KY": "Kayanza",
            "BI-KI": "Kirundo",
            "BI-MA": "Makamba",
            "BI-MU": "Muramvya",
            "BI-MY": "Muyinga",
            "BI-NG": "Ngozi",
            "BI-RT": "Rutana",
            "BI-RY": "Ruyigi"
        }
    },
    KH: {
        name: "Cambodia",
        divisions: {
            "KH-23": "Krong Kaeb [Krŏng K\xeab]",
            "KH-18": "Krong Preah Sihanouk [Krŏng Preăh Sihanouk]",
            "KH-12": "Phnom Penh [Phnum P\xe9nh]",
            "KH-2": "Baat Dambang [Bătd\xe2mb\xe2ng]",
            "KH-1": "Banteay Mean Chey [B\xe2nt\xe9ay M\xe9anchey]",
            "KH-3": "Kampong Chaam [K\xe2mp\xf3ng Cham]",
            "KH-4": "Kampong Chhnang [K\xe2mp\xf3ng Chhnăng]",
            "KH-5": "Kampong Spueu [K\xe2mp\xf3ng Spœ]",
            "KH-6": "Kampong Thum [K\xe2mp\xf3ng Thum]",
            "KH-7": "Kampot [K\xe2mp\xf4t]",
            "KH-8": "Kandaal [K\xe2ndal]",
            "KH-10": "Kracheh [Kr\xe2ch\xe9h]",
            "KH-11": "Mond01 Kiri [M\xf4nd\xf3l Kiri]",
            "KH-22": "Otdar Mean Chey [Ŏtd\xe2r M\xe9anchey]",
            "KH-15": "Pousaat [Poŭthĭsăt]",
            "KH-13": "Preah Vihear [Preăh Vih\xe9ar]",
            "KH-14": "Prey Veaeng [Prey V\xeang]",
            "KH-16": "Rotanak Kiri [R\xf4t\xe2n\xf4kiri]",
            "KH-17": "Siem Reab [Siĕmr\xe9ab]",
            "KH-19": "Stueng Traeng [Stœng Tr\xeang]",
            "KH-20": "Svaay Rieng [Svay Riĕng]",
            "KH-21": "Taakaev [Tak\xeav]"
        }
    },
    CM: {
        name: "Cameroon",
        divisions: {
            "CM-AD": "Adamaoua",
            "CM-CE": "Centre",
            "CM-ES": "Est",
            "CM-EN": "Far North",
            "CM-LT": "Littoral",
            "CM-NO": "North",
            "CM-NW": "North-West",
            "CM-SU": "South",
            "CM-SW": "South-West",
            "CM-OU": "West"
        }
    },
    CA: {
        name: "Canada",
        divisions: {
            "CA-AB": "Alberta",
            "CA-BC": "British Columbia",
            "CA-MB": "Manitoba",
            "CA-NB": "New Brunswick",
            "CA-NL": "Newfoundland and Labrador",
            "CA-NS": "Nova Scotia",
            "CA-ON": "Ontario",
            "CA-PE": "Prince Edward Island",
            "CA-QC": "Quebec",
            "CA-SK": "Saskatchewan",
            "CA-NT": "Northwest Territories",
            "CA-NU": "Nunavut",
            "CA-YT": "Yukon Territory"
        }
    },
    CV: {
        name: "Cape Verde",
        divisions: {
            "CV-B": "Ilhas de Barlavento",
            "CV-BV": "Boa Vista",
            "CV-PA": "Paul",
            "CV-PN": "Porto Novo",
            "CV-RG": "Ribeira Grande",
            "CV-SL": "Sal",
            "CV-SN": "Sāo Nicolau",
            "CV-SV": "Sāo Vicente",
            "CV-S": "Ilhas de Sotavento",
            "CV-BR": "Brava",
            "CV-FO": "Fogo",
            "CV-MA": "Maio",
            "CV-PR": "Praia",
            "CV-CA": "Santa Catarina",
            "CV-CR": "Santa Cruz",
            "CV-TA": "Tarrafal"
        }
    },
    KY: {
        name: "Cayman Islands",
        divisions: {
            "KY-KY": "Cayman Islands"
        }
    },
    CF: {
        name: "Central African Republic",
        divisions: {
            "CF-BGF": "Bangui",
            "CF-BB": "Bamingui-Bangoran",
            "CF-BK": "Basse-Kotto",
            "CF-HK": "Haute-Kotto",
            "CF-HM": "Haut-Mbomou",
            "CF-KG": "K\xe9mo",
            "CF-LB": "Lobaye",
            "CF-HS": "Mamb\xe9r\xe9-Kad\xe9\xef",
            "CF-MB": "Mbomou",
            "CF-KB": "Nana-Gr\xe9bizi",
            "CF-NM": "Nana-Mamb\xe9r\xe9",
            "CF-MP": "Ombella-Mpoko",
            "CF-UK": "Ouaka",
            "CF-AC": "Ouham",
            "CF-OP": "Ouham-Pend\xe9",
            "CF-SE": "Sangha-Mba\xe9r\xe9",
            "CF-VK": "Vakaga"
        }
    },
    TD: {
        name: "Chad",
        divisions: {
            "TD-BA": "Batha",
            "TD-BI": "Biltine",
            "TD-BET": "Borkou-Ennedi-Tibesti",
            "TD-CB": "Chari-Baguirmi",
            "TD-GR": "Gu\xe9ra",
            "TD-KA": "Kanem",
            "TD-LC": "Lac",
            "TD-LO": "Logone-Occidental",
            "TD-LR": "Logone-Oriental",
            "TD-MK": "Mayo-K\xe9bbi",
            "TD-MC": "Moyen-Chari",
            "TD-OD": "Ouadda\xef",
            "TD-SA": "Salamat",
            "TD-TA": "Tandjil\xe9"
        }
    },
    CL: {
        name: "Chile",
        divisions: {
            "CL-AI": "Ais\xe9n del General Carlos Ib\xe1\xf1iez del Campo",
            "CL-AN": "Antofagasta",
            "CL-AR": "Araucan\xeda",
            "CL-AT": "Atacama",
            "CL-BI": "B\xedo-B\xedo",
            "CL-CO": "Coquimbo",
            "CL-LI": "Libertador General Bernardo O'Higgins",
            "CL-LL": "Los Lagos",
            "CL-MA": "Magallanes",
            "CL-ML": "Maule",
            "CL-RM": "Reg\xedon Metropolitana de Santiago",
            "CL-TA": "Tarapac\xe1",
            "CL-VS": "Valparaiso"
        }
    },
    CN: {
        name: "China",
        divisions: {
            "CN-11": "Beijing",
            "CN-50": "Chongqing",
            "CN-31": "Shanghai",
            "CN-12": "Tianjin",
            "CN-34": "Anhui",
            "CN-35": "Fujian",
            "CN-62": "Gansu",
            "CN-44": "Guangdong",
            "CN-52": "Guizhou",
            "CN-46": "Hainan",
            "CN-13": "Hebei",
            "CN-23": "Heilongjiang",
            "CN-41": "Henan",
            "CN-42": "Hubei",
            "CN-43": "Hunan",
            "CN-32": "Jiangsu",
            "CN-36": "Jiangxi",
            "CN-22": "Jilin",
            "CN-21": "Liaoning",
            "CN-63": "Qinghai",
            "CN-61": "Shaanxi",
            "CN-37": "Shandong",
            "CN-14": "Shanxi",
            "CN-51": "Sichuan",
            "CN-71": "Taiwan",
            "CN-53": "Yunnan",
            "CN-33": "Zhejiang",
            "CN-45": "Guangxi",
            "CN-15": "Nei Monggol",
            "CN-64": "Ningxia",
            "CN-65": "Xinjiang",
            "CN-54": "Xizang",
            "CN-91": "Hong Kong"
        }
    },
    CX: {
        name: "Christmas Island",
        divisions: {
            "CX-CX": "Christmas Island"
        }
    },
    CC: {
        name: "Cocos (Keeling) Islands",
        divisions: {
            "CC-CC": "Cocos (Keeling) Islands"
        }
    },
    CO: {
        name: "Colombia",
        divisions: {
            "CO-DC": "Distrito Capital de Santa Fe de Bogota",
            "CO-AMA": "Amazonas",
            "CO-ANT": "Antioguia",
            "CO-ARA": "Arauca",
            "CO-ATL": "Atl\xe1ntico",
            "CO-BOL": "Bol\xedvar",
            "CO-BOY": "Boyac\xe1",
            "CO-CAL": "Caldas",
            "CO-CAQ": "Caquet\xe1",
            "CO-CAS": "Casanare",
            "CO-CAU": "Cauca",
            "CO-CES": "Cesar",
            "CO-COR": "C\xf3rdoba",
            "CO-CUN": "Cundinamarca",
            "CO-CHO": "Choc\xf3",
            "CO-GUA": "Guain\xeda",
            "CO-GUV": "Guaviare",
            "CO-HUI": "Huila",
            "CO-LAG": "La Guajira",
            "CO-MAG": "Magdalena",
            "CO-MET": "Meta",
            "CO-NAR": "Nari\xf1o",
            "CO-NSA": "Norte de Santander",
            "CO-PUT": "Putumayo",
            "CO-QUI": "Quind\xedo",
            "CO-RIS": "Risaralda",
            "CO-SAP": "San Andr\xe9s, Providencia y Santa Catalina",
            "CO-SAN": "Santander",
            "CO-SUC": "Sucre",
            "CO-TOL": "Tolima",
            "CO-VAC": "Valle del Cauca",
            "CO-VAU": "Vaup\xe9s",
            "CO-VID": "Vichada"
        }
    },
    KM: {
        name: "Comoros",
        divisions: {
            "KM-A": "Anjouan (Ndzouani)",
            "KM-G": "Grande Comore (Ngazidja)",
            "KM-M": "Moh\xe9li (Moili)"
        }
    },
    CG: {
        name: "Congo",
        divisions: {
            "CG-BZV": "Brazzaville",
            "CG-11": "Bouenza",
            "CG-8": "Cuvette",
            "CG-15": "Cuvette-Ouest",
            "CG-5": "Kouilou",
            "CG-2": "L\xe9koumou",
            "CG-7": "Likouala",
            "CG-9": "Niari",
            "CG-14": "Plateaux",
            "CG-12": "Pool",
            "CG-13": "Sangha"
        }
    },
    CD: {
        name: "Zaire",
        divisions: {
            "CD-KN": "Kinshasa",
            "CD-BN": "Bandundu",
            "CD-BC": "Bas-Congo",
            "CD-EQ": "\xc9quateur",
            "CD-HC": "Haut-Congo",
            "CD-KW": "Kasai-Occidental",
            "CD-KE": "Kasai-Oriental",
            "CD-KA": "Katanga",
            "CD-MA": "Maniema",
            "CD-NK": "Nord-Kivu",
            "CD-SK": "Sud-Kivu"
        }
    },
    CK: {
        name: "Cook Islands",
        divisions: {
            "CK-CK": "Cook Islands"
        }
    },
    CR: {
        name: "Costa Rica",
        divisions: {
            "CR-A": "Alajuela",
            "CR-C": "Cartago",
            "CR-G": "Guanacaste",
            "CR-H": "Heredia",
            "CR-L": "Lim\xf3n",
            "CR-P": "Puntarenas",
            "CR-SJ": "San Jos\xe9"
        }
    },
    CI: {
        name: "Cote D'ivoire (Ivory Coast)",
        divisions: {
            "CI-06": "18 Montagnes (R\xe9gion des)",
            "CI-16": "Agn\xe9bi (R\xe9gion de l')",
            "CI-09": "Bas-Sassandra (R\xe9gion du)",
            "CI-10": "Dengu\xe9l\xe9 (R\xe9gion du)",
            "CI-02": "Haut-Sassandra (R\xe9gion du)",
            "CI-07": "Lacs (R\xe9gion des)",
            "CI-01": "Lagunes (R\xe9gion des)",
            "CI-12": "Marahou\xe9 (R\xe9gion de la)",
            "CI-05": "Moyen-Como\xe9 (R\xe9gion du)",
            "CI-11": "Nzi-Como\xe9 (R\xe9gion)",
            "CI-03": "Savanes (R\xe9gion des)",
            "CI-15": "Sud-Bandama (R\xe9gion du)",
            "CI-13": "Sud-Como\xe9 (R\xe9gion du)",
            "CI-04": "Vall\xe9e du Bandama (R\xe9gion de la)",
            "CI-14": "Worodougou (R\xe9gion du)",
            "CI-08": "Zanzan (R\xe9gion du)"
        }
    },
    HR: {
        name: "Croatia (Hrvatska)",
        divisions: {
            "HR-07": "Bjelovarsko-bilogorska županija",
            "HR-12": "Brodsko-posavska županija",
            "HR-19": "Dubrovačko-neretvanska županija",
            "HR-18": "Istarska županija",
            "HR-04": "Karlovačka županija",
            "HR-06": "Koprivničkco-križevačka županija",
            "HR-02": "Krapinsko-zagorska županija",
            "HR-09": "Ličko-senjska županija",
            "HR-20": "Medjimurska županija",
            "HR-14": "Osječko-baranjska županija",
            "HR-11": "Požeško-slavonska županija",
            "HR-08": "Primorsko-goranska županija",
            "HR-03": "Sisaško-moslavačka županija",
            "HR-17": "Splitsko-dalmatinska županija",
            "HR-15": "Šibensko-kninska županija",
            "HR-05": "Varaždinska županija",
            "HR-10": "Virovitičko-podravska županija",
            "HR-16": "Vukovarsko-srijemska županija",
            "HR-13": "Zadarska županija",
            "HR-01": "Zagrebačka županija"
        }
    },
    CU: {
        name: "Cuba",
        divisions: {
            "CU-09": "Camag\xfcey",
            "CU-03": "Ciudad de La Habana",
            "CU-12": "Granma",
            "CU-14": "Guant\xe1namo",
            "CU-11": "Holgu\xedn",
            "CU-02": "La Habana",
            "CU-10": "Las Tunas",
            "CU-04": "Matanzas",
            "CU-01": "Pinar del R\xedo",
            "CU-07": "Sancti Sp\xedritus",
            "CU-13": "Santiago de Cuba",
            "CU-05": "Villa Clara",
            "CU-99": "Isla de la Juventud"
        }
    },
    CY: {
        name: "Cyprus",
        divisions: {
            "CY-04": "Ammochostos (Mağusa)",
            "CY-06": "Keryneia (Girne)",
            "CY-03": "Larnaka",
            "CY-01": "Lefkosia (Lefkoşa)",
            "CY-02": "Lemesos (Leymosun)",
            "CY-05": "Pafos (Baf)"
        }
    },
    CZ: {
        name: "Czech Republic",
        divisions: {
            "CZ-PRG": "Praha",
            "CZ-CJC": "Jihočesk\xfd kraj",
            "CZ-CJM": "Jihomoravsk\xfd kraj",
            "CZ-CSC": "Severočesk\xfd kraj",
            "CZ-CSM": "Severomoravsk\xfd kraj",
            "CZ-CST": "Středočesk\xfd kraj",
            "CZ-CVC": "V\xfdchodočesk\xfd kraj",
            "CZ-CZC": "Z\xe1padočesk\xfd kraj"
        }
    },
    DK: {
        name: "Denmark",
        divisions: {
            "DK-147": "Frederiksberg",
            "DK-101": "Kǿbenhavn",
            "DK-040": "Bornholm",
            "DK-020": "Frederiksborg",
            "DK-042": "Fyn",
            "DK-015": "Kǿbenhavn",
            "DK-080": "Nordjylland",
            "DK-055": "Ribe",
            "DK-065": "Ringkǿbing",
            "DK-025": "Roskilde",
            "DK-035": "Storstrǿm",
            "DK-050": "Sǿnderjylland",
            "DK-060": "Vejle",
            "DK-030": "Vestsj\xe6lland",
            "DK-076": "Viborg",
            "DK-070": "\xc5rhus"
        }
    },
    DJ: {
        name: "Djibouti",
        divisions: {
            "DJ-AS": "Ali Sabieh",
            "DJ-DI": "Dikhil",
            "DJ-DJ": "Djibouti",
            "DJ-OB": "Obock",
            "DJ-TA": "Tadjoura"
        }
    },
    DM: {
        name: "Dominica",
        divisions: {
            "DM-DM": "Dominica"
        }
    },
    DO: {
        name: "Dominican Republic",
        divisions: {
            "DO-DN": "Distrito National (Santo Domingo)",
            "DO-AZ": "Azua",
            "DO-BR": "Bahoruco",
            "DO-BH": "Barahona",
            "DO-DA": "Dajab\xf3n",
            "DO-DU": "Duarte",
            "DO-SE": "El Seibo",
            "DO-EP": "La Estrelleta [El\xedas Pi\xf1a]",
            "DO-HM": "Hato Mayor",
            "DO-IN": "Independencia",
            "DO-AL": "La Altagracia",
            "DO-RO": "La Romana",
            "DO-VE": "La Vega",
            "DO-MT": "Mar\xeda Trinidad S\xe1nchez",
            "DO-MN": "Monse\xf1or Nouel",
            "DO-MC": "Monte Cristi",
            "DO-MP": "Monte Plata",
            "DO-PN": "Pedernales",
            "DO-PR": "Peravia",
            "DO-PP": "Puerto Plata",
            "DO-SC": "Salcedo",
            "DO-SM": "Saman\xe1",
            "DO-SZ": "Sanchez Ram\xedrez",
            "DO-CR": "San Crist\xf3bal",
            "DO-JU": "San Juan",
            "DO-PM": "San Pedro de Macor\xeds",
            "DO-ST": "Santiago",
            "DO-SR": "Santiago Rodr\xedguez",
            "DO-VA": "Valverde"
        }
    },
    TP: {
        name: "East Timor",
        divisions: {
            "TP-TP": "East Timor"
        }
    },
    EC: {
        name: "Ecuador",
        divisions: {
            "EC-A": "Azuay",
            "EC-B": "Bol\xedvar",
            "EC-F": "Ca\xf1ar",
            "EC-C": "Carchi",
            "EC-X": "Cotopaxi",
            "EC-H": "Chimborazo",
            "EC-O": "El Oro",
            "EC-E": "Esmeraldas",
            "EC-W": "Gal\xe1pagos",
            "EC-G": "Guayas",
            "EC-I": "Imbabura",
            "EC-L": "Loja",
            "EC-R": "Los R\xedos",
            "EC-M": "Manab\xed",
            "EC-S": "Morona-Santiago",
            "EC-N": "Napo",
            "EC-Y": "Pastaza",
            "EC-P": "Pichincha",
            "EC-U": "Sucumb\xedos",
            "EC-T": "Tungurahua",
            "EC-Z": "Zarnora-Chinchipe"
        }
    },
    EG: {
        name: "Egypt",
        divisions: {
            "EG-DK": "Ad Daqahlīyah",
            "EG-BA": "Al Baḩr al Aḩmar",
            "EG-BH": "Al Buḩayrah",
            "EG-FYM": "Al Fayyūm",
            "EG-GH": "Al Gharbīyah",
            "EG-ALX": "Al Iskandarīyah",
            "EG-IS": "Al Ismā‘īlīyah",
            "EG-GZ": "Al Jīzah",
            "EG-MNF": "Al Minūfīyah",
            "EG-MN": "Al Minyā",
            "EG-C": "Al Qāhirah",
            "EG-KB": "Al Qalyūbīyah",
            "EG-WAD": "Al Wādī al Jadīd",
            "EG-SHR": "Ash Sharqīyah",
            "EG-SUZ": "As Suways",
            "EG-ASN": "Aswān",
            "EG-AST": "Asyūţ",
            "EG-BNS": "Banī Suwayf",
            "EG-PTS": "Būr Sa‘īd",
            "EG-DT": "Dumyāţ",
            "EG-JS": "Janūb Sīnā'",
            "EG-KFS": "Kafr ash Shaykh",
            "EG-MT": "Maţrūḩ",
            "EG-KN": "Qinā",
            "EG-SIN": "Shamāl Sīnā'",
            "EG-SHG": "Sūhāj"
        }
    },
    SV: {
        name: "El Salvador",
        divisions: {
            "SV-AH": "Ahuachap\xe1n",
            "SV-CA": "Caba\xf1as",
            "SV-CU": "Cuscatl\xe1n",
            "SV-CH": "Chalatenango",
            "SV-LI": "La Libertad",
            "SV-PA": "La Paz",
            "SV-UN": "La Uni\xf3n",
            "SV-MO": "Moraz\xe1n",
            "SV-SM": "San Miguel",
            "SV-SS": "San Salvador",
            "SV-SA": "Santa Ana",
            "SV-SV": "San Vicente",
            "SV-SO": "Sonsonate",
            "SV-SU": "Usulut\xe1n"
        }
    },
    GQ: {
        name: "Equatorial Guinea",
        divisions: {
            "GQ-C": "Regi\xf3n Continental",
            "GQ-CS": "Centro Sur",
            "GQ-KN": "Kie-Ntem",
            "GQ-LI": "Litoral",
            "GQ-WN": "Wele-Nz\xe1s",
            "GQ-I": "Regi\xf3n Insular",
            "GQ-AN": "Annob\xf3n",
            "GQ-BN": "Bioko Norte",
            "GQ-BS": "Bioko Sur"
        }
    },
    ER: {
        name: "Eritrea",
        divisions: {
            "ER-AG": "Akele Guzai [Akal\xe4 Guzay]",
            "ER-AS": "Asmara [Asm\xe4ra]",
            "ER-BA": "Barka",
            "ER-DE": "Denkalia [D\xe4nkali]",
            "ER-GS": "Gash-Setit [Gaš enna S\xe4tit]",
            "ER-HA": "Hamasien [Hamas\xe9n]",
            "ER-SA": "Sahel",
            "ER-SM": "Semhar [S\xe4mhar]",
            "ER-SN": "Senhit [S\xe4nhet]",
            "ER-SR": "Seraye [S\xe4ray\xe9]"
        }
    },
    EE: {
        name: "Estonia",
        divisions: {
            "EE-37": "Harjumaa",
            "EE-39": "Hiiumaa",
            "EE-44": "Ida-Virumaa",
            "EE-49": "Jōgevamaa",
            "EE-51": "J\xe4rvamaa",
            "EE-57": "L\xe4\xe4nemaa",
            "EE-59": "L\xe4\xe4ne-Virumaa",
            "EE-65": "Pōlvamaa",
            "EE-67": "P\xe4rnumaa",
            "EE-70": "Raplamaa",
            "EE-74": "Saaremaa",
            "EE-78": "Tartumaa",
            "EE-82": "Valgamaa",
            "EE-84": "Viljandimaa",
            "EE-86": "Vōrumaa"
        }
    },
    ET: {
        name: "Ethiopia",
        divisions: {
            "ET-AA": "Addis Ababa [Addis Abeba]",
            "ET-AF": "Afar",
            "ET-AM": "Amara [Amhara]",
            "ET-BE": "Benshangul-Gumaz [B\xe9nishangul]",
            "ET-GA": "Gambela Peoples [Gamb\xe9la]",
            "ET-HA": "Harari People [Harer]",
            "ET-OR": "Oromia [Oromo]",
            "ET-SO": "Somali",
            "ET-SN": "Southern Nations, Nationalities and Peoples",
            "ET-TI": "Tigrai [Tegr\xe9]"
        }
    },
    FK: {
        name: "Falkland Islands (Malvinas)",
        divisions: {
            "FK-FK": "Falkland Islands (Malvinas)"
        }
    },
    FO: {
        name: "Faroe Islands",
        divisions: {
            "FO-FO": "Faroe Islands"
        }
    },
    FJ: {
        name: "Fiji",
        divisions: {
            "FJ-C": "Central",
            "FJ-E": "Eastern",
            "FJ-N": "Northern",
            "FJ-W": "Western",
            "FJ-R": "Rotuma"
        }
    },
    FI: {
        name: "Finland",
        divisions: {
            "FI-AL": "Ahvenanmaan l\xe4\xe4ni",
            "FI-ES": "Etel\xe4-Suomen l\xe4\xe4ni",
            "FI-IS": "It\xe4-Suomen l\xe4\xe4ni",
            "FI-LL": "Lapin l\xe4\xe4ni",
            "FI-LS": "L\xe4nsi-Suomen l\xe4\xe4ni",
            "FI-OL": "Oulun l\xe4\xe4ni"
        }
    },
    FR: {
        name: "France",
        divisions: {
            "FR-A": "Alsace",
            "FR-67": "Bas-Rhin",
            "FR-68": "Haut-Rhin",
            "FR-B": "Aquitaine",
            "FR-79": "Deux-S\xe8vres",
            "FR-24": "Dordogne",
            "FR-33": "Gironde",
            "FR-40": "Landes",
            "FR-47": "Lot-et-Garonne",
            "FR-64": "Pyr\xe9n\xe9es-Atlantiques",
            "FR-C": "Auvergne",
            "FR-03": "Allier",
            "FR-15": "Cantal",
            "FR-43": "Haute-Loire",
            "FR-63": "Puy-de-D\xf4me",
            "FR-P": "Basse-Normandie",
            "FR-14": "Calvados",
            "FR-50": "Manche",
            "FR-61": "Orne",
            "FR-D": "Bourgogne",
            "FR-21": "C\xf4te-d'Or",
            "FR-58": "Ni\xe8vre",
            "FR-71": "Sa\xf4ne-et-Loire",
            "FR-89": "Yonne",
            "FR-E": "Bretagne",
            "FR-22": "Cotes-d'Armor",
            "FR-29": "Finist\xe8re",
            "FR-35": "Ille-et-Vilaine",
            "FR-56": "Morbihan",
            "FR-F": "Centre",
            "FR-18": "Cher",
            "FR-28": "Eure-et-Loir",
            "FR-36": "Indre",
            "FR-37": "Indre-et-Loire",
            "FR-41": "Loir-et-Cher",
            "FR-45": "Loiret",
            "FR-G": "Champagne-Ardenne",
            "FR-08": "Ardennes",
            "FR-10": "Aube",
            "FR-52": "Haute-Marne",
            "FR-51": "Marne",
            "FR-H": "Corse",
            "FR-2A": "Corse-du-Sud",
            "FR-2B": "Haute-Corse",
            "FR-I": "Franche-Comt\xe9",
            "FR-25": "Doubs",
            "FR-70": "Haute-Sa\xf4ne",
            "FR-39": "Jura",
            "FR-90": "Territoire de Belfort",
            "FR-Q": "Haute-Normandie",
            "FR-27": "Eure",
            "FR-76": "Seine-Maritime",
            "FR-J": "\xcele-de-France",
            "FR-91": "Essonne",
            "FR-92": "Hauts-de-Seine",
            "FR-75": "Paris",
            "FR-77": "Seine-et-Marne",
            "FR-93": "Seine-Saint-Denis",
            "FR-94": "Val-de-Marne",
            "FR-95": "Val-d'Oise",
            "FR-78": "Yvelines",
            "FR-K": "Languedoc-Roussillon",
            "FR-11": "Aude",
            "FR-30": "Gard",
            "FR-34": "H\xe9rault",
            "FR-48": "Loz\xe8re",
            "FR-66": "Pyr\xe9n\xe9es-Orientales",
            "FR-L": "Limousin",
            "FR-19": "Corr\xe8ze",
            "FR-23": "Creuse",
            "FR-87": "Haute-Vienne",
            "FR-M": "Lorraine",
            "FR-54": "Meurthe-et-Moselle",
            "FR-55": "Meuse",
            "FR-57": "Moselle",
            "FR-88": "Vosges",
            "FR-N": "Midi-Pyr\xe9n\xe9es",
            "FR-09": "Ari\xe8ge",
            "FR-12": "Aveyron",
            "FR-32": "Gers",
            "FR-31": "Haute-Garonne",
            "FR-65": "Hautes-Pyr\xe9n\xe9es",
            "FR-46": "Lot",
            "FR-81": "Tarn",
            "FR-82": "Tarn-et-Garonne",
            "FR-O": "Nord-Pas-de-Calais",
            "FR-59": "Nord",
            "FR-62": "Pas-de-Calais",
            "FR-R": "Pays de la Loire",
            "FR-44": "Loire-Atlantique",
            "FR-49": "Maine-et-Loire",
            "FR-53": "Mayenne",
            "FR-72": "Sarthe",
            "FR-85": "Vend\xe9e",
            "FR-S": "Picardie",
            "FR-02": "Aisne",
            "FR-60": "Oise",
            "FR-80": "Somme",
            "FR-T": "Poitou-Charentes",
            "FR-16": "Charente",
            "FR-17": "Charente-Maritime",
            "FR-86": "Vienne",
            "FR-U": "Provence-Alpes-C\xf4te d'Azur",
            "FR-04": "Alpes-de-Haute-Provence",
            "FR-06": "Alpes-Maritimes",
            "FR-13": "Bauches-du-Rh\xf4ne",
            "FR-05": "Hautes-Alpes",
            "FR-83": "Var",
            "FR-84": "Vaucluse",
            "FR-V": "Rh\xf4ne-Alpes",
            "FR-01": "Ain",
            "FR-07": "Ard\xe8che",
            "FR-26": "Dr\xf4me",
            "FR-74": "Haute-Savoie",
            "FR-38": "Is\xe8re",
            "FR-42": "Loire",
            "FR-69": "Rh\xf4ne",
            "FR-73": "Savoie",
            "FR-GP": "Guadeloupe",
            "FR-GF": "Guyane (francaise)",
            "FR-MQ": "Martinique",
            "FR-RE": "R\xe9union",
            "FR-YT": "Mayotte",
            "FR-PM": "Saint-Pierre-et-Miquelon",
            "FR-NC": "Nouvelle-Cal\xe9donie",
            "FR-PF": "Polyn\xe9sie fran\xe7aise",
            "FR-TF": "Terres Australes",
            "FR-WF": "Wallis et Futuna"
        }
    },
    GF: {
        name: "French Guiana",
        divisions: {
            "GF-GF": "French Guiana"
        }
    },
    PF: {
        name: "French Polynesia",
        divisions: {
            "PF-PF": "French Polynesia"
        }
    },
    TF: {
        name: "French Southern Territories",
        divisions: {
            "TF-TF": "French Southern Territories"
        }
    },
    GA: {
        name: "Gabon",
        divisions: {
            "GA-1": "Estuaire",
            "GA-2": "Haut-Ogoou\xe9",
            "GA-3": "Moyen-Ogoou\xe9",
            "GA-4": "Ngouni\xe9",
            "GA-5": "Nyanga",
            "GA-6": "Ogoou\xe9-Ivindo",
            "GA-7": "Ogoou\xe9-Lolo",
            "GA-8": "Ogoou\xe9-Maritime",
            "GA-9": "Woleu-Ntem"
        }
    },
    GM: {
        name: "Gambia",
        divisions: {
            "GM-B": "Banjul",
            "GM-L": "Lower River",
            "GM-M": "MacCarthy Island",
            "GM-N": "North Bank",
            "GM-U": "Upper River",
            "GM-W": "Western"
        }
    },
    GE: {
        name: "Georgia",
        divisions: {
            "GE-AB": "Ap'khazet'is Avtonomiuri Respublika [Abkhazia]",
            "GE-AJ": "Acharis Avtonomiuri Respublika [Ajaria]",
            "GE-BUS": "Bat'umi",
            "GE-CHI": "Chiat'ura",
            "GE-GAG": "Gagra",
            "GE-GOR": "Gori",
            "GE-KUT": "K'ut'aisi",
            "GE-PTI": "P'ot'i",
            "GE-RUS": "Rust'avi",
            "GE-SUI": "Sokhumi",
            "GE-TBS": "T'bilisi",
            "GE-TQI": "Tqibuli",
            "GE-TQV": "Tqvarch'eli",
            "GE-TSQ": "Tsqalmbo",
            "GE-ZUG": "Zugdidi",
            "GE-01": "Abashis Raioni",
            "GE-02": "Adigenis Raioni",
            "GE-03": "Akhalgoris Raioni",
            "GE-04": "Akhalk'alak'is Raioni",
            "GE-05": "Akhalts'ikhis Raioni",
            "GE-06": "Akhmetis Raioni",
            "GE-07": "Ambrolauris Raioni",
            "GE-08": "Aspindzis Raioni",
            "GE-09": "Baghdat'is Raioni",
            "GE-10": "Bolnisis Raioni",
            "GE-11": "Borjomis Raioni",
            "GE-12": "Ch'khorotsqus Raioni",
            "GE-13": "Ch'okhatauris Raioni",
            "GE-14": "Dedop'listsqaros Raioni",
            "GE-15": "Dmanisis Raioni",
            "GE-16": "Dushet'is Raioni",
            "GE-17": "Galis Raioni",
            "GE-18": "Gardabnis Raioni",
            "GE-19": "Goris Raioni",
            "GE-20": "Gudaut'is Raioni",
            "GE-21": "Gulrip'shis Raioni",
            "GE-22": "Gurjaanis Raioni",
            "GE-23": "Javis Raioni",
            "GE-24": "K'arelis Raioni",
            "GE-25": "Kaspis Raioni",
            "GE-26": "K'edis Raioni",
            "GE-27": "Kharagaulis Raioni",
            "GE-28": "Khashuris Raioni",
            "GE-29": "Khelvach'auris Raioni",
            "GE-30": "Khobis Raioni",
            "GE-31": "Khonis Raioni",
            "GE-32": "Khulos Raioni",
            "GE-33": "K'obuletis Raioni",
            "GE-34": "Lagodekhis Raioni",
            "GE-35": "Lanch'khut'is Raioni",
            "GE-36": "Lentekhis Raioni",
            "GE-37": "Marneulis Raioni",
            "GE-38": "Martvilis Raioni",
            "GE-39": "Mestiis Raioni",
            "GE-40": "Mts'khet'is Raioni",
            "GE-41": "Ninotsmindis Raioni",
            "GE-42": "Och'amch'iris Raioni",
            "GE-43": "Onis Raioni",
            "GE-44": "Ozurget'is Raioni",
            "GE-45": "Qazbegis Raioni",
            "GE-46": "Qvarlis Raioni",
            "GE-47": "Sach'kheris Raioni",
            "GE-48": "Sagarejos Raioni",
            "GE-49": "Samtrediis Raioni",
            "GE-50": "Senakis Raioni",
            "GE-51": "Shuakhevis Raioni",
            "GE-52": "Sighnaghis Raioni",
            "GE-53": "Sokhumis Raioni",
            "GE-54": "T'elavis Raioni",
            "GE-55": "T'erjolis Raioni",
            "GE-56": "T'et'ritsqaros Raioni",
            "GE-57": "T'ianet'is Raioni",
            "GE-58": "Ts'ageris Raioni",
            "GE-59": "Tsalenjikhis Raioni",
            "GE-60": "Tsalkis Raioni",
            "GE-61": "Vanis Raioni",
            "GE-62": "Zestap'onis Raioni",
            "GE-63": "Zugdidis Raioni"
        }
    },
    DE: {
        name: "Germany",
        divisions: {
            "DE-BW": "Baden-Wuerttemberg",
            "DE-BY": "Bayern",
            "DE-BE": "Berlin",
            "DE-BB": "Brandenburg",
            "DE-HB": "Bremen",
            "DE-HH": "Hamburg",
            "DE-HE": "Hessen",
            "DE-MV": "Mecklenburg-Vorpommern",
            "DE-NI": "Niedersachsen",
            "DE-NW": "Nordrhein-Westfalen",
            "DE-RP": "Rheinland-Pfalz",
            "DE-SL": "Saarland",
            "DE-SN": "Sachsen",
            "DE-ST": "Sachsen-Anhalt",
            "DE-SH": "Schleswig-Holstein",
            "DE-TH": "Th\xfcringen"
        }
    },
    GH: {
        name: "Ghana",
        divisions: {
            "GH-AH": "Ashanti",
            "GH-BA": "Brong-Ahafo",
            "GH-CP": "Central",
            "GH-EP": "Eastern",
            "GH-AA": "Greater Accra",
            "GH-NP": "Northern",
            "GH-UE": "Upper East",
            "GH-UW": "Upper West",
            "GH-TV": "Volta",
            "GH-WP": "Western"
        }
    },
    GI: {
        name: "Gibraltar",
        divisions: {
            "GI-GI": "Gibraltar"
        }
    },
    GB: {
        name: "United Kingdom",
        divisions: {
            "GB-CHA": "Channel Islands",
            "GB-GSY": "Guernsey [Guernesey]",
            "GB-JSY": "Jersey",
            "GB-ENG": "England",
            "GB-BDG": "Barking and Dagenham",
            "GB-BNE": "Barnet",
            "GB-BNS": "Barnsley",
            "GB-BAS": "Bath and North East Somerset",
            "GB-BDF": "Bedfordshire",
            "GB-BEX": "Bexley",
            "GB-BIR": "Birmingham (City of)",
            "GB-BBD": "Blackburn with Darwen",
            "GB-BPL": "Blackpool",
            "GB-BOL": "Bolton",
            "GB-BMH": "Bournemouth",
            "GB-BRC": "Bracknell Forest",
            "GB-BRD": "Bradford (City of)",
            "GB-BEN": "Brent",
            "GB-BNH": "Brighton and Hove",
            "GB-BST": "Bristol, City of",
            "GB-BRY": "Bromley",
            "GB-BKM": "Buckinghamshire",
            "GB-BUR": "Bury",
            "GB-CLD": "Calderdale",
            "GB-CAM": "Cambridgeshire",
            "GB-CMD": "Camden",
            "GB-CHS": "Cheshire",
            "GB-CON": "Cornwall",
            "GB-COV": "Coventry (City of)",
            "GB-CRY": "Croydon",
            "GB-CMA": "Cumbria",
            "GB-DAL": "Darlington",
            "GB-DER": "Derby (City of)",
            "GB-DBY": "Derbyshire",
            "GB-DEV": "Devon",
            "GB-DNC": "Doncaster",
            "GB-DOR": "Dorset",
            "GB-DUD": "Dudley",
            "GB-DUR": "Durharn",
            "GB-EAL": "Ealing",
            "GB-ERY": "East Riding of Yorkshire",
            "GB-ESX": "East Sussex",
            "GB-ENF": "Enfield",
            "GB-ESS": "Essex",
            "GB-GAT": "Gateshead",
            "GB-GLS": "Gloucestershire",
            "GB-GRE": "Greenwich",
            "GB-HCK": "Hackney",
            "GB-HAL": "Haiton",
            "GB-HMF": "Hammersmith and Fulham",
            "GB-HAM": "Hampshire",
            "GB-HRY": "Haringey",
            "GB-HRW": "Harrow",
            "GB-HPL": "Hartlepool",
            "GB-HAV": "Havering",
            "GB-HEF": "Herefordshire, County of",
            "GB-HRT": "Hertfordshire",
            "GB-HIL": "Hillingdon",
            "GB-HNS": "Hounslow",
            "GB-IOW": "Isle of Wight",
            "GB-IOS": "Isles of Scilly",
            "GB-ISL": "Islington",
            "GB-KEC": "Kensington and Chelsea",
            "GB-KEN": "Kent",
            "GB-KHL": "Kingston upon Hull, City of",
            "GB-KTT": "Kingston upon Thames",
            "GB-KIR": "Kirklees",
            "GB-KWL": "Knowsley",
            "GB-LBH": "Lambeth",
            "GB-LAN": "Lancashire",
            "GB-LDS": "Leeds (City of)",
            "GB-LCE": "Leitester (City of)",
            "GB-LEC": "Leicestershire",
            "GB-LEW": "Lewisham",
            "GB-LIN": "Lincolnshire",
            "GB-LIV": "Liverpool (City of)",
            "GB-LND": "London",
            "GB-LUT": "Luton",
            "GB-MAN": "Manchester (City of)",
            "GB-MDW": "Medway",
            "GB-MRT": "Merton",
            "GB-MDB": "Middlesbrough",
            "GB-MIK": "Milton Keynes",
            "GB-NET": "Newcastle upon Tyne (City of)",
            "GB-NWM": "Newham",
            "GB-NFK": "Norfolk",
            "GB-NEL": "North East Lincolnshire",
            "GB-NLN": "North Lincolnshire",
            "GB-NSM": "North Somerset",
            "GB-NTY": "North Tyneside",
            "GB-NYK": "North Yorkshire",
            "GB-NTH": "Northamptonshire",
            "GB-NBL": "Northumberland",
            "GB-NGM": "Nottingham (City of)",
            "GB-NTT": "Nottinghamshire",
            "GB-OLD": "Oldham",
            "GB-OXF": "Oxfordshire",
            "GB-PTE": "Peterborough",
            "GB-PLY": "Plymouth (City of)",
            "GB-POL": "Poole",
            "GB-POR": "Portsmouth (City of)",
            "GB-RDG": "Reading",
            "GB-RDB": "Redbridge",
            "GB-RCC": "Redcar and Cleveland",
            "GB-RIC": "Richmond upon Thames",
            "GB-RCH": "Rochdale",
            "GB-ROT": "Rotherharn",
            "GB-RUT": "Rutland",
            "GB-SHN": "St. Helens",
            "GB-SLF": "Salford (City of)",
            "GB-SAW": "Sandweil",
            "GB-SFT": "Sefton",
            "GB-SHF": "Sheffield (City of)",
            "GB-SHR": "Shropshire",
            "GB-SLG": "Slough",
            "GB-SOL": "Solihull",
            "GB-SOM": "Somerset",
            "GB-SGC": "South Gloucestershire",
            "GB-STY": "South Tyneside",
            "GB-STH": "Southampton (City of)",
            "GB-SOS": "Southend-on-Sea",
            "GB-SWK": "Southwark",
            "GB-STS": "Staffordshire",
            "GB-SKP": "Stockport",
            "GB-STT": "Stockton-On-Tees",
            "GB-STE": "Stoke-on-Trent (City of)",
            "GB-SFK": "Suffolk",
            "GB-SND": "Sunderland (City of)",
            "GB-SRY": "Surrey",
            "GB-STN": "Sutton",
            "GB-SWD": "Swindon",
            "GB-TAM": "Tameside",
            "GB-TFW": "Telford and Wrekin",
            "GB-THR": "Thurrock",
            "GB-TOB": "Torbay",
            "GB-TWH": "Tower Hamlets",
            "GB-TRF": "Trafford",
            "GB-WKF": "Wakefield (City of)",
            "GB-WLL": "Walsall",
            "GB-WFT": "Waltham Forest",
            "GB-WND": "Wandsworth",
            "GB-WRT": "Warrington",
            "GB-WAR": "Warwickshire",
            "GB-WBK": "West Berkshire",
            "GB-WSX": "West Sussex",
            "GB-WSM": "Westminster (City of)",
            "GB-WGN": "Wigan",
            "GB-WIL": "Wiltshire",
            "GB-WNM": "Windsor and Maidenhead",
            "GB-WRL": "Wirral",
            "GB-WOK": "Wokingham",
            "GB-WLV": "Wolverhampton",
            "GB-WOR": "Worcestershire",
            "GB-YOR": "York (City of)",
            "GB-IOM": "Isle of Man",
            "GB-NIR": "Northern Ireland",
            "GB-ANT": "Antrim",
            "GB-ARD": "Ards",
            "GB-ARM": "Armagh",
            "GB-BLA": "Ballymena",
            "GB-BLY": "Ballymoney",
            "GB-BNB": "Banbridge",
            "GB-BFS": "Belfast (City of)",
            "GB-CKF": "Carrickfergus",
            "GB-CSR": "Castlereagh",
            "GB-CLR": "Coleraine",
            "GB-CKT": "Cookstown",
            "GB-CGV": "Craigavon",
            "GB-DRY": "Derry (City of)",
            "GB-DOW": "Down",
            "GB-DGN": "Dungannon",
            "GB-FER": "Fermanagh",
            "GB-LRN": "Larne",
            "GB-LMV": "Limavady",
            "GB-LSB": "Lisburn",
            "GB-MFT": "Magherafelt",
            "GB-MYL": "Moyle",
            "GB-NYM": "Newry and Mourne",
            "GB-NTA": "Newtownabbey",
            "GB-NDN": "North Down",
            "GB-OMH": "Omagh",
            "GB-STB": "Strabane",
            "GB-SCT": "Scotland",
            "GB-ABE": "Aberdeen City",
            "GB-ABD": "Aberdeenshire",
            "GB-ANS": "Angus",
            "GB-AGB": "Argyll and Bute",
            "GB-CLK": "Clackmannanshire",
            "GB-DGY": "Dumfries and Galloway",
            "GB-DND": "Dundee City",
            "GB-EAY": "East Ayrshire",
            "GB-EDU": "East Dunbartonshire",
            "GB-ELN": "East Lothian",
            "GB-ERW": "East Renfrewshire",
            "GB-EDH": "Edinburgh, City of",
            "GB-ELS": "Eilean Siar",
            "GB-FAL": "Falkirk",
            "GB-FIF": "Fife",
            "GB-GLG": "Glasgow City",
            "GB-HLD": "Highland",
            "GB-IVC": "Inverclyde",
            "GB-MLN": "Midlothian",
            "GB-MRY": "Moray",
            "GB-NAY": "North Ayrshire",
            "GB-NLK": "North Lanarkshire",
            "GB-ORK": "Orkney Islands",
            "GB-PKN": "Perth and Kinross",
            "GB-RFW": "Renfrewshire",
            "GB-SCB": "Scottish Borders, The",
            "GB-ZET": "Shetland Islands",
            "GB-SAY": "South Ayrshire",
            "GB-SLK": "South Lanarkshire",
            "GB-STG": "Stirling",
            "GB-WDU": "West Dunbartonshire",
            "GB-WLN": "West Lothian",
            "GB-WLS": "Wales [Cymru]",
            "GB-BGW": "Blaenau Gwent",
            "GB-BGE": "Bridgend [Pen-y-bont ar Ogwr GB-POG]",
            "GB-CAY": "Caerphilly [Caerffili GB-CAF]",
            "GB-CRF": "Cardiff (City of) [Caerdydd GB-CRD]",
            "GB-CMN": "Carmarthenshire [Sir Gaerfyrddin GB-GFY]",
            "GB-CGN": "Ceredigion [Sir Ceredigion]",
            "GB-CWY": "Conwy",
            "GB-DEN": "Denbighshire [Sir Ddinbych GB-DDB]",
            "GB-FLN": "Flintshire [Sir y Fflint GB-FFL]",
            "GB-GWN": "Gwynedd",
            "GB-AGY": "Isle of Anglesey [Sir Ynys Man GB-YNM]",
            "GB-MTY": "Merthyr Tydfil [Merthyr Tudful GB-MTU]",
            "GB-MON": "Monmouthshire [Sir Fynwy GB-FYN]",
            "GB-NTL": "Neath Port Talbot [Castell-nedd Port Talbot GB-CTL]",
            "GB-NWP": "Newport [Casnewydd GB-CNW]",
            "GB-PEM": "Pembrokeshire [Sir Benfro CB-BNF]",
            "GB-POW": "Powys",
            "GB-RCT": "Rhondda, Cynon, Taff [Rhondda, Cynon, Taf]",
            "GB-SWA": "Swansea (City of) [Abertawe GB-ATA]",
            "GB-TOF": "Torfaen [Tor-faen]",
            "GB-VGL": "Vale of Glamorgan, The [Bro Morgannwg GB-BMG]",
            "GB-WRX": "Wrexham [Wrecsam GB-WRC]"
        }
    },
    GR: {
        name: "Greece",
        divisions: {
            "GR-I": "Anatoliki Makedonia kai Thraki",
            "GR-52": "Drama",
            "GR-71": "Evros",
            "GR-55": "Kavalla",
            "GR-73": "Rodopi",
            "GR-72": "Xanthi",
            "GR-IX": "Attiki",
            "GR-A1": "Attiki",
            "GR-VII": "Dytiki Ellada",
            "GR-13": "Acha\xefa",
            "GR-01": "Aitolia-Akarnania",
            "GR-14": "Ileia",
            "GR-III": "Dytiki Makedonia",
            "GR-63": "Florina",
            "GR-51": "Grevena",
            "GR-56": "Kastoria",
            "GR-58": "Kozani",
            "GR-VI": "Ionioi Nisoi",
            "GR-23": "Kefallinia",
            "GR-22": "Kerkyra",
            "GR-24": "Lefkas",
            "GR-21": "Zakynthos",
            "GR-IV": "Ipeiros",
            "GR-31": "Arta",
            "GR-33": "Ioannina",
            "GR-34": "Preveza",
            "GR-32": "Thesprotia",
            "GR-II": "Kentriki Makedonia",
            "GR-64": "Chalkidiki",
            "GR-53": "Imathia",
            "GR-57": "Kilkis",
            "GR-59": "Pella",
            "GR-61": "Pieria",
            "GR-62": "Serrai",
            "GR-54": "Thessaloniki",
            "GR-XIII": "Kriti",
            "GR-94": "Chania",
            "GR-91": "Irakleion",
            "GR-92": "Lasithion",
            "GR-93": "Rethymnon",
            "GR-XII": "Notio Aigaio",
            "GR-81": "Dodekanisos",
            "GR-82": "Kyklades",
            "GR-X": "Peloponnisos",
            "GR-11": "Argolis",
            "GR-12": "Arkadia",
            "GR-15": "Korinthia",
            "GR-16": "Lakonia",
            "GR-17": "Messinia",
            "GR-VIII": "Sterea Ellada",
            "GR-05": "Evrytania",
            "GR-04": "Evvoia",
            "GR-07": "Fokis",
            "GR-06": "Fthiotis",
            "GR-03": "Voiotia",
            "GR-V": "Thessalia",
            "GR-41": "Karditsa",
            "GR-42": "Larisa",
            "GR-43": "Magnisia",
            "GR-44": "Trikala",
            "GR-XI": "Voreio Aigaio",
            "GR-85": "Chios",
            "GR-83": "Lesvos",
            "GR-84": "Samos"
        }
    },
    GL: {
        name: "Greenland",
        divisions: {
            "GL-GL": "Greenland"
        }
    },
    GD: {
        name: "Grenada",
        divisions: {
            "GD-GD": "Grenada"
        }
    },
    GP: {
        name: "Guadeloupe",
        divisions: {
            "GP-GP": "Guadeloupe"
        }
    },
    GU: {
        name: "Guam",
        divisions: {
            "GU-GU": "Guam"
        }
    },
    GT: {
        name: "Guatemala",
        divisions: {
            "GT-AV": "Alta Verapaz",
            "GT-BV": "Baja Verapaz",
            "GT-CM": "Chimaltenango",
            "GT-CQ": "Chiquimula",
            "GT-PR": "El Progreso",
            "GT-ES": "Escuintla",
            "GT-GU": "Guatemala",
            "GT-HU": "Huehuetenango",
            "GT-IZ": "Izabal",
            "GT-JA": "Jalapa",
            "GT-JU": "Jutiapa",
            "GT-PE": "Pet\xe9n",
            "GT-QZ": "Quezaltenango",
            "GT-QC": "Quich\xe9",
            "GT-RE": "Retalhuleu",
            "GT-SA": "Sacatep\xe9quez",
            "GT-SM": "San Marcos",
            "GT-SR": "Santa Rosa",
            "GT-SO": "Solol\xe1",
            "GT-SU": "Suchitep\xe9quez",
            "GT-TO": "Totonicap\xe1n",
            "GT-ZA": "Zacapa"
        }
    },
    GN: {
        name: "Guinea",
        divisions: {
            "GN-B": "Bake, Gouvernorat de",
            "GN-BF": "Boffa",
            "GN-BK": "Bok\xe9",
            "GN-FR": "Fria",
            "GN-GA": "Gaoual",
            "GN-KD": "Kindia",
            "GN-C": "Conakry, Gouvernorat de",
            "GN-F": "Faranah, Gouvernorat de",
            "GN-DB": "Dabola",
            "GN-DI": "Dinguiraye",
            "GN-FA": "Faranah",
            "GN-KS": "Kissidougou",
            "GN-K": "Kankan, Gouvernorat de",
            "GN-KA": "Kankan",
            "GN-KE": "K\xe9rouan\xe9",
            "GN-KO": "Kouroussa",
            "GN-MD": "Mandiana",
            "GN-SI": "Siguiri",
            "GN-D": "Kindia, Gouvernorat de",
            "GN-CO": "Coyah",
            "GN-DU": "Dubr\xe9ka",
            "GN-FO": "For\xe9cariah",
            "GN-TE": "T\xe9lim\xe9l\xe9",
            "GN-L": "Lab\xe9, Gouvernorat de",
            "GN-KB": "Koubia",
            "GN-LA": "Lab\xe9",
            "GN-LE": "L\xe9louma",
            "GN-ML": "Mali",
            "GN-TO": "Tougu\xe9",
            "GN-M": "Mamou, Gouvernorat de",
            "GN-DL": "Dalaba",
            "GN-MM": "Mamou",
            "GN-PI": "Pita",
            "GN-N": "Nz\xe9r\xe9kor\xe9, Gouvernorat de",
            "GN-BE": "Beyla",
            "GN-GU": "Gu\xe9k\xe9dou",
            "GN-LO": "Lola",
            "GN-MC": "Macenta",
            "GN-NZ": "Nz\xe9r\xe9kor\xe9",
            "GN-YO": "Yomou"
        }
    },
    GW: {
        name: "Guinea-Bissau",
        divisions: {
            "GW-BS": "Bissau",
            "GW-BA": "Bafat\xe1",
            "GW-BM": "Biombo",
            "GW-BL": "Bolama",
            "GW-CA": "Cacheu",
            "GW-GA": "Gab\xfa",
            "GW-OI": "Oio",
            "GW-QU": "Quinara"
        }
    },
    GY: {
        name: "Guyana",
        divisions: {
            "GY-BA": "Barima-Waini",
            "GY-CU": "Cuyuni-Mazaruni",
            "GY-DE": "Demerara-Mahaica",
            "GY-EB": "East Berbice-Corentyne",
            "GY-ES": "Essequibo Islands-West Demerara",
            "GY-MA": "Mahaica-Berbice",
            "GY-PM": "Pomeroon-Supenaam",
            "GY-PT": "Potaro-Siparuni",
            "GY-UD": "Upper Demerara-Berbice",
            "GY-UT": "Upper Takutu-Upper Essequibo"
        }
    },
    HT: {
        name: "Haiti",
        divisions: {
            "HT-AR": "Artibonite",
            "HT-CE": "Centre",
            "HT-GA": "Grande-Anse",
            "HT-ND": "Nord",
            "HT-NE": "Nord-Est",
            "HT-NO": "Nord-Ouest",
            "HT-OU": "Ouest",
            "HT-SD": "Sud",
            "HT-SE": "Sud-Est"
        }
    },
    HM: {
        name: "Heard & McDonald Islands",
        divisions: {
            "HM-HM": "Heard & McDonald Islands"
        }
    },
    VA: {
        name: "Vatican City (Holy See)",
        divisions: {
            "VA-VA": "Vatican City (Holy See)"
        }
    },
    HN: {
        name: "Honduras",
        divisions: {
            "HN-AT": "Atl\xe1ntida",
            "HN-CL": "Col\xf3n",
            "HN-CM": "Comayagua",
            "HN-CP": "Cop\xe1n",
            "HN-CR": "Cort\xe9s",
            "HN-CH": "Choluteca",
            "HN-EP": "El Para\xedso",
            "HN-FM": "Francisco Moraz\xe1n",
            "HN-GD": "Gracias a Dios",
            "HN-IN": "Intibuc\xe1",
            "HN-IB": "Islas de la Bah\xeda",
            "HN-LP": "La Paz",
            "HN-LE": "Lempira",
            "HN-OC": "Ocotepeque",
            "HN-OL": "Olancho",
            "HN-SB": "Santa B\xe1rbara",
            "HN-VA": "Valle",
            "HN-YO": "Yoro"
        }
    },
    HK: {
        name: "Hong Kong",
        divisions: {
            "HK-HK": "Hong Kong"
        }
    },
    HU: {
        name: "Hungary",
        divisions: {
            "HU-BU": "Budapest",
            "HU-BK": "B\xe1cs-Kiskun",
            "HU-BA": "Baranya",
            "HU-BE": "B\xe9k\xe9s",
            "HU-BZ": "Borsod-Aba\xfaj-Zempl\xe9n",
            "HU-CS": "Csongr\xe1d",
            "HU-FE": "Fej\xe9r",
            "HU-GS": "Gy\xf3r-Moson-Sopron",
            "HU-HB": "Hajd\xfa-Bihar",
            "HU-HE": "Heves",
            "HU-JN": "Jasz-Nagykun-Szolnok",
            "HU-KE": "Kom\xe1rom-Esztergom",
            "HU-NO": "N\xf3gr\xe1d",
            "HU-PE": "Pest",
            "HU-SO": "Somogy",
            "HU-SZ": "Szabolcs-Szatm\xe1r-Bereg",
            "HU-TO": "Tolna",
            "HU-VA": "Vas",
            "HU-VE": "Veszpr\xe9m",
            "HU-ZA": "Zala",
            "HU-BC": "B\xe9k\xe9scsaba",
            "HU-DE": "Debrecen",
            "HU-DU": "Duna\xfajv\xe1ros",
            "HU-EG": "Eger",
            "HU-GY": "Gy\xf3r",
            "HU-HV": "H\xf3dmez\xf3v\xe1s\xe1rhely",
            "HU-KV": "Kaposv\xe1r",
            "HU-KM": "Kecskem\xe9t",
            "HU-MI": "Miskolc",
            "HU-NK": "Nagykanizsa",
            "HU-NY": "Ny\xedregyh\xe1za",
            "HU-PS": "P\xe9cs",
            "HU-ST": "Salg\xf3tarj\xe1n",
            "HU-SN": "Sopron",
            "HU-SD": "Szeged",
            "HU-SF": "Sz\xe9kesfeh\xe9rv\xe1r",
            "HU-SS": "Szeksz\xe1rd",
            "HU-SK": "Szolnok",
            "HU-SH": "Szombathely",
            "HU-TB": "Tatab\xe1nya",
            "HU-VM": "Veszpr\xe9m",
            "HU-ZE": "Zalaegerszeg"
        }
    },
    IS: {
        name: "Iceland",
        divisions: {
            "IS-7": "Austurland",
            "IS-1": "H\xf6fudborgarsv\xe6di utan Reykjav\xedkur",
            "IS-6": "Nordurland eystra",
            "IS-5": "Nordurland vestra",
            "IS-0": "Reykjavīk",
            "IS-8": "Sudurland",
            "IS-2": "Sudurnes",
            "IS-4": "Vestfirdir",
            "IS-3": "Vesturland"
        }
    },
    IN: {
        name: "India",
        divisions: {
            "IN-AP": "Andhra Pradesh",
            "IN-AR": "Arunachal Pradesh",
            "IN-AS": "Assam",
            "IN-BR": "Bihar",
            "IN-GA": "Goa",
            "IN-GJ": "Gujarat",
            "IN-HR": "Haryana",
            "IN-HP": "Himachal Pradesh",
            "IN-JK": "Jammu and Kashmir",
            "IN-KA": "Karnataka",
            "IN-KL": "Kerala",
            "IN-MP": "Madhya Pradesh",
            "IN-MH": "Maharashtra",
            "IN-MN": "Manipur",
            "IN-ML": "Meghalaya",
            "IN-MZ": "Mizoram",
            "IN-NL": "Nagaland",
            "IN-OR": "Orissa",
            "IN-PB": "Punjab",
            "IN-RJ": "Rajasthan",
            "IN-SK": "Sikkim",
            "IN-TN": "Tamil Nadu",
            "IN-TR": "Tripura",
            "IN-UP": "Uttar Pradesh",
            "IN-WB": "West Bengal",
            "IN-AN": "Andaman and Nicobar Islands",
            "IN-CH": "Chandigarh",
            "IN-DN": "Dadra and Nagar Haveli",
            "IN-DD": "Daman and Diu",
            "IN-DL": "Delhi",
            "IN-LD": "Lakshadweep",
            "IN-PY": "Pondicherry"
        }
    },
    ID: {
        name: "Indonesia",
        divisions: {
            "ID-IJU": "Irian Jaya",
            "ID-IJ": "Irian Jaya",
            "ID-JWU": "Jawa",
            "ID-JB": "Jawa Barat",
            "ID-JT": "Jawa Tengah",
            "ID-JI": "Jawa Timur",
            "ID-JK": "Jakarta Raya",
            "ID-YO": "Yogyakarta",
            "ID-KAU": "Kalimantan",
            "ID-KB": "Kalimantan Barat",
            "ID-KS": "Kalimantan Selatan",
            "ID-KT": "Kalimantan Tengah",
            "ID-KI": "Kalimantan Timur",
            "ID-MAU": "Maluku",
            "ID-MA": "Maluku",
            "ID-NUU": "Nusa Tenggara",
            "ID-BA": "Bali",
            "ID-NB": "Nusa Tenggara Barat",
            "ID-NT": "Nusa Tenggara Timur",
            "ID-TT": "Timor Timur",
            "ID-SLU": "Sulawesi",
            "ID-SN": "Sulawesi Selatan",
            "ID-ST": "Sulawesi Tengah",
            "ID-SG": "Sulawesi Tenggara",
            "ID-SA": "Sulawesi Utara",
            "ID-SMU": "Sumatera",
            "ID-BE": "Bengkulu",
            "ID-JA": "Jambi",
            "ID-LA": "Lampung",
            "ID-RI": "Riau",
            "ID-SB": "Sumatera Barat",
            "ID-SS": "Sumatera Selatan",
            "ID-SU": "Sumatera Utara",
            "ID-AC": "Aceh"
        }
    },
    IR: {
        name: "Iran",
        divisions: {
            "IR-03": "Ardabīl",
            "IR-02": "Āzarbāyjān-e-Gharbī",
            "IR-01": "Āzarbāyjān-e-Sharqī",
            "IR-06": "Būshehr",
            "IR-08": "Chahār Maḩāll vā Bakhtīārī",
            "IR-04": "Eşfahān",
            "IR-14": "Fārs",
            "IR-19": "Gīlān",
            "IR-24": "Hamadān",
            "IR-23": "Hormozgān",
            "IR-05": "Īlām",
            "IR-15": "Kermān",
            "IR-17": "Kermānshāhān",
            "IR-09": "Khorāsān",
            "IR-10": "Khūzestān",
            "IR-18": "Kohkīlūyeh va Būyer Aḩmadī",
            "IR-16": "Kordestān",
            "IR-20": "Lorestān",
            "IR-22": "Markazī",
            "IR-21": "Māzandarān",
            "IR-26": "Qom",
            "IR-12": "Semnān",
            "IR-13": "Sīstān va Balūchestān",
            "IR-07": "Tehrān",
            "IR-25": "Yazd",
            "IR-11": "Zanjān"
        }
    },
    IQ: {
        name: "Iraq",
        divisions: {
            "IQ-AN": "Al Anbār",
            "IQ-BA": "Al Başrah",
            "IQ-MU": "Al Muthann\xe1",
            "IQ-QA": "Al Qādisīyah",
            "IQ-NA": "An Najaf",
            "IQ-AR": "Arbīl",
            "IQ-SU": "As Sulaymānīyah",
            "IQ-TS": "At Ta'mīm",
            "IQ-BB": "Bābil",
            "IQ-BG": "Baghdād",
            "IQ-DA": "Dahūk",
            "IQ-DQ": "Dhī Qār",
            "IQ-DI": "Diyāl\xe1",
            "IQ-KA": "Karbalā'",
            "IQ-MA": "Maysān",
            "IQ-NI": "Nīnaw\xe1",
            "IQ-SD": "Şalāḩ ad Dīn",
            "IQ-WA": "Wāsiţ"
        }
    },
    IE: {
        name: "Ireland",
        divisions: {
            "IE-CP": "Connaught (Connacht)",
            "IE-G": "Galway",
            "IE-LM": "Leitrim (Liatroim)",
            "IE-MO": "Mayo (Maigh Eo)",
            "IE-RN": "Roscommon (Ros Com\xe1in)",
            "IE-SO": "Sligo (Sligeach)",
            "IE-LP": "Leinster (Laighin)",
            "IE-CW": "Carlow (Ceatharlach)",
            "IE-D": "Dublin",
            "IE-KE": "Kildare (Cill Dara)",
            "IE-KK": "Kilkenny (Cill Chainnigh)",
            "IE-LS": "Laois (Laois)",
            "IE-LD": "Longford (An Longfort)",
            "IE-LH": "Louth (L\xfa)",
            "IE-MH": "Meath (An Mh\xed)",
            "IE-OY": "Offaly (U\xedbh Fhail\xed)",
            "IE-WH": "Westmeath (An Iarmh\xed)",
            "IE-WX": "Wexford",
            "IE-WW": "Wicklow (Cill Mhant\xe1in)",
            "IE-M": "Munster (An Mhumhain)",
            "IE-UP": "Ulster (Ulaidh)",
            "IE-CN": "Cavan (An Cabh\xe1n)",
            "IE-DL": "Donegal (D\xfan na nGall)",
            "IE-MN": "Monaghan (Muineach\xe1n)"
        }
    },
    IL: {
        name: "Israel",
        divisions: {
            "IL-D": "HaDarom (El Janūbī)",
            "IL-M": "HaMerkaz (El Awsat)",
            "IL-2": "HaZafon (Esh Shamālī)",
            "IL-HA": "Hefa (Heifā)",
            "IL-TA": "Tel-Aviv (Tell Abīb)",
            "IL-JM": "Yerushalayim (Al Quds)"
        }
    },
    IT: {
        name: "Italy",
        divisions: {
            "IT-65": "Abruzzo",
            "IT-CH": "Chieti",
            "IT-AQ": "L'Aquila",
            "IT-PE": "Pescara",
            "IT-TE": "Teramo",
            "IT-77": "Basilicata",
            "IT-MT": "Matera",
            "IT-PZ": "Potenza",
            "IT-78": "Calabria",
            "IT-CZ": "Catanzaro",
            "IT-CS": "Cosenza",
            "IT-KR": "Crotone",
            "IT-RC": "Reggio Calabria",
            "IT-W": "Vibo Valentia",
            "IT-72": "Campania",
            "IT-AV": "Avellino",
            "IT-BN": "Benevento",
            "IT-CE": "Caserta",
            "IT-NA": "Napoli",
            "IT-SA": "Salerno",
            "IT-45": "Emilia-Romagna",
            "IT-BO": "Bologna",
            "IT-FE": "Ferrara",
            "IT-FO": "Forl\xec",
            "IT-MO": "Modena",
            "IT-PR": "Parma",
            "IT-PC": "Piacenza",
            "IT-RA": "Ravenna",
            "IT-RE": "Reggio Emilia",
            "IT-RN": "Rimini",
            "IT-36": "Friuli-Venezia Giulia",
            "IT-GO": "Gorizia",
            "IT-PN": "Pordenone",
            "IT-TS": "Trieste",
            "IT-UD": "Udine",
            "IT-62": "Lazio",
            "IT-FR": "Frosinone",
            "IT-LT": "Latina",
            "IT-RI": "Rieti",
            "IT-RM": "Roma",
            "IT-VT": "Viterbo",
            "IT-42": "Liguria",
            "IT-GE": "Genova",
            "IT-IM": "Imperia",
            "IT-SP": "La Spezia",
            "IT-SV": "Savona",
            "IT-25": "Lombardia",
            "IT-BG": "Bergamo",
            "IT-BS": "Brescia",
            "IT-CO": "Como",
            "IT-CR": "Cremona",
            "IT-LC": "Lecco",
            "IT-LO": "Lodi",
            "IT-MN": "Mantova",
            "IT-MI": "Milano",
            "IT-PV": "Pavia",
            "IT-SO": "Sondrio",
            "IT-VA": "Varese",
            "IT-57": "Marche",
            "IT-AN": "Ancona",
            "IT-AP": "Ascoli Piceno",
            "IT-MC": "Macerata",
            "IT-PS": "Pesaro",
            "IT-67": "Molise",
            "IT-CB": "Campobasso",
            "IT-IS": "Isernia",
            "IT-21": "Piemonte",
            "IT-AL": "Alessandria",
            "IT-AT": "Asti",
            "IT-BI": "Biella",
            "IT-CN": "Cuneo",
            "IT-NO": "Novara",
            "IT-TO": "Torino",
            "IT-VB": "Verbano-Cusio-Ossola",
            "IT-VC": "Vercelli",
            "IT-75": "Puglia",
            "IT-BA": "Bari",
            "IT-BR": "Brindisi",
            "IT-FG": "Foggia",
            "IT-LE": "Lecce",
            "IT-TA": "Taranto",
            "IT-88": "Sardegna",
            "IT-CA": "Cagliari",
            "IT-NU": "Nuoro",
            "IT-OR": "Oristano",
            "IT-SS": "Sassari",
            "IT-82": "Sicilia",
            "IT-AG": "Agrigento",
            "IT-CL": "Caltanissetta",
            "IT-CT": "Catania",
            "IT-EN": "Enna",
            "IT-ME": "Mesaina",
            "IT-PA": "Palermo",
            "IT-RG": "Ragusa",
            "IT-SR": "Siracusa",
            "IT-TP": "Trapani",
            "IT-52": "Toscana",
            "IT-AR": "Arezzo",
            "IT-FI": "Firenze",
            "IT-GR": "Grosseto",
            "IT-LI": "Livorno",
            "IT-LU": "Lucca",
            "IT-MS": "Massa",
            "IT-PI": "Pisa",
            "IT-PT": "Pistoia",
            "IT-PO": "Prato",
            "IT-SI": "Siena",
            "IT-32": "Trentino-Alte Adige (Trentino-S\xfcdtirol)",
            "IT-BZ": "Bolzano (Bozen)",
            "IT-TN": "Trento",
            "IT-55": "Umbria",
            "IT-PG": "Perugia",
            "IT-TR": "Terni",
            "IT-23": "Valle d'Aosta (Vall\xe9e d'Aoste)",
            "IT-AO": "Aosta (Aoste)",
            "IT-34": "Veneto",
            "IT-BL": "Belluno",
            "IT-PD": "Padova",
            "IT-RO": "Rovigo",
            "IT-TV": "Treviso",
            "IT-VE": "Venezia",
            "IT-VR": "Verona",
            "IT-VI": "Vicenza"
        }
    },
    JM: {
        name: "Jamaica",
        divisions: {
            "JM-13": "Clarendon",
            "JM-09": "Hanover",
            "JM-01": "Kingston",
            "JM-12": "Manchester",
            "JM-04": "Portland",
            "JM-02": "Saint Andrew",
            "JM-06": "Saint Ann",
            "JM-14": "Saint Catherine",
            "JM-11": "Saint Elizabeth",
            "JM-08": "Saint James",
            "JM-05": "Saint Mary",
            "JM-03": "Saint Thomas",
            "JM-07": "Trelawny",
            "JM-10": "Westmoreland"
        }
    },
    JP: {
        name: "Japan",
        divisions: {
            "JP-23": "Aichi",
            "JP-05": "Akita",
            "JP-02": "Aomori",
            "JP-38": "Ehime",
            "JP-21": "Gifu",
            "JP-10": "Gunma",
            "JP-34": "Hiroshima",
            "JP-01": "Hokkaido",
            "JP-18": "Hukui [Fukui]",
            "JP-40": "Hukuoka [Fukuoka]",
            "JP-07": "Hukusima [Fukushima]",
            "JP-28": "Hy\xf4go [Hyogo]",
            "JP-08": "Ibaraki",
            "JP-17": "Isikawa [Ishikawa]",
            "JP-03": "Iwate",
            "JP-37": "Kagawa",
            "JP-46": "Kagoshima",
            "JP-14": "Kanagawa",
            "JP-39": "Kochi",
            "JP-43": "Kumamoto",
            "JP-26": "Kyoto",
            "JP-24": "Mie",
            "JP-04": "Miyagi",
            "JP-45": "Miyazaki",
            "JP-20": "Nagano",
            "JP-42": "Nagasaki",
            "JP-29": "Nara",
            "JP-15": "Niigata",
            "JP-44": "Oita",
            "JP-33": "Okayama",
            "JP-47": "Okinawa",
            "JP-27": "Osaka",
            "JP-41": "Saga",
            "JP-11": "Saitama",
            "JP-25": "Shiga",
            "JP-22": "Shizuoka",
            "JP-12": "Chiba",
            "JP-09": "Tochigi",
            "JP-36": "Tokushima",
            "JP-13": "Tokyo",
            "JP-31": "Tottori",
            "JP-16": "Toyama",
            "JP-30": "Wakayama",
            "JP-06": "Yamagata",
            "JP-35": "Yamaguti [Yamaguchi]",
            "JP-19": "Yamanasi [Yamanashi]"
        }
    },
    JO: {
        name: "Jordan",
        divisions: {
            "JO-AJ": "‘Ajlūn",
            "JO-AQ": "Al 'Aqaba",
            "JO-BA": "Al Balqā'",
            "JO-KA": "Al Karak",
            "JO-MA": "Al Mafraq",
            "JO-AM": "‘Ammān",
            "JO-AT": "Aţ Ţafīlah",
            "JO-AZ": "Az Zarqā'",
            "JO-IR": "Irbid",
            "JO-JA": "Jarash",
            "JO-MN": "Ma‘ān",
            "JO-MD": "Mādaba"
        }
    },
    KZ: {
        name: "Kazakhstan",
        divisions: {
            "KZ-ALA": "Almaty",
            "KZ-BAY": "Bayqonyr (Baykonyr)",
            "KZ-ALM": "Almaty oblysy (Almatinskaya oblast')",
            "KZ-AKM": "Aqmola oblysy (Akmolinskaya oblast')",
            "KZ-AKT": "Aqt\xf6be oblysy (Aktyubinskaya oblast')",
            "KZ-ATY": "Atyra\xfc oblysy (Atyrauskaya oblast')",
            "KZ-ZAP": "Batys Kazakstan oblysy (Zapadno-Kazakhstanskaya oblast')",
            "KZ-MAN": "Mangghystaū oblysy (Mangystauskaya oblast')",
            "KZ-YUZ": "Ongt\xfcstik Kazakstan oblysy (Yuzhno-Kazakhstanskaya oblast')",
            "KZ-PAV": "Pavlodar oblysy (Pavlodarskaya oblast')",
            "KZ-KAR": "Qaraghandy oblysy (Karagandinskaya oblast')",
            "KZ-KUS": "Qostanay oblysy (Kustanayskaya oblast')",
            "KZ-KZY": "Qyzylorda oblysy (Kzylordinskaya oblast')",
            "KZ-VOS": "Shyghys Kazakstan oblysy (Vostochno-Kazakhstanskaya oblast')",
            "KZ-SEV": "Solt\xfcstik Kazakstan oblysy (Severo-Kazakhstanskaya oblast')",
            "KZ-ZHA": "Zhambyl oblysy (Zhambylskaya Oblast')"
        }
    },
    KE: {
        name: "Kenya",
        divisions: {
            "KE-110": "Nairobi Municipality",
            "KE-200": "Central (Kati)",
            "KE-300": "Coast (Pwani)",
            "KE-400": "Eastern (Mashariki)",
            "KE-500": "North-Eastern (Kaskazini Mashariki)",
            "KE-600": "Nyanza",
            "KE-700": "Rift Valley",
            "KE-900": "Western (Magharibi)"
        }
    },
    KI: {
        name: "Kiribati",
        divisions: {
            "KI-G": "Gilbert Islands",
            "KI-L": "Line Islands",
            "KI-P": "Phoenix Islands"
        }
    },
    KP: {
        name: "Korea (North)",
        divisions: {
            "KP-KAE": "Kaesong-si",
            "KP-NAM": "Nampo-si",
            "KP-PYO": "Pyongyang-si",
            "KP-CHA": "Chagang-do",
            "KP-HAB": "Hamgyongbuk-do",
            "KP-HAN": "Hamgyongnam-do",
            "KP-HWB": "Hwanghaebuk-do",
            "KP-HWN": "Hwanghaenam-do",
            "KP-KAN": "Kangwon-do",
            "KP-PYB": "Pyonganbuk-do",
            "KP-PYN": "Pyongannam-do",
            "KP-YAN": "Yanggang-do"
        }
    },
    KR: {
        name: "Korea (South)",
        divisions: {
            "KR-11": "Seoul Teugbyeolsi [ Seoul-T’ŭkpyŏlshi]",
            "KR-26": "Busan Gwang'yeogsi [Pusan-Kwangyŏkshi]",
            "KR-27": "Daegu Gwang'yeogsi [Taegu-Kwangyŏkshi)",
            "KR-30": "Daejeon Gwang'yeogsi [Taejŏn-Kwangyŏkshi]",
            "KR-29": "Gwangju Gwang'yeogsi [Kwangju-Kwangyŏkshi]",
            "KR-28": "Incheon Gwang'yeogsi [Inchŏn-Kwangyŏkshi]",
            "KR-31": "Ulsan Gwang'yeogsi [Ulsan-Kwangyŏkshi]",
            "KR-43": "Chungcheongbugdo [Ch'ungch'ŏngbuk-do]",
            "KR-44": "Chungcheongnamdo [Ch'ungch'ŏngnam-do]",
            "KR-42": "Gang'weondo [Kang-won-do]",
            "KR-41": "Gyeonggido [Kyŏnggi-do]",
            "KR-47": "Gyeongsangbugdo [Kyŏngsangbuk-do]",
            "KR-48": "Gyeongsangnamdo [Kyŏngsangnam-do]",
            "KR-49": "Jejudo [Cheju-do]",
            "KR-45": "Jeonrabugdo [Chŏllabuk-do)",
            "KR-46": "Jeonranamdo [Chŏllanam-do]"
        }
    },
    KW: {
        name: "Kuwait",
        divisions: {
            "KW-AH": "Al Aḩmadi",
            "KW-FA": "Al Farwānīyah",
            "KW-JA": "Al Jahrah",
            "KW-KU": "Al Kuwayt",
            "KW-HA": "Ḩawallī"
        }
    },
    KG: {
        name: "Kyrgyzstan",
        divisions: {
            "KG-C": "Chu (Chuyskaya oblast')",
            "KG-J": "Jalal-Abad (Dzhalal-Abadskaya oblast')",
            "KG-N": "Naryn (Narynskaya Oblast’)",
            "KG-O": "Osh (Oshskaya oblast')",
            "KG-T": "Talas (Talasskaya oblast')",
            "KG-Y": "Ysyk-K\xf6l (Issyk-Kul'skaya oblast')"
        }
    },
    LA: {
        name: "Laos",
        divisions: {
            "LA-VT": "Vientiane",
            "LA-AT": "Attapu [Attopeu]",
            "LA-BK": "Bok\xe8o",
            "LA-BL": "Bolikhamxai [Borikhane]",
            "LA-CH": "Champasak [Champassak]",
            "LA-HO": "Houaphan",
            "LA-KH": "Khammouan",
            "LA-LM": "Louang Namtha",
            "LA-LP": "Louangphabang [Louang Prabang]",
            "LA-OU": "Oud\xf4mxai [Oudomsai]",
            "LA-PH": "Ph\xf4ngsali [Phong Saly]",
            "LA-SL": "Salavan [Saravane]",
            "LA-SV": "Savannakh\xe9t",
            "LA-VI": "Vientiane",
            "LA-XA": "Xaignabouli [Sayaboury]",
            "LA-XE": "X\xe9kong [S\xe9kong]",
            "LA-XI": "Xiangkhoang [Xieng Khouang]"
        }
    },
    LV: {
        name: "Latvia",
        divisions: {
            "LV-AI": "Aizkraukles Aprinkis",
            "LV-AL": "Alūksnes Aprinkis",
            "LV-BL": "Balvu Aprinkis",
            "LV-BU": "Bauskas Aprinkis",
            "LV-CE": "Cēsu Aprinkis",
            "LV-DA": "Daugavpils Aprinkis",
            "LV-DO": "Dobeles Aprinkis",
            "LV-GU": "Gulbenes Aprinkis",
            "LV-JL": "Jelgavas Aprinkis",
            "LV-JK": "Jēkabpils Aprinkis",
            "LV-KR": "Krāslavas Aprinkis",
            "LV-KU": "Kuldīgas Aprinkis",
            "LV-LM": "Limbažu Aprinkis",
            "LV-LE": "Liepājas Aprinkis",
            "LV-LU": "Ludzas Aprinkis",
            "LV-MA": "Madonas Aprinkis",
            "LV-OG": "Ogres Aprinkis",
            "LV-PR": "Preilu Aprinkis",
            "LV-RE": "Rēzeknes Aprinkis",
            "LV-RI": "Rīgas Aprinkis",
            "LV-SA": "Saldus Aprinkis",
            "LV-TA": "Talsu Aprinkis",
            "LV-TU": "Tukuma Aprinkis",
            "LV-VK": "Valkas Aprinkis",
            "LV-VM": "Valmieras Aprinkis",
            "LV-VE": "Ventspils Aprinkis",
            "LV-DGV": "Daugavpils",
            "LV-JEL": "Jelgava",
            "LV-JUR": "Jūrmala",
            "LV-LPX": "Liepāja",
            "LV-REZ": "Rēzekne",
            "LV-RIX": "Riga",
            "LV-VEN": "Ventspils"
        }
    },
    LB: {
        name: "Lebanon",
        divisions: {
            "LB-BA": "Beiro\xfbt (Bayrūt)",
            "LB-BI": "El B\xe9qaa (Al Biqā')",
            "LB-JL": "Jabal Loubn\xe2ne (Jabal Lubnān)",
            "LB-AS": "Loubn\xe2ne ech Chem\xe2li (Ash Shamāl)",
            "LB-JA": "Loubn\xe2ne ej Jno\xfbbi (Al Janūb)",
            "LB-NA": "Nabat\xeey\xe9 (An Nabaţīyah"
        }
    },
    LS: {
        name: "Lesotho",
        divisions: {
            "LS-D": "Berea",
            "LS-B": "Butha-Buthe",
            "LS-C": "Leribe",
            "LS-E": "Mafeteng",
            "LS-A": "Maseru",
            "LS-F": "Mohale's Hoek",
            "LS-J": "Mokhotlong",
            "LS-H": "Qacha's Nek",
            "LS-G": "Quthing",
            "LS-K": "Thaba-Tseka"
        }
    },
    LR: {
        name: "Liberia",
        divisions: {
            "LR-BM": "Bomi",
            "LR-BG": "Bong",
            "LR-GB": "Grand Bassa",
            "LR-CM": "Grand Cape Mount",
            "LR-GG": "Grand Gedeh",
            "LR-GK": "Grand Kru",
            "LR-LO": "Lofa",
            "LR-MG": "Margibi",
            "LR-MY": "Maryland",
            "LR-MO": "Montserrado",
            "LR-NI": "Nimba",
            "LR-RI": "Rivercess",
            "LR-SI": "Sinoe"
        }
    },
    LY: {
        name: "Libya",
        divisions: {
            "LY-BU": "Al Buţnān",
            "LY-JA": "Al Jabal al Akhḑar",
            "LY-JG": "Al Jabal al Gharbī",
            "LY-Ju": "Al Jufrah",
            "LY-WA": "Al Wāḩah",
            "LY-Wu": "Al Wusţ\xe1",
            "LY-ZA": "Az Zāwiyah",
            "LY-BA": "Banghāzī",
            "LY-FA": "Fazzān",
            "LY-MI": "Mişrātah",
            "LY-NA": "Naggaza",
            "LY-SF": "Sawfajjin",
            "LY-TB": "Ţarābulus"
        }
    },
    LI: {
        name: "Liechtenstein",
        divisions: {
            "LI-LI": "Liechtenstein"
        }
    },
    LT: {
        name: "Lithuania",
        divisions: {
            "LT-AL": "Alytaus Apskritis",
            "LT-KU": "Kauno Apskritis",
            "LT-KL": "Klaipėdos Apskritis",
            "LT-MR": "Marijampolės Apskritis",
            "LT-PN": "Panevėžio Apskritis",
            "LT-SA": "Šiauliu Apskritis",
            "LT-TA": "Tauragės Apskritis",
            "LT-TE": "Telšiu Apskritis",
            "LT-UT": "Utenos Apskritis",
            "LT-VL": "Vilniaus Apskritis"
        }
    },
    LU: {
        name: "Luxembourg",
        divisions: {
            "LU-D": "Diekirch",
            "LU-G": "Grevenmacher",
            "LU-L": "Luxemburg"
        }
    },
    MO: {
        name: "Macau",
        divisions: {
            "MO-MO": "Macau"
        }
    },
    MK: {
        name: "Macedonia",
        divisions: {
            "MK-MK": "Macedonia"
        }
    },
    MG: {
        name: "Madagascar",
        divisions: {
            "MG-T": "Antananarivo",
            "MG-D": "Antsiranana",
            "MG-F": "Fianarantsoa",
            "MG-M": "Mahajanga",
            "MG-A": "Toamasina",
            "MG-U": "Toliara"
        }
    },
    MW: {
        name: "Malawi",
        divisions: {
            "MW-C": "Central",
            "MW-DE": "Dedza",
            "MW-DO": "Dowa",
            "MW-KS": "Kasungu",
            "MW-LI": "Lilongwe",
            "MW-MC": "Mchinji",
            "MW-NK": "Nkhotakota",
            "MW-NU": "Ntcheu",
            "MW-NI": "Ntchisi",
            "MW-SA": "Salima",
            "MW-N": "Northern",
            "MW-CT": "Chitipa",
            "MW-KR": "Karonga",
            "MW-MZ": "Mzimba",
            "MW-NB": "Nkhata Bay",
            "MW-RU": "Rumphi",
            "MW-S": "Southern",
            "MW-BL": "Blantyre",
            "MW-CK": "Chikwawa",
            "MW-CR": "Chiradzulu",
            "MW-MH": "Machinga",
            "MW-MG": "Mangochi",
            "MW-MU": "Mulanje",
            "MW-MW": "Mwanza",
            "MW-NS": "Nsanje",
            "MW-TH": "Thyolo",
            "MW-ZO": "Zomba"
        }
    },
    MY: {
        name: "Malaysia",
        divisions: {
            "MY-W": "Wilayah Persekutuan Kuala Lumpur",
            "MY-L": "Wilayah Persekutuan Labuan",
            "MY-J": "Johor",
            "MY-K": "Kedah",
            "MY-D": "Kelantan",
            "MY-M": "Melaka",
            "MY-N": "Negeri Sembilan",
            "MY-C": "Pahang",
            "MY-A": "Perak",
            "MY-R": "Perlis",
            "MY-P": "Pulau Pinang",
            "MY-SA": "Sabah",
            "MY-SK": "Sarawak",
            "MY-B": "Selangor",
            "MY-T": "Terengganu"
        }
    },
    MV: {
        name: "Maldives",
        divisions: {
            "MV-MLE": "Male",
            "MV-02": "Alif",
            "MV-20": "Baa",
            "MV-17": "Dhaalu",
            "MV-14": "Faafu",
            "MV-27": "Gaaf Alif",
            "MV-28": "Gaafu Dhaalu",
            "MV-29": "Gnaviyani",
            "MV-07": "Haa Alif",
            "MV-23": "Haa Dhaalu",
            "MV-26": "Kaafu",
            "MV-05": "Laamu",
            "MV-03": "Lhaviyani",
            "MV-12": "Meemu",
            "MV-25": "Noonu",
            "MV-13": "Raa",
            "MV-01": "Seenu",
            "MV-24": "Shaviyani",
            "MV-08": "Thaa",
            "MV-04": "Vaavu"
        }
    },
    ML: {
        name: "Mali",
        divisions: {
            "ML-BKO": "Bamako",
            "ML-7": "Gao",
            "ML-1": "Kayes",
            "ML-8": "Kidal",
            "ML-2": "Koulikoro",
            "ML-5": "Mopti",
            "ML-4": "S\xe9gou",
            "ML-3": "Sikasso",
            "ML-6": "Tombouctou"
        }
    },
    MT: {
        name: "Malta",
        divisions: {
            "MT-MT": "Malta"
        }
    },
    MH: {
        name: "Marshall Islands",
        divisions: {
            "MH-L": "Ralik chain",
            "MH-ALL": "Ailinglapalap",
            "MH-EBO": "Ebon",
            "MH-ENI": "Eniwetok",
            "MH-JAL": "Jaluit",
            "MH-KIL": "Kili",
            "MH-KWA": "Kwajalein",
            "MH-LAE": "Lae",
            "MH-LIB": "Lib",
            "MH-NMK": "Namorik",
            "MH-NMU": "Namu",
            "MH-RON": "Rongelap",
            "MH-UJA": "Ujae",
            "MH-UJL": "Ujelang",
            "MH-WTH": "Wotho",
            "MH-T": "Ratak chain",
            "MH-ALK": "Ailuk",
            "MH-ARN": "Arno",
            "MH-AUR": "Aur",
            "MH-LIK": "Likiep",
            "MH-MAJ": "Majuro",
            "MH-MAL": "Maloelap",
            "MH-MEJ": "Mejit",
            "MH-MIL": "Mili",
            "MH-UTI": "Utirik",
            "MH-WTJ": "Wotje"
        }
    },
    MQ: {
        name: "Martinique",
        divisions: {
            "MQ-MQ": "Martinique"
        }
    },
    MR: {
        name: "Mauritania",
        divisions: {
            "MR-NKC": "Nouakchott",
            "MR-07": "Adrar",
            "MR-03": "Assaba",
            "MR-05": "Brakna",
            "MR-08": "Dakhlet Nouādhibou",
            "MR-04": "Gorgol",
            "MR-10": "Guidimaka",
            "MR-01": "Hodh ech Chargui",
            "MR-02": "Hodh el Gharbi",
            "MR-12": "Inchiri",
            "MR-09": "Tagant",
            "MR-11": "Tiris Zemmour",
            "MR-06": "Trarza"
        }
    },
    MU: {
        name: "Mauritius",
        divisions: {
            "MU-BR": "Beau Bassin-Rose Hill",
            "MU-CU": "Curepipe",
            "MU-PL": "Port Louis",
            "MU-QB": "Quatre Bornes",
            "MU-VP": "Vacoas-Phoenix",
            "MU-BL": "Black River",
            "MU-FL": "Flacq",
            "MU-GP": "Grand Port",
            "MU-MO": "Moka",
            "MU-PA": "Pamplemousses",
            "MU-PW": "Plaines Wilhems",
            "MU-RR": "Rivi\xe8re du Rempart",
            "MU-SA": "Savanne",
            "MU-AG": "Agalega Islands",
            "MU-CC": "Cargados Carajos Shoals [Saint Brandon Islands]",
            "MU-RO": "Rodrigues Island"
        }
    },
    YT: {
        name: "Mayotte",
        divisions: {
            "YT-YT": "Mayotte"
        }
    },
    MX: {
        name: "Mexico",
        divisions: {
            "MX-DIF": "Distrito Federal",
            "MX-AGU": "Aguascalientes",
            "MX-BCN": "Baja California",
            "MX-BCS": "Baja California Sur",
            "MX-CAM": "Campeche",
            "MX-COA": "Coahuila",
            "MX-COL": "Colima",
            "MX-CHP": "Chiapas",
            "MX-CHH": "Chihuahua",
            "MX-DUR": "Durango",
            "MX-GRO": "Guerrero",
            "MX-GUA": "Guanajuato",
            "MX-HID": "Hidalgo",
            "MX-JAL": "Jalisco",
            "MX-MEX": "M\xe9xico",
            "MX-MIC": "Michoac\xe1n",
            "MX-MOR": "Morelos",
            "MX-NAY": "Nayarit",
            "MX-NLE": "Nuevo Le\xf3n",
            "MX-OAX": "Oaxaca",
            "MX-PUE": "Puebla",
            "MX-QUE": "Queretaro",
            "MX-ROO": "Quintana Roo",
            "MX-SLP": "San Luis Potos\xed",
            "MX-SIN": "Sinaloa",
            "MX-SON": "Sonora",
            "MX-TAB": "Tabasco",
            "MX-TAM": "Tamaulipas",
            "MX-TLA": "Tlaxcala",
            "MX-VER": "Veracruz",
            "MX-YUC": "Yucat\xe1n",
            "MX-ZAC": "Zacatecas"
        }
    },
    FM: {
        name: "Micronesia",
        divisions: {
            "FM-TRK": "chuuk",
            "FM-KSA": "Kosrae",
            "FM-PNI": "Pohnpei",
            "FM-YAP": "Yap"
        }
    },
    MD: {
        name: "Moldova",
        divisions: {
            "MD-BAL": "Bălţi",
            "MD-CAH": "Cahul",
            "MD-CHI": "Chişinău",
            "MD-DUB": "Dubăsari",
            "MD-ORH": "Orhei",
            "MD-RIB": "R\xeebniţa",
            "MD-SOC": "Soroca",
            "MD-TIG": "Tighina",
            "MD-TIR": "Tiraspol",
            "MD-UNG": "Ungheni",
            "MD-ANE": "Anenii Noi",
            "MD-BAS": "Basarabeasca",
            "MD-BRI": "Brinceni",
            "MD-CHL": "Cahul",
            "MD-CAM": "Camenca",
            "MD-CAN": "Cantemir",
            "MD-CAI": "Căinari",
            "MD-CAL": "Călăraşi",
            "MD-CAS": "Căuşeni",
            "MD-CIA": "Ciad\xeer-Lunga",
            "MD-CIM": "Cimişlia",
            "MD-COM": "Comrat",
            "MD-CRI": "Criuleni",
            "MD-DON": "Donduşeni",
            "MD-DRO": "Drochia",
            "MD-DBI": "Dubăsari",
            "MD-EDI": "Edineţ",
            "MD-FAL": "Făleşti",
            "MD-FLO": "Floreşti",
            "MD-GLO": "Glodeni",
            "MD-GRI": "Grigoriopol",
            "MD-HIN": "H\xeenceşti",
            "MD-IAL": "Ialoveni",
            "MD-LEO": "Leova",
            "MD-NIS": "Nisporeni",
            "MD-OCN": "Ocniţa",
            "MD-OHI": "Orhei",
            "MD-REZ": "Rezina",
            "MD-RIT": "R\xeebniţa",
            "MD-RIS": "R\xeeşcani",
            "MD-SIN": "S\xeengerei",
            "MD-SLO": "Slobozia",
            "MD-SOA": "Soroca",
            "MD-STR": "Străşeni",
            "MD-SOL": "Şoldăneşti",
            "MD-STE": "Ştefan Vodă",
            "MD-TAR": "Taraclia",
            "MD-TEL": "Teleneşti",
            "MD-UGI": "Ungheni",
            "MD-VUL": "Vulcăneşti"
        }
    },
    MC: {
        name: "Monaco",
        divisions: {
            "MC-MC": "Monaco"
        }
    },
    MN: {
        name: "Mongolia",
        divisions: {
            "MN-1": "Ulaanbaatar",
            "MN-073": "Arhangay",
            "MN-069": "Bayanhongor",
            "MN-071": "Bayan-\xd6lgiy",
            "MN-067": "Bulgan",
            "MN-037": "Darhan uul",
            "MN-061": "Dornod",
            "MN-063": "Dornogovĭ",
            "MN-059": "Dundgovĭ",
            "MN-057": "Dzavhan",
            "MN-065": "Govĭ-Altay",
            "MN-064": "Govĭ-S\xfcmber",
            "MN-039": "Hentiy",
            "MN-043": "Hovd",
            "MN-041": "H\xf6vsg\xf6l",
            "MN-053": "\xd6mn\xf6govĭ",
            "MN-035": "Orhon",
            "MN-055": "\xd6v\xf6rhangay",
            "MN-049": "Selenge",
            "MN-051": "S\xfchbaatar",
            "MN-047": "T\xf6v",
            "MN-046": "Uvs"
        }
    },
    MS: {
        name: "Montserrat",
        divisions: {
            "MS-MS": "Montserrat"
        }
    },
    MA: {
        name: "Morocco",
        divisions: {
            "MA-CE": "Centre",
            "MA-AZI": "Azilal",
            "MA-BEM": "Beni Mellal",
            "MA-BES": "Ben Slimane",
            "MA-BOM": "Boulemane",
            "MA-CAS": "Casablanca [Dar el Be\xefda]",
            "MA-JDI": "El Jadida",
            "MA-KHO": "Khouribga",
            "MA-SET": "Settat",
            "MA-CN": "Centre-Nord",
            "MA-HOC": "Al Hoce\xefma",
            "MA-FES": "F\xe8s",
            "MA-SEF": "Sefrou",
            "MA-TAO": "Taounate",
            "MA-TAZ": "Taza",
            "MA-CS": "Centre-Sud",
            "MA-HAJ": "El Hajeb",
            "MA-ERR": "Errachidia",
            "MA-IFR": "Ifrane",
            "MA-KHN": "Khenifra",
            "MA-MEK": "Mekn\xe8s",
            "MA-ES": "Est",
            "MA-BER": "Berkane",
            "MA-FIG": "Figuig",
            "MA-IRA": "Jrada",
            "MA-NAD": "Nador",
            "MA-OUJ": "Oujda",
            "MA-NO": "Nord-Ouest",
            "MA-CHE": "Chefchaouene",
            "MA-KEN": "K\xe9nitra",
            "MA-KHE": "Khemisset",
            "MA-LAR": "Larache",
            "MA-RBA": "Rabat-Sal\xe9",
            "MA-SIK": "Sidi Kacem",
            "MA-TNG": "Tanger",
            "MA-TET": "T\xe9touan",
            "MA-SU": "Sud",
            "MA-AGD": "Agadir",
            "MA-BAH": "A\xeft Baha",
            "MA-MEL": "A\xeft Melloul",
            "MA-ASZ": "Assa-Zag",
            "MA-BOD": "Boujdour (EH)",
            "MA-ESM": "Es Semara (EH)",
            "MA-GUE": "Guelmim",
            "MA-LAA": "Laayoune (EH)",
            "MA-OUA": "Ouarzazate",
            "MA-OUD": "Oued ed Dahab (EH)",
            "MA-TNT": "Tan-Tan",
            "MA-TAR": "Taroudannt",
            "MA-TAT": "Tata",
            "MA-TIZ": "Tiznit",
            "MA-TS": "Tensift",
            "MA-HAO": "Al Haouz",
            "MA-CHI": "Chichaoua",
            "MA-ESI": "Essaouira",
            "MA-KES": "Kelaat Sraghna",
            "MA-MAR": "Marrakech",
            "MA-SAF": "Safi"
        }
    },
    MZ: {
        name: "Mozambique",
        divisions: {
            "MZ-MPM": "Maputo",
            "MZ-P": "Cabo Delgado",
            "MZ-G": "Gaza",
            "MZ-I": "Inhambane",
            "MZ-B": "Manica",
            "MZ-L": "Maputo",
            "MZ-N": "Nampula",
            "MZ-A": "Niassa",
            "MZ-S": "Sofala",
            "MZ-T": "Tete",
            "MZ-Q": "Zamb\xe9zia"
        }
    },
    MM: {
        name: "Myanmar",
        divisions: {
            "MM-07": "Ayeyarwady",
            "MM-02": "Bago",
            "MM-03": "Magway",
            "MM-04": "Mandalay",
            "MM-01": "Sagaing",
            "MM-05": "Tanintharyi",
            "MM-06": "Yangon",
            "MM-14": "Chin",
            "MM-11": "Kachin",
            "MM-12": "Kayah",
            "MM-13": "Kayin",
            "MM-15": "Mon",
            "MM-16": "Rakhine",
            "MM-17": "Shan"
        }
    },
    NA: {
        name: "Namibia",
        divisions: {
            "NA-CA": "Caprivi",
            "NA-ER": "Erongo",
            "NA-HA": "Hardap",
            "NA-KA": "Karas",
            "NA-KH": "Khomas",
            "NA-KU": "Kunene",
            "NA-OW": "Ohangwena",
            "NA-OK": "Okavango",
            "NA-OH": "Omaheke",
            "NA-OS": "Omusati",
            "NA-ON": "Oshana",
            "NA-OT": "Oshikoto",
            "NA-OD": "Otjozondjupa"
        }
    },
    NR: {
        name: "Nauru",
        divisions: {
            "NR-NR": "Nauru"
        }
    },
    NP: {
        name: "Nepal",
        divisions: {
            "NP-1": "Madhyamanchal",
            "NP-BA": "Bagmati",
            "NP-JA": "Janakpur",
            "NP-NA": "Narayani",
            "NP-2": "Madhya Pashchimanchal",
            "NP-BH": "Bheri",
            "NP-KA": "Karnali",
            "NP-RA": "Rapti",
            "NP-3": "Pashchimanchal",
            "NP-DH": "Dhawalagiri",
            "NP-GA": "Gandaki",
            "NP-LU": "Lumbini",
            "NP-4": "Purwanchal",
            "NP-KO": "Kosi [Koshi]",
            "NP-ME": "Mechi",
            "NP-SA": "Sagarmatha",
            "NP-5": "Sudur Pashchimanchal",
            "NP-MA": "Mahakali",
            "NP-SE": "Seti"
        }
    },
    NL: {
        name: "Netherlands",
        divisions: {
            "NL-DR": "Drenthe",
            "NL-FL": "Flevoland",
            "NL-FR": "Friesland",
            "NL-GE": "Gelderland",
            "NL-GR": "Groningen",
            "NL-LI": "Limburg",
            "NL-NB": "Noord-Brabant",
            "NL-NH": "Noord-Holland",
            "NL-OV": "Overijssel",
            "NL-UT": "Utrecht",
            "NL-ZE": "Zeeland",
            "NL-ZH": "Zuid-Holland"
        }
    },
    AN: {
        name: "Netherlands Antilles",
        divisions: {
            "AN-AN": "Netherlands Antilles"
        }
    },
    NC: {
        name: "New Caledonia",
        divisions: {
            "NC-NC": "New Caledonia"
        }
    },
    NZ: {
        name: "New Zealand",
        divisions: {
            "NZ-N": "North Island",
            "NZ-AUK": "Auckland",
            "NZ-BOP": "Bay of Plenty",
            "NZ-GIS": "Gisborne",
            "NZ-HKB": "Hawkes's Bay",
            "NZ-MWT": "Manawatu-Wanganui",
            "NZ-NTL": "Northland",
            "NZ-TKI": "Taranaki",
            "NZ-WKO": "Waikato",
            "NZ-WGN": "Wellington",
            "NZ-S": "South Island",
            "NZ-CAN": "Canterbury",
            "NZ-MBH": "Marlborough",
            "NZ-NSN": "Nelson",
            "NZ-OTA": "Otago",
            "NZ-STL": "Southland",
            "NZ-TAS": "Tasman",
            "NZ-WTC": "West Coast"
        }
    },
    NI: {
        name: "Nicaragua",
        divisions: {
            "NI-BO": "Boaco",
            "NI-CA": "Carazo",
            "NI-CI": "Chinandega",
            "NI-CO": "Chontales",
            "NI-ES": "Estel\xed",
            "NI-GR": "Granada",
            "NI-JI": "Jinotega",
            "NI-LE": "Le\xf3n",
            "NI-MD": "Madriz",
            "NI-MN": "Manaqua",
            "NI-MS": "Masaya",
            "NI-MT": "Matagalpa",
            "NI-NS": "Nueva Segovia",
            "NI-SJ": "R\xedo San Juan",
            "NI-RI": "Rivas",
            "NI-ZE": "Zelaya"
        }
    },
    NE: {
        name: "Niger",
        divisions: {
            "NE-8": "Niamey",
            "NE-1": "Agadez",
            "NE-2": "Diffa",
            "NE-3": "Dosso",
            "NE-4": "Maradi",
            "NE-5": "Tahoua",
            "NE-6": "Tillaberi",
            "NE-7": "Zinder"
        }
    },
    NG: {
        name: "Nigeria",
        divisions: {
            "NG-FC": "Abuja Capital Territory",
            "NG-AB": "Abia",
            "NG-AD": "Adamawa",
            "NG-AK": "Akwa Ibom",
            "NG-AN": "Anambra",
            "NG-BA": "Bauchi",
            "NG-BE": "Benue",
            "NG-BO": "Borno",
            "NG-CR": "Cross River",
            "NG-DE": "Delta",
            "NG-ED": "Edo",
            "NG-EN": "Enugu",
            "NG-IM": "Imo",
            "NG-JI": "Jigawa",
            "NG-KD": "Kaduna",
            "NG-KN": "Kano",
            "NG-KT": "Katsina",
            "NG-KE": "Kebbi",
            "NG-KO": "Kogi",
            "NG-KW": "Kwara",
            "NG-LA": "Lagos",
            "NG-NI": "Niger",
            "NG-OG": "Ogun",
            "NG-ON": "Ondo",
            "NG-OS": "Osun",
            "NG-OY": "Oyo",
            "NG-PL": "Plateau",
            "NG-RI": "Rivers",
            "NG-SO": "Sokoto",
            "NG-TA": "Taraba",
            "NG-YO": "Yobe"
        }
    },
    NU: {
        name: "Niue",
        divisions: {
            "NU-NU": "Niue"
        }
    },
    NF: {
        name: "Norfolk Island",
        divisions: {
            "NF-NF": "Norfolk Island"
        }
    },
    MP: {
        name: "Northern Mariana Islands",
        divisions: {
            "MP-MP": "Northern Mariana Islands"
        }
    },
    NO: {
        name: "Norway",
        divisions: {
            "NO-02": "Akershus",
            "NO-09": "Aust-Agder",
            "NO-06": "Buskerud",
            "NO-20": "Finnmark",
            "NO-04": "Hedmark",
            "NO-12": "Hordaland",
            "NO-15": "M\xf8re og Romsdal",
            "NO-18": "Nordland",
            "NO-17": "Nord-Tr\xf8ndelag",
            "NO-05": "Oppland",
            "NO-03": "Oslo",
            "NO-11": "Rogaland",
            "NO-14": "Sogn og Fjordane",
            "NO-16": "S\xf8r-Tr\xf8ndelag",
            "NO-08": "Telemark",
            "NO-19": "Troms",
            "NO-10": "Vest-Agder",
            "NO-07": "Vestfold",
            "NO-01": "\xd8stfold",
            "NO-22": "Jan Mayen (Arctic Region)",
            "NO-21": "Svalbard (Arctic Region)"
        }
    },
    OM: {
        name: "Oman",
        divisions: {
            "OM-DA": "Ad Dākhilīyah",
            "OM-BA": "Al Bāţinah",
            "OM-JA": "Al Janūbīyah [Zufār]",
            "OM-WU": "Al Wusţā",
            "OM-SH": "Ash Sharqīyah",
            "OM-ZA": "Az Zāhirah",
            "OM-MA": "Masqaţ",
            "OM-MU": "Musandam"
        }
    },
    PK: {
        name: "Pakistan",
        divisions: {
            "PK-IS": "Islamabad",
            "PK-BA": "Baluchistan (Balochistān)",
            "PK-NW": "North-West Frontier",
            "PK-PB": "Punjab",
            "PK-SD": "Sind (Sindh)",
            "PK-TA": "Federally Administered Tribal Areas",
            "PK-JK": "Azad Kashmir",
            "PK-NA": "Northern Areas"
        }
    },
    PW: {
        name: "Palau",
        divisions: {
            "PW-PW": "Palau"
        }
    },
    PA: {
        name: "Panama",
        divisions: {
            "PA-1": "Botas del Toro",
            "PA-2": "Cocl\xe9",
            "PA-3": "Col\xf3n",
            "PA-4": "Chiriquī",
            "PA-5": "Dari\xe9n",
            "PA-6": "Herrera",
            "PA-7": "Los Santos",
            "PA-8": "Panam\xe1",
            "PA-9": "Veraguas",
            "PA-0": "Comarca de San Blas"
        }
    },
    PG: {
        name: "Papua New Guinea",
        divisions: {
            "PG-NCD": "National Capital District (Port Moresby)",
            "PG-CPM": "Central",
            "PG-CPK": "Chimbu",
            "PG-EHG": "Eastern Highlands",
            "PG-EBR": "East New Britain",
            "PG-ESW": "East Sepik",
            "PG-EPW": "Enga",
            "PG-GPK": "Gulf",
            "PG-MPM": "Madang",
            "PG-MRL": "Manus",
            "PG-MBA": "Milne Bay",
            "PG-MPL": "Morobe",
            "PG-NIK": "New Ireland",
            "PG-NPP": "Northern",
            "PG-NSA": "North Solomons",
            "PG-SAN": "Sandaun [West Sepik]",
            "PG-SHM": "Southern Highlands",
            "PG-WPD": "Western",
            "PG-WHM": "Western Highlands",
            "PG-WBK": "West New Britain"
        }
    },
    PY: {
        name: "Paraguay",
        divisions: {
            "PY-ASU": "Asunci\xf3n",
            "PY-16": "Alto Paraguay",
            "PY-10": "Alto Parang",
            "PY-13": "Amambay",
            "PY-19": "Boquer\xf3n",
            "PY-5": "Caaguaz\xfa",
            "PY-6": "Caazap\xe1",
            "PY-14": "Canindey\xfa",
            "PY-11": "Central",
            "PY-1": "Concepci\xf3n",
            "PY-3": "Cordillera",
            "PY-4": "Guair\xe1",
            "PY-7": "Itap\xfaa",
            "PY-8": "Misiones",
            "PY-12": "Neembuc\xfa",
            "PY-9": "Paraguarī",
            "PY-15": "Presidente Hayes",
            "PY-2": "San Pedro"
        }
    },
    PE: {
        name: "Peru",
        divisions: {
            "PE-CAL": "El Callao",
            "PE-AMA": "Amazonas",
            "PE-ANC": "Ancash",
            "PE-APU": "Apur\xedmac",
            "PE-ARE": "Arequipa",
            "PE-AYA": "Ayacucho",
            "PE-CAJ": "Cajamarca",
            "PE-CUS": "Cuzco [Cusco]",
            "PE-HUV": "Huancavelica",
            "PE-HUC": "Hu\xe1nuco",
            "PE-ICA": "Ica",
            "PE-JUN": "Jun\xedn",
            "PE-LAL": "La Libertad",
            "PE-LAM": "Lambayeque",
            "PE-LIM": "Lima",
            "PE-LOR": "Loreto",
            "PE-MDD": "Madre de Dios",
            "PE-MOQ": "Moquegua",
            "PE-PAS": "Pasco",
            "PE-PIU": "Piura",
            "PE-PUN": "Puno",
            "PE-SAM": "San Mart\xedn",
            "PE-TAC": "Tacna",
            "PE-TUM": "Tumbes",
            "PE-UCA": "Ucayali"
        }
    },
    PH: {
        name: "Philippines",
        divisions: {
            "PH-PH": "Philippines"
        }
    },
    PN: {
        name: "Pitcairn",
        divisions: {
            "PN-PN": "Pitcairn"
        }
    },
    PL: {
        name: "Poland",
        divisions: {
            "PL-BP": "Biała Podlaska",
            "PL-BK": "Białystok",
            "PL-BB": "Bielsko",
            "PL-BY": "Bydgoszcz",
            "PL-CH": "Chełm",
            "PL-CI": "Ciechan\xf3w",
            "PL-CZ": "Czestochowa",
            "PL-EL": "Elblag",
            "PL-GD": "Gdańsk",
            "PL-GO": "Gorz\xf3w",
            "PL-JG": "Jelenia Gera",
            "PL-KL": "Kalisz",
            "PL-KA": "Katowice",
            "PL-KI": "Kielce",
            "PL-KN": "Konin",
            "PL-KO": "Koszalin",
            "PL-KR": "Krak\xf3w",
            "PL-KS": "Krosno",
            "PL-LG": "Legnica",
            "PL-LE": "Leszno",
            "PL-LU": "Lublin",
            "PL-LO": "Łomia",
            "PL-LD": "Ł\xf3dź",
            "PL-NS": "Nowy Sacz",
            "PL-OL": "Olsztyn",
            "PL-OP": "Opole",
            "PL-OS": "Ostrołeka",
            "PL-PI": "Piła",
            "PL-PT": "Piotrk\xf3w",
            "PL-PL": "Płock",
            "PL-PO": "Poznań",
            "PL-PR": "Przemyśl",
            "PL-RA": "Radom",
            "PL-RZ": "Rzesz\xf3w",
            "PL-SE": "Siedlce",
            "PL-SI": "Sieradz",
            "PL-SK": "Skierniewice",
            "PL-SL": "Słupsk",
            "PL-SU": "Suwałki",
            "PL-SZ": "Szczecin",
            "PL-TG": "Tarnobrzeg",
            "PL-TA": "Tarn\xf3w",
            "PL-TO": "Toruń",
            "PL-WB": "Wałbrzych",
            "PL-WA": "Warszawa",
            "PL-WL": "Włocławek",
            "PL-WR": "Wrocław",
            "PL-ZA": "Zamość",
            "PL-ZG": "Zielona G\xf3ra"
        }
    },
    PT: {
        name: "Portugal",
        divisions: {
            "PT-01": "Aveiro",
            "PT-02": "Beja",
            "PT-03": "Braga",
            "PT-04": "Bragan\xe7a",
            "PT-05": "Castelo Branco",
            "PT-06": "Coimbra",
            "PT-07": "\xc9vora",
            "PT-08": "Faro",
            "PT-09": "Guarda",
            "PT-10": "Leiria",
            "PT-11": "Lisboa",
            "PT-12": "Portalegre",
            "PT-13": "Porto",
            "PT-14": "Santar\xe9m",
            "PT-15": "Set\xfabal",
            "PT-16": "Viana do Castelo",
            "PT-17": "Vila Real",
            "PT-18": "Viseu",
            "PT-20": "Regiāo Aut\xf3noma dos A\xe7ores",
            "PT-30": "Regiāo Aut\xf3noma da Madeira"
        }
    },
    PR: {
        name: "Puerto Rico",
        divisions: {
            "PR-PR": "Puerto Rico"
        }
    },
    QA: {
        name: "Qatar",
        divisions: {
            "QA-DA": "Ad Dawḩah",
            "QA-GH": "Al Ghuwayrīyah",
            "QA-JU": "Al Jumaylīyah",
            "QA-KH": "Al Khawr",
            "QA-WA": "Al Wakrah",
            "QA-RA": "Ar Rayyān",
            "QA-JB": "Jarīyān al Bāţnah",
            "QA-MS": "Madīnat ash Shamāl",
            "QA-US": "Umm Şalāl"
        }
    },
    RE: {
        name: "Reunion",
        divisions: {
            "RE-RE": "Reunion"
        }
    },
    RO: {
        name: "Romania",
        divisions: {
            "RO-B": "Bucureşti",
            "RO-AB": "Alba",
            "RO-AR": "Arad",
            "RO-AG": "Argeş",
            "RO-BC": "Bacău",
            "RO-BH": "Bihor",
            "RO-BN": "Bistriţa-Năsăud",
            "RO-BT": "Botoşani",
            "RO-BV": "Braşov",
            "RO-BR": "Brăila",
            "RO-BZ": "Buzău",
            "RO-CS": "Caraş-Severin",
            "RO-CL": "Călăraşi",
            "RO-CJ": "Cluj",
            "RO-CT": "Constanţa",
            "RO-CV": "Covasna",
            "RO-DB": "D\xe2mboviţa",
            "RO-DJ": "Dolj",
            "RO-GL": "Galaţi",
            "RO-GR": "Giurgiu",
            "RO-GJ": "Gorj",
            "RO-HR": "Harghita",
            "RO-HD": "Hunedoara",
            "RO-IL": "Ialomiţa",
            "RO-IS": "Iaşi",
            "RO-MM": "Maramureş",
            "RO-MH": "Mehedinţi",
            "RO-MS": "Mureş",
            "RO-NT": "Neamţ",
            "RO-OT": "Olt",
            "RO-PH": "Prahova",
            "RO-SM": "Satu Mare",
            "RO-SJ": "Sălaj",
            "RO-SB": "Sibiu",
            "RO-SV": "Suceava",
            "RO-TR": "Teleorman",
            "RO-TM": "Timiş",
            "RO-TL": "Tulcea",
            "RO-VS": "Vaslui",
            "RO-VL": "V\xe2lcea",
            "RO-VN": "Vrancea"
        }
    },
    RU: {
        name: "Russian Federation",
        divisions: {
            "RU-AD": "Adygeya, Respublika",
            "RU-AL": "Altay, Respublika",
            "RU-BA": "Bashkortostan, Respublika",
            "RU-BU": "Buryatiya, Respublika",
            "RU-CE": "Chechenskaya Respublika",
            "RU-CU": "Chuvashskaya Respublika",
            "RU-DA": "Dagestan, Respublika",
            "RU-IN": "Ingushskaya Respublika",
            "RU-KB": "Kabardino-Balkarskaya Respublika",
            "RU-KL": "Kalmykiya, Respublika",
            "RU-KC": "Karachayevo-Cherkesskaya Respublika",
            "RU-KR": "Kareliya, Respublika",
            "RU-KK": "Khakasiya, Respublika",
            "RU-KO": "Komi, Respublika",
            "RU-ME": "Mariy El, Respublika",
            "RU-MO": "Mordoviya, Respublika",
            "RU-SA": "Sakha, Respublika [Yakutiya]",
            "RU-SE": "Severnaya Osetiya, Respublika [Alaniya]",
            "RU-TA": "Tatarstan, Respublika",
            "RU-TY": "Tyva, Respublika [Tuva]",
            "RU-UD": "Udmurtskaya Respublika",
            "RU-ALT": "Altayskiy kray",
            "RU-KHA": "Khabarovskiy kray",
            "RU-KDA": "Krasnodarskiy kray",
            "RU-KYA": "Krasnoyarskiy kray",
            "RU-PRI": "Primorskiy kray",
            "RU-STA": "Stavropol 'skiy kray",
            "RU-AMU": "Amurskaya Oblast'",
            "RU-ARK": "Arkhangel'skaya Oblast'",
            "RU-AST": "Astrakhanskaya Oblast'",
            "RU-BEL": "Belgorodskaya Oblast'",
            "RU-BRY": "Bryanskaya Oblast'",
            "RU-CHE": "Chelyabinskaya Oblast'",
            "RU-CHI": "Chitinskaya Oblast'",
            "RU-IRK": "Irkutskaya Oblast'",
            "RU-IVA": "Ivanovskaya Oblast'",
            "RU-KGD": "Kaliningradskaya Oblast'",
            "RU-KLU": "Kaluzhskaya Oblast'",
            "RU-KAM": "Kamchatskaya Oblast'",
            "RU-KEM": "Kemerovskaya Oblast'",
            "RU-KIR": "Kirovskaya Oblast'",
            "RU-KOS": "Kostromskaya Oblast'",
            "RU-KGN": "Kurganskaya Oblast'",
            "RU-KRS": "Kurskaya Oblast'",
            "RU-LEN": "Leningradskaya Oblast'",
            "RU-LIP": "Lipetskaya Oblast'",
            "RU-MAG": "Magadanskaya Oblast'",
            "RU-MOS": "Moskovskaya Oblast'",
            "RU-MUR": "Murmanskaya Oblast'",
            "RU-NIZ": "Nizhegorodskaya Oblast'",
            "RU-NGR": "Novgorodskaya Oblast'",
            "RU-NVS": "Novosibirskaya Oblast'",
            "RU-OMS": "Omskaya Oblast'",
            "RU-ORE": "Orenburgskaya Oblast'",
            "RU-ORL": "Orlovskaya Oblast'",
            "RU-PNZ": "Penzenskaya Oblast'",
            "RU-PER": "Permskaya Oblast'",
            "RU-PSK": "Pskovskaya Oblast'",
            "RU-ROS": "Rostovskaya Oblast'",
            "RU-RYA": "Ryazanskaya Oblast'",
            "RU-SAK": "Sakhalinskaya Oblast'",
            "RU-SAM": "Samarskaya Oblast’",
            "RU-SAR": "Saratovskaya Oblast'",
            "RU-SMO": "Smolenskaya Oblast'",
            "RU-SVE": "Sverdlovskaya Oblast'",
            "RU-TAM": "Tambovskaya Oblast'",
            "RU-TOM": "Tomskaya Oblast’",
            "RU-TUL": "Tul'skaya Oblast'",
            "RU-TVE": "Tverskaya Oblast'",
            "RU-TYU": "Tyumenskaya Oblast'",
            "RU-ULY": "Ul'yanovskaya Oblast'",
            "RU-VLA": "Vladimirskaya Oblast'",
            "RU-VGG": "Volgogradskaya Oblast'",
            "RU-VLG": "Vologodskaya Oblast'",
            "RU-VOR": "Voronezhskaya Oblast'",
            "RU-YAR": "Yaroslavskaya Oblast'",
            "RU-MOW": "Moskva",
            "RU-SPE": "Sankt-Peterburg",
            "RU-YEV": "Yevreyskaya avtonomnaya oblast'",
            "RU-AGB": "Aginskiy Buryatskiy avtonomnyy okrug",
            "RU-CHU": "Chukotskiy avtonomnyy okrug",
            "RU-EVE": "Evenkiyskiy avtonomnyy okrug",
            "RU-KHM": "Khanty-Mansiyskiy avtonomnyy okrug",
            "RU-KOP": "Komi-Permyatskiy avtonomnyy okrug",
            "RU-KOR": "Koryakskiy avtonomnyy okrug",
            "RU-NEN": "Nenetskiy avtonomnyy okrug",
            "RU-TAY": "Taymyrskiy (Dolgano-Nenetskiy) avtonomnyy okrug",
            "RU-UOB": "Ust’-Ordynskiy Buryatskiy avtonomnyy okrug",
            "RU-YAN": "Yamalo-Nenetskiy avtonomnyy okrug"
        }
    },
    RW: {
        name: "Rwanda",
        divisions: {
            "RW-C": "Butare",
            "RW-I": "Byumba",
            "RW-E": "Cyangugu",
            "RW-D": "Gikongoro",
            "RW-G": "Gisenyi",
            "RW-B": "Gitarama",
            "RW-J": "Kibungo",
            "RW-F": "Kibuye",
            "RW-K": "Kigali-Rural (Kigali y’ Icyaro)",
            "RW-L": "Kigali-Ville (Kilgali Ngari)",
            "RW-M": "Mutara",
            "RW-H": "Ruhengeri"
        }
    },
    SH: {
        name: "St. Helena",
        divisions: {
            "SH-SH": "Saint Helena",
            "SH-AC": "Ascension",
            "SH-TA": "Tristan da Cunha"
        }
    },
    KN: {
        name: "Saint Kitts & Nevis",
        divisions: {
            "KN-KN": "Saint Kitts & Nevis"
        }
    },
    LC: {
        name: "Saint Lucia",
        divisions: {
            "LC-LC": "Saint Lucia"
        }
    },
    PM: {
        name: "St. Pierre & Miquelon",
        divisions: {
            "PM-PM": "St. Pierre & Miquelon"
        }
    },
    VC: {
        name: "St. Vincent & the Grenadines",
        divisions: {
            "VC-VC": "St. Vincent & the Grenadines"
        }
    },
    WS: {
        name: "Samoa",
        divisions: {
            "WS-AA": "A'ana",
            "WS-AL": "Aiga-i-le-Tai",
            "WS-AT": "Atua",
            "WS-FA": "Fa'asaleleaga",
            "WS-GE": "Gaga'emauga",
            "WS-GI": "Gagaifomauga",
            "WS-PA": "Palauli",
            "WS-SA": "Satupa'itea",
            "WS-TU": "Tuamasaga",
            "WS-VF": "Va'a-o-Fonoti",
            "WS-VS": "Vaisigano"
        }
    },
    SM: {
        name: "San Marino",
        divisions: {
            "SM-SM": "San Marino"
        }
    },
    ST: {
        name: "Sao Tome & Principe",
        divisions: {
            "ST-P": "Pr\xedncipe",
            "ST-S": "Sāo Tom\xe9"
        }
    },
    SA: {
        name: "Saudi Arabia",
        divisions: {
            "SA-11": "Al Bāḩah",
            "SA-08": "Al Ḩudūd ash Shamālīyah",
            "SA-12": "Al Jawf",
            "SA-03": "Al Madīnah",
            "SA-05": "Al Qaşim",
            "SA-O1": "Ar Riyāḑ",
            "SA-04": "Ash Sharqīyah",
            "SA-14": "‘Asīr",
            "SA-06": "Ḩā'il",
            "SA-09": "Jīzān",
            "SA-02": "Makkah",
            "SA-10": "Najrān",
            "SA-07": "Tabūk"
        }
    },
    SN: {
        name: "Senegal",
        divisions: {
            "SN-DK": "Dakar",
            "SN-DB": "Diourbel",
            "SN-FK": "Fatick",
            "SN-KL": "Kaolack",
            "SN-KD": "Kolda",
            "SN-LG": "Louga",
            "SN-SL": "Saint-Louis",
            "SN-TC": "Tambacounda",
            "SN-TH": "Thi\xe8s",
            "SN-ZG": "Ziguinchor"
        }
    },
    SC: {
        name: "Seychelles",
        divisions: {
            "SC-SC": "Seychelles"
        }
    },
    SL: {
        name: "Sierra Leone",
        divisions: {
            "SL-W": "Western Area (Freetown)",
            "SL-E": "Eastern",
            "SL-N": "Northern",
            "SL-S": "Southern"
        }
    },
    SG: {
        name: "Singapore",
        divisions: {
            "SG-SG": "Singapore"
        }
    },
    SK: {
        name: "Slovak Republic",
        divisions: {
            "SK-BC": "Banskobystrick\xfd kraj",
            "SK-BL": "Bratislavsk\xfd kraj",
            "SK-KI": "Košick\xfd kraj",
            "SK-NI": "Nitriansky kraj",
            "SK-PV": "Prešovsk\xfd kraj",
            "SK-TC": "Trenčiansky kraj",
            "SK-TA": "Trnavsk\xfd kraj",
            "SK-ZI": "Žilinsk\xfd kraj"
        }
    },
    SI: {
        name: "Slovenia",
        divisions: {
            "SI-07": "Dolenjska",
            "SI-09": "Gorenjska",
            "SI-11": "Goriška",
            "SI-03": "Koroška",
            "SI-10": "Notranjsko-kraška",
            "SI-12": "Obalno-kraška",
            "SI-08": "Osrednjeslovenska",
            "SI-02": "Podravska",
            "SI-01": "Pomurska",
            "SI-04": "Savinjska",
            "SI-06": "Spodnjeposavska",
            "SI-05": "Zasavska"
        }
    },
    SB: {
        name: "Solomon Islands",
        divisions: {
            "SB-CT": "Capital Territory (Honiara)",
            "SB-CE": "Central",
            "SB-GU": "Guadalcanal",
            "SB-IS": "Isabel",
            "SB-MK": "Makira",
            "SB-ML": "Malaita",
            "SB-TE": "Temotu",
            "SB-WE": "Western"
        }
    },
    SO: {
        name: "Somalia",
        divisions: {
            "SO-AW": "Awdal",
            "SO-BK": "Bakool",
            "SO-BN": "Banaadir",
            "SO-BR": "Bari",
            "SO-BY": "BaY",
            "SO-GA": "Galguduud",
            "SO-GE": "Gedo",
            "SO-HI": "Hiiraan",
            "SO-JD": "Jubbada Dhexe",
            "SO-JH": "Jubbada Hoose",
            "SO-MU": "Mudug",
            "SO-NU": "Nugaal",
            "SO-SA": "Sanaag",
            "SO-SD": "Shabeellaha Dhexe",
            "SO-SH": "Shabeellaha Hoose",
            "SO-SO": "Sool",
            "SO-TO": "Togdheer",
            "SO-WO": "Woqooyi Galbeed"
        }
    },
    ZA: {
        name: "South Africa",
        divisions: {
            "ZA-EC": "Eastern Cape (Oos-Kaap)",
            "ZA-FS": "Free State (Vrystaat)",
            "ZA-GT": "Gauteng",
            "ZA-NL": "Kwazulu-Natal",
            "ZA-MP": "Mpumalanga",
            "ZA-NC": "Northern Cape (Noord-Kaap)",
            "ZA-NP": "Northern Province (Noordelike Provinsie)",
            "ZA-NW": "North-West (Noord-Wes)",
            "ZA-WC": "Western Cape (Wes-Kaap)"
        }
    },
    GS: {
        name: "S.Georgia & S.Sandwich Islands",
        divisions: {
            "GS-GS": "S.Georgia & S.Sandwich Islands"
        }
    },
    ES: {
        name: "Spain",
        divisions: {
            "ES-AN": "Andaluc\xeda",
            "ES-AL": "Almer\xeda",
            "ES-CA": "C\xe1diz",
            "ES-CO": "C\xf3rdoba",
            "ES-GR": "Granada",
            "ES-H": "Huelva",
            "ES-J": "Ja\xe9n",
            "ES-MA": "M\xe1laga",
            "ES-SE": "Sevilla",
            "ES-AR": "Arag\xf3n",
            "ES-HU": "Huesca",
            "ES-TE": "Teruel",
            "ES-Z": "Zaragoza",
            "ES-O": "Asturias",
            "ES-CN": "Canarias",
            "ES-GC": "Las Palmas",
            "ES-TF": "Santa Cruz De Tenerife",
            "ES-S": "Cantabria",
            "ES-CM": "Castilla-La Mancha",
            "ES-AB": "Albacete",
            "ES-CR": "Ciudad Real",
            "ES-CU": "Cuenca",
            "ES-GU": "Guadalajara",
            "ES-TO": "Toledo",
            "ES-CL": "Castilla y Le\xf3n",
            "ES-AV": "\xc1vila",
            "ES-BU": "Burgos",
            "ES-LE": "Le\xf3n",
            "ES-P": "Palencia",
            "ES-SA": "Salamanca",
            "ES-SG": "Segovia",
            "ES-SO": "Soria",
            "ES-VA": "Valladolid",
            "ES-ZA": "Zamora",
            "ES-CT": "Catalu\xf1a",
            "ES-B": "Barcelona",
            "ES-GE": "Gerona",
            "ES-L": "L\xe9rida",
            "ES-T": "Tarragona",
            "ES-EX": "Extremadura",
            "ES-BA": "Badajoz",
            "ES-CC": "C\xe1ceres",
            "ES-GA": "Galicia",
            "ES-C": "La Coru\xf1a",
            "ES-LU": "Lugo",
            "ES-OR": "Orense",
            "ES-PO": "Pontevedra",
            "ES-PM": "Baleares",
            "ES-LO": "La Rioja",
            "ES-M": "Madrid",
            "ES-MU": "Murcia",
            "ES-NA": "Navarra",
            "ES-PV": "Pa\xeds Vasco",
            "ES-VI": "\xc1lava",
            "ES-SS": "Guip\xfazcoa",
            "ES-BI": "Vizcaya",
            "ES-VC": "Valenciana, Comunidad",
            "ES-A": "Alicante",
            "ES-CS": "Castell\xf3n",
            "ES-V": "Valencia"
        }
    },
    LK: {
        name: "Sri Lanka",
        divisions: {
            "LK-1": "Basnahira Palata (Western Province)",
            "LK-11": "Colombo",
            "LK-12": "Gampaha",
            "LK-13": "Kalutara",
            "LK-3": "Dakunu Palata (Southern Province)",
            "LK-31": "Galle",
            "LK-33": "Hambantota",
            "LK-32": "Matara",
            "LK-2": "Madhyama Palata (Central Province)",
            "LK-21": "Kandy",
            "LK-22": "Matale",
            "LK-23": "Nuwara Eliya",
            "LK-5": "Negenahira Palata (Eastern Province)",
            "LK-52": "Arnpara",
            "LK-51": "Batticaloa",
            "LK-53": "Trincomalee",
            "LK-9": "Sabaragamuwa Palata",
            "LK-92": "Kegalla",
            "LK-91": "Ratnapura",
            "LK-7": "Uturumeda Palata (North Central Province)",
            "LK-71": "Anuradhapura",
            "LK-72": "Polonnaruwa",
            "LK-4": "Uturu Palata (Northern Province)",
            "LK-41": "Jaffna",
            "LK-42": "Kilinochchi",
            "LK-43": "Mannar",
            "LK-45": "Mullaittivu",
            "LK-44": "Vavuniya",
            "LK-8": "Uva Palata",
            "LK-81": "Badulla",
            "LK-82": "Monaragala",
            "LK-6": "Wayamba Palata (North Western Province)",
            "LK-61": "Kurunegala",
            "LK-62": "Puttalam"
        }
    },
    SD: {
        name: "Sudan",
        divisions: {
            "SD-23": "A‘ālī an Nīl",
            "SD-26": "Al Baḩr al Aḩmar",
            "SD-18": "Al Buḩayrāt",
            "SD-07": "Al Jazīrah",
            "SD-03": "Al Kharţūm",
            "SD-06": "Al Qaḑārif",
            "SD-22": "Al Waḩdah",
            "SD-04": "An Nīl",
            "SD-08": "An Nīl al Abyaḑ",
            "SD-24": "An Nīl al Azraq",
            "SD-01": "Ash Shamālīyah",
            "SD-17": "Baḩr al Jabal",
            "SD-16": "Gharb al Istiwā'īyah",
            "SD-14": "Gharb Baḩr al Ghazāl",
            "SD-12": "Gharb Dārfūr",
            "SD-10": "Gharb Kurdufān",
            "SD-11": "Janūb Dārfūr",
            "SD-13": "Janūb Kurdufān",
            "SD-20": "Jūnqalī",
            "SD-05": "Kassalā",
            "SD-15": "Shamāl Baḩr al Ghazāl",
            "SD-02": "Shamāl Dārfūr",
            "SD-09": "Shamāl Kurdufān",
            "SD-19": "Sharq al Istiwā'iyah",
            "SD-25": "Sinnār",
            "SD-21": "Wārāb"
        }
    },
    SR: {
        name: "Suriname",
        divisions: {
            "SR-BR": "Brokopondo",
            "SR-CM": "Commewijne",
            "SR-CR": "Coronie",
            "SR-MA": "Marowijne",
            "SR-NI": "Nickerie",
            "SR-PR": "Para",
            "SR-PM": "Paramaribo",
            "SR-SA": "Saramacca",
            "SR-SI": "Sipaliwini",
            "SR-WA": "Wanica"
        }
    },
    SJ: {
        name: "Svalbard & Jan Mayen Islands",
        divisions: {
            "SJ-SJ": "Svalbard & Jan Mayen Islands"
        }
    },
    SZ: {
        name: "Swaziland",
        divisions: {
            "SZ-HH": "Hhohho",
            "SZ-LU": "Lubombo",
            "SZ-MA": "Manzini",
            "SZ-SH": "Shiselweni"
        }
    },
    SE: {
        name: "Sweden",
        divisions: {
            "SE-K": "Blekinge l\xe4n",
            "SE-W": "Dalarnas l\xe4n",
            "SE-I": "Gotlands l\xe4n",
            "SE-X": "G\xe4vleborgs l\xe4n",
            "SE-N": "Hallands l\xe4n",
            "SE-Z": "J\xe4mtlands l\xe4n",
            "SE-F": "J\xf6nk\xf6pings l\xe4n",
            "SE-H": "Kalmar l\xe4n",
            "SE-G": "Kronobergs l\xe4n",
            "SE-BD": "Norrbottens l\xe4n",
            "SE-M": "Sk\xe5ne l\xe4n",
            "SE-AB": "Stockholms l\xe4n",
            "SE-D": "S\xf6dermanlands l\xe4n",
            "SE-C": "Uppsala l\xe4n",
            "SE-S": "V\xe4rmlands l\xe4n",
            "SE-AC": "V\xe4sterbottens l\xe4n",
            "SE-Y": "V\xe4sternorrlands l\xe4n",
            "SE-U": "V\xe4stmanlands l\xe4n",
            "SE-O": "V\xe4stra G\xf6talands l\xe4n",
            "SE-T": "\xd6rebro l\xe4n",
            "SE-E": "\xd6sterg\xf6tlands l\xe4n"
        }
    },
    CH: {
        name: "Switzerland",
        divisions: {
            "CH-AG": "Aargau",
            "CH-AR": "Appenzell Ausserrhoden (de)",
            "CH-AI": "Appenzell Inner-Rhoden",
            "CH-BL": "Basel-Landschaft",
            "CH-BS": "Basel-Stadt",
            "CH-BE": "Bern",
            "CH-FR": "Freiburg",
            "CH-GE": "Geneve",
            "CH-GL": "Glarus",
            "CH-GR": "Graub\xfcnden",
            "CH-JU": "Jura",
            "CH-LU": "Luzern (de)",
            "CH-NE": "Neuchatel",
            "CH-NW": "Nidwalden",
            "CH-OW": "Obwalden",
            "CH-SG": "Sankt Gallen",
            "CH-SH": "Schaffhausen",
            "CH-SZ": "Schwyz",
            "CH-SO": "Solothurn",
            "CH-TG": "Thurgau",
            "CH-TI": "Ticino",
            "CH-UR": "Uri",
            "CH-VS": "Wallis",
            "CH-VD": "Vaud",
            "CH-ZG": "Zug (de)",
            "CH-ZH": "Z\xfcrich"
        }
    },
    SY: {
        name: "Syria",
        divisions: {
            "SY-HA": "Al Ḩasakah",
            "SY-LA": "Al Lādhiqīyah",
            "SY-QU": "Al Qunayţirah",
            "SY-RA": "Ar Raqqah",
            "SY-SU": "As Suwaydā'",
            "SY-DR": "Dar’ā",
            "SY-DY": "Dayr az Zawr",
            "SY-DI": "Dimashq",
            "SY-HL": "Ḩalab",
            "SY-HM": "Ḩamāh",
            "SY-HI": "Ḩimş",
            "SY-ID": "Idlib",
            "SY-RD": "Rīf Dimashq",
            "SY-TA": "Ţarţūs"
        }
    },
    TW: {
        name: "Taiwan",
        divisions: {
            "TW-KHH": "Kaohsiung",
            "TW-TPE": "Taipei",
            "TW-CYI": "Chiayi",
            "TW-HSZ": "Hsinchu",
            "TW-KEE": "Keelung",
            "TW-TXG": "Taichung",
            "TW-TNN": "Tainan",
            "TW-CHA": "Changhua",
            "TW-HUA": "Hualien",
            "TW-ILA": "Ilan",
            "TW-MIA": "Miaoli",
            "TW-NAN": "Nantou",
            "TW-PEN": "Penghu",
            "TW-PIF": "Pingtung",
            "TW-TTT": "Taitung",
            "TW-TAO": "Taoyuan",
            "TW-YUN": "Yunlin"
        }
    },
    TJ: {
        name: "Tajikistan",
        divisions: {
            "TJ-KR": "Karategin",
            "TJ-KT": "Khatlon",
            "TJ-LN": "Leninabad",
            "TJ-GB": "Gorno-Badakhshan"
        }
    },
    TZ: {
        name: "Tanzania",
        divisions: {
            "TZ-01": "Arusha",
            "TZ-02": "Dar-es-Salaam",
            "TZ-03": "Dodoma",
            "TZ-04": "Iringa",
            "TZ-05": "Kagera",
            "TZ-06": "Kaskazini Pemba (Pemba North)",
            "TZ-07": "Kaskazini Unguja (Zanzibar North)",
            "TZ-08": "Kigoma",
            "TZ-09": "Kilimanjaro",
            "TZ-10": "Kusini Pemba (Pemba South)",
            "TZ-11": "Kusini Unguja (Zanzibar South)",
            "TZ-12": "Lindi",
            "TZ-13": "Mara",
            "TZ-14": "Mbeya",
            "TZ-15": "Mjini Magharibi (Zanzibar West)",
            "TZ-16": "Morogoro",
            "TZ-17": "Mtwara",
            "TZ-18": "Mwanza",
            "TZ-19": "Pwani (Coast)",
            "TZ-20": "Rukwa",
            "TZ-21": "Ruvuma",
            "TZ-22": "Shinyanga",
            "TZ-23": "Singida",
            "TZ-24": "Tabora",
            "TZ-25": "Tanga"
        }
    },
    TH: {
        name: "Thailand",
        divisions: {
            "TH-10": "Krung Thep Maha Nakhon [Bangkok]",
            "TH-S": "Phatthaya",
            "TH-37": "Amnat Charoen",
            "TH-15": "Ang Thong",
            "TH-31": "Buri Ram",
            "TH-24": "Chachoengsao",
            "TH-18": "Chai Nat",
            "TH-36": "Chaiyaphum",
            "TH-22": "Chanthaburi",
            "TH-50": "Chiang Mai",
            "TH-57": "Chiang Rai",
            "TH-20": "Chon Buri",
            "TH-86": "Chumphon",
            "TH-46": "Kalasin",
            "TH-62": "Kamphaeng Phet",
            "TH-71": "Kanchanaburi",
            "TH-40": "Khon Kaen",
            "TH-81": "Krabi",
            "TH-52": "Lampang",
            "TH-51": "Lamphun",
            "TH-42": "Loei",
            "TH-16": "Lop Buri",
            "TH-58": "Mae Hong Son",
            "TH-44": "Maha Sarakham",
            "TH-49": "Mukdahan",
            "TH-26": "Nakhon Nayok",
            "TH-73": "Nakhon Pathom",
            "TH-48": "Nakhon Phanom",
            "TH-30": "Nakhon Ratchasima",
            "TH-60": "Nakhon Sawan",
            "TH-80": "Nakhon Si Thammarat",
            "TH-55": "Nan",
            "TH-96": "Narathiwat",
            "TH-39": "Nong Bua Lam Phu",
            "TH-43": "Nong Khai",
            "TH-12": "Nonthaburi",
            "TH-13": "Pathum Thani",
            "TH-94": "Pattani",
            "TH-82": "Phangnga",
            "TH-93": "Phatthalung",
            "TH-56": "Phayao",
            "TH-67": "Phetchabun",
            "TH-76": "Phetchaburi",
            "TH-66": "Phichit",
            "TH-65": "Phitsanulok",
            "TH-54": "Phrae",
            "TH-14": "Phra Nakhon Si Ayutthaya",
            "TH-83": "Phuket",
            "TH-25": "Prachin Buri",
            "TH-77": "Prachuap Khiri Khan",
            "TH-85": "Ranong",
            "TH-70": "Ratchaburi",
            "TH-21": "Rayong",
            "TH-45": "Roi Et",
            "TH-27": "Sa Kaeo",
            "TH-47": "Sakon Nakhon",
            "TH-11": "Samut Prakan",
            "TH-74": "Samut Sakhon",
            "TH-75": "Samut Songkhram",
            "TH-19": "Saraburi",
            "TH-91": "Satun",
            "TH-17": "Sing Buri",
            "TH-33": "Si Sa Ket",
            "TH-90": "Songkhla",
            "TH-64": "Sukhothai",
            "TH-72": "Suphan Buri",
            "TH-84": "Surat Thani",
            "TH-32": "Surin",
            "TH-63": "Tak",
            "TH-92": "Trang",
            "TH-23": "Trat",
            "TH-34": "Ubon Ratchathani",
            "TH-41": "Udon Thani",
            "TH-61": "Uthai Thani",
            "TH-53": "Uttaradit",
            "TH-95": "Yala",
            "TH-35": "Yasothon"
        }
    },
    TG: {
        name: "Togo",
        divisions: {
            "TG-C": "Centre",
            "TG-K": "Kara",
            "TG-M": "Maritime (R\xe9gion)",
            "TG-P": "Plateaux",
            "TG-S": "Savannes"
        }
    },
    TK: {
        name: "Tokelau",
        divisions: {
            "TK-TK": "Tokelau"
        }
    },
    TO: {
        name: "Tonga",
        divisions: {
            "TO-TO": "Tonga"
        }
    },
    TT: {
        name: "Trinidad & Tobago",
        divisions: {
            "TT-CTT": "Couva-Tabaquite-Talparo",
            "TT-DMN": "Diego Martin",
            "TT-ETO": "Eastern Tobago",
            "TT-PED": "Penal-Debe",
            "TT-PRT": "Princes Town",
            "TT-RCM": "Rio Claro-Mayaro",
            "TT-SGE": "Sangre Grande",
            "TT-SJL": "San Juan-Laventille",
            "TT-SIP": "Siparia",
            "TT-TUP": "Tunapuna-Piarco",
            "TT-WTO": "Western Tobago",
            "TT-ARI": "Arima",
            "TT-CHA": "Chaguanas",
            "TT-PTF": "Point Fortin",
            "TT-POS": "Port of Spain",
            "TT-SFO": "San Fernando"
        }
    },
    TN: {
        name: "Tunisia",
        divisions: {
            "TN-31": "B\xe9ja",
            "TN-13": "Ben Arous",
            "TN-23": "Bizerte",
            "TN-81": "Gab\xe8s",
            "TN-71": "Gafsa",
            "TN-32": "Jendouba",
            "TN-41": "Kairouan",
            "TN-42": "Kasserine",
            "TN-73": "Kebili",
            "TN-12": "L'Ariana",
            "TN-33": "Le Kef",
            "TN-53": "Mahdia",
            "TN-82": "Medenine",
            "TN-52": "Monastir",
            "TN-21": "Nabeul",
            "TN-61": "Sfax",
            "TN-43": "Sidi Bouzid",
            "TN-34": "Siliana",
            "TN-51": "Sousse",
            "TN-83": "Tataouine",
            "TN-72": "Tozeur",
            "TN-11": "Tunis",
            "TN-22": "Zaghouan"
        }
    },
    TR: {
        name: "Turkey",
        divisions: {
            "TR-01": "Adana",
            "TR-02": "Adiyaman",
            "TR-03": "Afyon",
            "TR-04": "Ağrı",
            "TR-68": "Aksaray",
            "TR-05": "Amasya",
            "TR-06": "Ankara",
            "TR-07": "Antalya",
            "TR-75": "Ardahan",
            "TR-08": "Artvin",
            "TR-09": "Aydin",
            "TR-10": "Balıkesir",
            "TR-74": "Bartın",
            "TR-72": "Batman",
            "TR-69": "Bayburt",
            "TR-11": "Bilecik",
            "TR-12": "Bing\xf6l",
            "TR-13": "Bitlis",
            "TR-14": "Bolu",
            "TR-15": "Burdur",
            "TR-16": "Bursa",
            "TR-17": "\xc7anakkale",
            "TR-18": "\xc7ankırı",
            "TR-19": "\xc7orum",
            "TR-20": "Denizli",
            "TR-21": "Diyarbakır",
            "TR-22": "Edirne",
            "TR-23": "Elaziğ",
            "TR-24": "Erzincan",
            "TR-25": "Erzurum",
            "TR-26": "Eskişehir",
            "TR-27": "Gaziantep",
            "TR-28": "Giresun",
            "TR-29": "G\xfcm\xfcşhane",
            "TR-30": "Hakkari",
            "TR-31": "Hatay",
            "TR-76": "Iğdir",
            "TR-32": "Isparta",
            "TR-33": "İ\xe7el",
            "TR-34": "İstanbul",
            "TR-35": "İzmir",
            "TR-46": "Kahramanmaraş",
            "TR-78": "Karab\xfck",
            "TR-70": "Karaman",
            "TR-36": "Kars",
            "TR-37": "Kastamonu",
            "TR-38": "Kayseri",
            "TR-71": "Kırıkkale",
            "TR-39": "Kırklareli",
            "TR-40": "Kırşehir",
            "TR-79": "Kilis",
            "TR-41": "Kocaeli",
            "TR-42": "Konya",
            "TR-43": "K\xfctahya",
            "TR-44": "Malatya",
            "TR-4S": "Manisa",
            "TR-47": "Mardin",
            "TR-48": "Muğla",
            "TR-49": "Muş",
            "TR-SO": "Nevşehir",
            "TR-51": "Niğde",
            "TR-52": "Ordu",
            "TR-53": "Rize",
            "TR-54": "Sakarya",
            "TR-SS": "Samsun",
            "TR-56": "Siirt",
            "TR-57": "Sinop",
            "TR-S8": "Sivas",
            "TR-63": "Şanlıurfa",
            "TR-73": "Şirnak",
            "TR-59": "Tekirdağ",
            "TR-60": "Tokat",
            "TR-61": "Trabzon",
            "TR-62": "Tunceli",
            "TR-64": "Uşak",
            "TR-65": "Van",
            "TR-77": "Yalova",
            "TR-66": "Yozgat",
            "TR-67": "Zonguldak"
        }
    },
    TM: {
        name: "Turkmenistan",
        divisions: {
            "TM-A": "Ahal",
            "TM-B": "Balkan",
            "TM-D": "Daşhowuz",
            "TM-L": "Lebap",
            "TM-M": "Mary"
        }
    },
    TC: {
        name: "Turks & Caicos Islands",
        divisions: {
            "TC-TC": "Turks & Caicos Islands"
        }
    },
    TV: {
        name: "Tuvalu",
        divisions: {
            "TV-TV": "Tuvalu"
        }
    },
    UG: {
        name: "Uganda",
        divisions: {
            "UG-APA": "Apac",
            "UG-ARU": "Arua",
            "UG-BUN": "Bundibugyo",
            "UG-BUS": "Bushenyi",
            "UG-GUL": "Gulu",
            "UG-HOI": "Hoima",
            "UG-IGA": "Iganga",
            "UG-JIN": "Jinja",
            "UG-KBL": "Kabale",
            "UG-KBR": "Kabarole",
            "UG-KLG": "Kalangala",
            "UG-KLA": "Kampala",
            "UG-KLI": "Kamuli",
            "UG-KAP": "Kapchorwa",
            "UG-KAS": "Kasese",
            "UG-KLE": "Kibaale",
            "UG-KIB": "Kiboga",
            "UG-KIS": "Kisoro",
            "UG-KIT": "Kitgum",
            "UG-KOT": "Kotido",
            "UG-KUM": "Kumi",
            "UG-LIR": "Lira",
            "UG-LUW": "Luwero",
            "UG-MSK": "Masaka",
            "UG-MSI": "Masindi",
            "UG-MBL": "Mbale",
            "UG-MBR": "Mbarara",
            "UG-MOR": "Moroto",
            "UG-MOY": "Moyo",
            "UG-MPI": "Mpigi",
            "UG-MUB": "Mubende",
            "UG-MUK": "Mukono",
            "UG-NEB": "Nebbi",
            "UG-NTU": "Ntungamo",
            "UG-PAL": "Pallisa",
            "UG-RAK": "Rakai",
            "UG-RUK": "Rukungiri",
            "UG-SOR": "Soroti",
            "UG-TOR": "Tororo"
        }
    },
    UA: {
        name: "Ukraine",
        divisions: {
            "UA-71": "Cherkas'ka Oblast'",
            "UA-74": "Chernihivs'ka Oblast'",
            "UA-77": "Chernivets'ka Oblast'",
            "UA-12": "Dnipropetrovs'ka Oblast'",
            "UA-14": "Donets'ka Oblast'",
            "UA-26": "Ivano-Frankivs'ka Oblast'",
            "UA-63": "Kharkivs'ka Oblast'",
            "UA-65": "Khersons'ka Oblast'",
            "UA-68": "Khmel'nyts'ka Oblast'",
            "UA-35": "Kirovohrads'ka Oblast'",
            "UA-32": "Ky\xefvs'ka Oblast'",
            "UA-09": "Luhans'ka Oblast'",
            "UA-46": "L'vivs'ka Oblast'",
            "UA-48": "Mykola\xefvs'ka Oblast'",
            "UA-51": "Odes'ka Oblast'",
            "UA-53": "Poltavs'ka Oblast'",
            "UA-56": "Rivnens'ka Oblast'",
            "UA-59": "Sums'ka Oblast'",
            "UA-61": "Ternopil's'ka Oblast'",
            "UA-05": "Vinnyts'ka Oblast'",
            "UA-07": "Volyns'ka Oblast'",
            "UA-21": "Zakarpats'ka Oblast'",
            "UA-23": "Zaporiz'ka Oblast'",
            "UA-18": "Zhytomyrs'ka Oblast'",
            "UA-43": "Respublika Krym",
            "UA-30": "Kyiv",
            "UA-40": "Sevastopol'"
        }
    },
    AE: {
        name: "United Arab Emirates",
        divisions: {
            "AE-AZ": "Abū Zaby (Abu Dhabi)",
            "AE-AJ": "‘Ajmān",
            "AE-FU": "Al Fujayrah",
            "AE-SH": "Ash Shāriqah (Sharjah)",
            "AE-DU": "Dubayy (Dubai)",
            "AE-RK": "R'as al Khaymah",
            "AE-UQ": "Umm al Qaywayn"
        }
    },
    US: {
        name: "United States",
        divisions: {
            "US-AL": "Alabama",
            "US-AK": "Alaska",
            "US-AZ": "Arizona",
            "US-AR": "Arkansas",
            "US-CA": "California",
            "US-CO": "Colorado",
            "US-CT": "Connecticut",
            "US-DE": "Delaware",
            "US-FL": "Florida",
            "US-GA": "Georgia",
            "US-HI": "Hawaii",
            "US-ID": "Idaho",
            "US-IL": "Illinois",
            "US-IN": "Indiana",
            "US-IA": "Iowa",
            "US-KS": "Kansas",
            "US-KY": "Kentucky",
            "US-LA": "Louisiana",
            "US-ME": "Maine",
            "US-MD": "Maryland",
            "US-MA": "Massachusetts",
            "US-MI": "Michigan",
            "US-MN": "Minnesota",
            "US-MS": "Mississippi",
            "US-MO": "Missouri",
            "US-MT": "Montana",
            "US-NE": "Nebraska",
            "US-NV": "Nevada",
            "US-NH": "New Hampshire",
            "US-NJ": "New Jersey",
            "US-NM": "New Mexico",
            "US-NY": "New York",
            "US-NC": "North Carolina",
            "US-ND": "North Dakota",
            "US-OH": "Ohio",
            "US-OK": "Oklahoma",
            "US-OR": "Oregon",
            "US-PA": "Pennsylvania",
            "US-RI": "Rhode Island",
            "US-SC": "South Carolina",
            "US-SD": "South Dakota",
            "US-TN": "Tennessee",
            "US-TX": "Texas",
            "US-UT": "Utah",
            "US-VT": "Vermont",
            "US-VA": "Virginia",
            "US-WA": "Washington",
            "US-WV": "West Virginia",
            "US-WI": "Wisconsin",
            "US-WY": "Wyoming",
            "US-DC": "District of Columbia",
            "US-AS": "American Samoa",
            "US-GU": "Guam",
            "US-MP": "Northern Mariana Islands",
            "US-PR": "Puerto Rico",
            "US-UM": "United States Minor Outlying Islands",
            "US-VI": "Virgin Islands, U.S.",
            "US-AE": "Armed Forces Europe",
            "US-AA": "Armed Forces Americas",
            "US-AP": "Armed Forces Pacific"
        }
    },
    UY: {
        name: "Uruguay",
        divisions: {
            "UY-AR": "Artigas",
            "UY-CA": "Canelones",
            "UY-CL": "Cerro Largo",
            "UY-CO": "Colonia",
            "UY-DU": "Durazno",
            "UY-FS": "Flores",
            "UY-FD": "Florida",
            "UY-LA": "Lavalleja",
            "UY-MA": "Maldonado",
            "UY-MO": "Montevideo",
            "UY-PA": "Paysand\xfa",
            "UY-RN": "R\xedo Negro",
            "UY-RV": "Rivera",
            "UY-RO": "Rocha",
            "UY-SA": "Salto",
            "UY-SJ": "San Jos\xe9",
            "UY-SO": "Soriano",
            "UY-TA": "Tacuaremb\xf3",
            "UY-TT": "Treinta y Tres"
        }
    },
    UZ: {
        name: "Uzbekistan",
        divisions: {
            "UZ-QR": "Qoraqalpoghiston Respublikasi (Karakalpakstan, Respublika)",
            "UZ-AN": "Andijon (Andizhan)",
            "UZ-BU": "Bukhoro (Bukhara)",
            "UZ-FA": "Farghona (Fergana)",
            "UZ-JI": "Jizzakh (Dzhizak)",
            "UZ-KH": "Khorazm (Khorezm)",
            "UZ-NG": "Namangan",
            "UZ-NW": "Nawoiy (Navoi)",
            "UZ-QA": "Qashqadaryo (Kashkadar'ya)",
            "UZ-SA": "Samarqand (Samarkand)",
            "UZ-SI": "Sirdaryo (Syrdar'ya)",
            "UZ-SU": "Surkhondaryo (Surkhandar'ya)",
            "UZ-TO": "Toshkent (Tashkent)"
        }
    },
    VU: {
        name: "Vanuatu",
        divisions: {
            "VU-MAP": "Malampa",
            "VU-PAM": "P\xe9nama",
            "VU-SAM": "Sanma",
            "VU-SEE": "Sh\xe9fa",
            "VU-TAE": "Taf\xe9a",
            "VU-TOB": "Torba"
        }
    },
    VE: {
        name: "Venezuela",
        divisions: {
            "VE-A": "Distrito Federal",
            "VE-B": "Anzo\xe1tegui",
            "VE-C": "Apure",
            "VE-D": "Aragua",
            "VE-E": "Barinas",
            "VE-F": "Bol\xedvar",
            "VE-G": "Carabobo",
            "VE-H": "Cojedes",
            "VE-I": "Falc\xf3n",
            "VE-J": "Gu\xe1rico",
            "VE-K": "Lara",
            "VE-L": "M\xe9rida",
            "VE-M": "Miranda",
            "VE-N": "Monagas",
            "VE-O": "Nueva Esparta",
            "VE-P": "Portuguesa",
            "VE-R": "Sucre",
            "VE-S": "T\xe1chira",
            "VE-T": "Trujillo",
            "VE-U": "Yaracuy",
            "VE-V": "Zulia",
            "VE-Z": "Amazonas",
            "VE-Y": "Delta Amacuro",
            "VE-W": "Dependencias Federales"
        }
    },
    VN: {
        name: "Vietnam",
        divisions: {
            "VN-44": "An Giang",
            "VN-53": "Bat Can",
            "VN-54": "Bat Giang",
            "VN-55": "Bat Lieu",
            "VN-56": "Bat Ninh",
            "VN-43": "Ba Ria - Vung Tau",
            "VN-50": "Ben Tre",
            "VN-31": "Binh Dinh",
            "VN-57": "Binh Duong",
            "VN-58": "Binh Phuoc",
            "VN-40": "Binh Thuan",
            "VN-59": "Ca Mau",
            "VN-48": "Can Tho",
            "VN-04": "Cao Bang",
            "VN-33": "Dac Lac",
            "VN-60": "Da Nang, thanh pho",
            "VN-39": "Dong Nai",
            "VN-45": "Dong Thap",
            "VN-30": "Gia Lai",
            "VN-03": "Ha Giang",
            "VN-61": "Hai Duong",
            "VN-62": "Hai Phong, thanh pho",
            "VN-63": "Ha Nam",
            "VN-64": "Ha Noi, thu do",
            "VN-15": "Ha Tay",
            "VN-23": "Ha Tinh",
            "VN-14": "Hoa Binh",
            "VN-65": "Ho Chi Minh, thanh po [Sai Gon]",
            "VN-66": "Hung Yen",
            "VN-34": "Khanh Hoa",
            "VN-47": "Kien Giang",
            "VN-28": "Kon Turn",
            "VN-01": "Lai Chau",
            "VN-35": "Lam Dong",
            "VN-09": "Lang Son",
            "VN-02": "Lao Cai",
            "VN-41": "Long An",
            "VN-67": "Nam Dinh",
            "VN-22": "Nghe An",
            "VN-18": "Ninh Binh",
            "VN-36": "Ninh Thuan",
            "VN-68": "Phu Tho",
            "VN-32": "Phu Yen",
            "VN-24": "Quang Ninh",
            "VN-27": "Quang Nam",
            "VN-29": "Quang Ngai",
            "VN-25": "Quang Tri",
            "VN-52": "Sec Trang",
            "VN-05": "Son La",
            "VN-37": "Tay Ninh",
            "VN-20": "Thai Binh",
            "VN-69": "Thai Nguyen",
            "VN-21": "Thanh Hoa",
            "VN-26": "Thua Thien-Hue",
            "VN-46": "Tien Giang",
            "VN-51": "Tra Vinh",
            "VN-07": "Tuyen Quang",
            "VN-49": "Vinh Long",
            "VN-70": "Vinh Yen",
            "VN-06": "Yen Bai"
        }
    },
    VG: {
        name: "Virgin Islands (British)",
        divisions: {
            "VG-VG": "Virgin Islands (British)"
        }
    },
    VI: {
        name: "Virgin Islands (U.S.)",
        divisions: {
            "VI-VI": "Virgin Islands (U.S.)"
        }
    },
    WF: {
        name: "Wallis & Futuna Islands",
        divisions: {
            "WF-WF": "Wallis & Futuna Islands"
        }
    },
    EH: {
        name: "Western Sahara",
        divisions: {
            "EH-EH": "Western Sahara"
        }
    },
    YE: {
        name: "Yemen",
        divisions: {
            "YE-AB": "Abyān",
            "YE-AD": "‘Adan",
            "YE-BA": "Al Bayḑā'",
            "YE-HU": "Al Ḩudaydah",
            "YE-JA": "Al Jawf",
            "YE-MR": "Al Mahrah",
            "YE-MW": "Al Maḩwit",
            "YE-DH": "Dhamār",
            "YE-HD": "Ḩaḑramawt",
            "YE-HJ": "Ḩajjah",
            "YE-IB": "Ibb",
            "YE-LA": "Laḩij",
            "YE-MA": "Ma'rib",
            "YE-SD": "Şa'dah",
            "YE-SN": "Şan‘ā'",
            "YE-SH": "Shabwah",
            "YE-TA": "Ta‘izz"
        }
    },
    YU: {
        name: "Yugoslavia",
        divisions: {
            "YU-CG": "Crna Gora",
            "YU-SR": "Srbija",
            "YU-KM": "Kosovo-Metohija",
            "YU-VO": "Vojvodina"
        }
    },
    ZM: {
        name: "Zambia",
        divisions: {
            "ZM-02": "Central",
            "ZM-08": "Copperbelt",
            "ZM-03": "Eastern",
            "ZM-04": "Luapula",
            "ZM-09": "Lusaka",
            "ZM-05": "Northern",
            "ZM-06": "North-Western",
            "ZM-07": "Southern",
            "ZM-01": "Western"
        }
    },
    ZW: {
        name: "Zimbabwe",
        divisions: {
            "ZW-BU": "Bulawayo",
            "ZW-HA": "Harare",
            "ZW-MA": "Manicaland",
            "ZW-MC": "Mashonaland Central",
            "ZW-ME": "Mashonaland East",
            "ZW-MW": "Mashonaland West",
            "ZW-MV": "Masvingo",
            "ZW-MN": "Matabeleland North",
            "ZW-MS": "Matabeleland South",
            "ZW-MI": "Midlands"
        }
    }
}, ma = ()=>{
    let e = new Map;
    for (let [n, i] of Object.entries(I))e.set(i.name.toUpperCase(), {
        code: n,
        divisions: i.divisions
    });
    return e;
}, Qe = ma(), Ra = [
    {
        name: "Afghanistan",
        dial_code: "+93",
        code: "AF"
    },
    {
        name: "Aland Islands",
        dial_code: "+358",
        code: "AX"
    },
    {
        name: "Albania",
        dial_code: "+355",
        code: "AL"
    },
    {
        name: "Algeria",
        dial_code: "+213",
        code: "DZ"
    },
    {
        name: "AmericanSamoa",
        dial_code: "+1684",
        code: "AS"
    },
    {
        name: "Andorra",
        dial_code: "+376",
        code: "AD"
    },
    {
        name: "Angola",
        dial_code: "+244",
        code: "AO"
    },
    {
        name: "Anguilla",
        dial_code: "+1264",
        code: "AI"
    },
    {
        name: "Antarctica",
        dial_code: "+672",
        code: "AQ"
    },
    {
        name: "Antigua and Barbuda",
        dial_code: "+1268",
        code: "AG"
    },
    {
        name: "Argentina",
        dial_code: "+54",
        code: "AR"
    },
    {
        name: "Armenia",
        dial_code: "+374",
        code: "AM"
    },
    {
        name: "Aruba",
        dial_code: "+297",
        code: "AW"
    },
    {
        name: "Australia",
        dial_code: "+61",
        code: "AU"
    },
    {
        name: "Austria",
        dial_code: "+43",
        code: "AT"
    },
    {
        name: "Azerbaijan",
        dial_code: "+994",
        code: "AZ"
    },
    {
        name: "Bahamas",
        dial_code: "+1242",
        code: "BS"
    },
    {
        name: "Bahrain",
        dial_code: "+973",
        code: "BH"
    },
    {
        name: "Bangladesh",
        dial_code: "+880",
        code: "BD"
    },
    {
        name: "Barbados",
        dial_code: "+1246",
        code: "BB"
    },
    {
        name: "Belarus",
        dial_code: "+375",
        code: "BY"
    },
    {
        name: "Belgium",
        dial_code: "+32",
        code: "BE"
    },
    {
        name: "Belize",
        dial_code: "+501",
        code: "BZ"
    },
    {
        name: "Benin",
        dial_code: "+229",
        code: "BJ"
    },
    {
        name: "Bermuda",
        dial_code: "+1441",
        code: "BM"
    },
    {
        name: "Bhutan",
        dial_code: "+975",
        code: "BT"
    },
    {
        name: "Bolivia, Plurinational State of",
        dial_code: "+591",
        code: "BO"
    },
    {
        name: "Bosnia and Herzegovina",
        dial_code: "+387",
        code: "BA"
    },
    {
        name: "Botswana",
        dial_code: "+267",
        code: "BW"
    },
    {
        name: "Brazil",
        dial_code: "+55",
        code: "BR"
    },
    {
        name: "British Indian Ocean Territory",
        dial_code: "+246",
        code: "IO"
    },
    {
        name: "Brunei Darussalam",
        dial_code: "+673",
        code: "BN"
    },
    {
        name: "Bulgaria",
        dial_code: "+359",
        code: "BG"
    },
    {
        name: "Burkina Faso",
        dial_code: "+226",
        code: "BF"
    },
    {
        name: "Burundi",
        dial_code: "+257",
        code: "BI"
    },
    {
        name: "Cambodia",
        dial_code: "+855",
        code: "KH"
    },
    {
        name: "Cameroon",
        dial_code: "+237",
        code: "CM"
    },
    {
        name: "Canada",
        dial_code: "+1",
        code: "CA"
    },
    {
        name: "Cape Verde",
        dial_code: "+238",
        code: "CV"
    },
    {
        name: "Cayman Islands",
        dial_code: "+ 345",
        code: "KY"
    },
    {
        name: "Central African Republic",
        dial_code: "+236",
        code: "CF"
    },
    {
        name: "Chad",
        dial_code: "+235",
        code: "TD"
    },
    {
        name: "Chile",
        dial_code: "+56",
        code: "CL"
    },
    {
        name: "China",
        dial_code: "+86",
        code: "CN"
    },
    {
        name: "Christmas Island",
        dial_code: "+61",
        code: "CX"
    },
    {
        name: "Cocos (Keeling) Islands",
        dial_code: "+61",
        code: "CC"
    },
    {
        name: "Colombia",
        dial_code: "+57",
        code: "CO"
    },
    {
        name: "Comoros",
        dial_code: "+269",
        code: "KM"
    },
    {
        name: "Congo",
        dial_code: "+242",
        code: "CG"
    },
    {
        name: "Congo, The Democratic Republic of the Congo",
        dial_code: "+243",
        code: "CD"
    },
    {
        name: "Cook Islands",
        dial_code: "+682",
        code: "CK"
    },
    {
        name: "Costa Rica",
        dial_code: "+506",
        code: "CR"
    },
    {
        name: "Cote d'Ivoire",
        dial_code: "+225",
        code: "CI"
    },
    {
        name: "Croatia",
        dial_code: "+385",
        code: "HR"
    },
    {
        name: "Cuba",
        dial_code: "+53",
        code: "CU"
    },
    {
        name: "Cyprus",
        dial_code: "+357",
        code: "CY"
    },
    {
        name: "Czech Republic",
        dial_code: "+420",
        code: "CZ"
    },
    {
        name: "Denmark",
        dial_code: "+45",
        code: "DK"
    },
    {
        name: "Djibouti",
        dial_code: "+253",
        code: "DJ"
    },
    {
        name: "Dominica",
        dial_code: "+1767",
        code: "DM"
    },
    {
        name: "Dominican Republic",
        dial_code: "+1849",
        code: "DO"
    },
    {
        name: "Ecuador",
        dial_code: "+593",
        code: "EC"
    },
    {
        name: "Egypt",
        dial_code: "+20",
        code: "EG"
    },
    {
        name: "El Salvador",
        dial_code: "+503",
        code: "SV"
    },
    {
        name: "Equatorial Guinea",
        dial_code: "+240",
        code: "GQ"
    },
    {
        name: "Eritrea",
        dial_code: "+291",
        code: "ER"
    },
    {
        name: "Estonia",
        dial_code: "+372",
        code: "EE"
    },
    {
        name: "Ethiopia",
        dial_code: "+251",
        code: "ET"
    },
    {
        name: "Falkland Islands (Malvinas)",
        dial_code: "+500",
        code: "FK"
    },
    {
        name: "Faroe Islands",
        dial_code: "+298",
        code: "FO"
    },
    {
        name: "Fiji",
        dial_code: "+679",
        code: "FJ"
    },
    {
        name: "Finland",
        dial_code: "+358",
        code: "FI"
    },
    {
        name: "France",
        dial_code: "+33",
        code: "FR"
    },
    {
        name: "French Guiana",
        dial_code: "+594",
        code: "GF"
    },
    {
        name: "French Polynesia",
        dial_code: "+689",
        code: "PF"
    },
    {
        name: "Gabon",
        dial_code: "+241",
        code: "GA"
    },
    {
        name: "Gambia",
        dial_code: "+220",
        code: "GM"
    },
    {
        name: "Georgia",
        dial_code: "+995",
        code: "GE"
    },
    {
        name: "Germany",
        dial_code: "+49",
        code: "DE"
    },
    {
        name: "Ghana",
        dial_code: "+233",
        code: "GH"
    },
    {
        name: "Gibraltar",
        dial_code: "+350",
        code: "GI"
    },
    {
        name: "Greece",
        dial_code: "+30",
        code: "GR"
    },
    {
        name: "Greenland",
        dial_code: "+299",
        code: "GL"
    },
    {
        name: "Grenada",
        dial_code: "+1473",
        code: "GD"
    },
    {
        name: "Guadeloupe",
        dial_code: "+590",
        code: "GP"
    },
    {
        name: "Guam",
        dial_code: "+1671",
        code: "GU"
    },
    {
        name: "Guatemala",
        dial_code: "+502",
        code: "GT"
    },
    {
        name: "Guernsey",
        dial_code: "+44",
        code: "GG"
    },
    {
        name: "Guinea",
        dial_code: "+224",
        code: "GN"
    },
    {
        name: "Guinea-Bissau",
        dial_code: "+245",
        code: "GW"
    },
    {
        name: "Guyana",
        dial_code: "+595",
        code: "GY"
    },
    {
        name: "Haiti",
        dial_code: "+509",
        code: "HT"
    },
    {
        name: "Holy See (Vatican City State)",
        dial_code: "+379",
        code: "VA"
    },
    {
        name: "Honduras",
        dial_code: "+504",
        code: "HN"
    },
    {
        name: "Hong Kong",
        dial_code: "+852",
        code: "HK"
    },
    {
        name: "Hungary",
        dial_code: "+36",
        code: "HU"
    },
    {
        name: "Iceland",
        dial_code: "+354",
        code: "IS"
    },
    {
        name: "India",
        dial_code: "+91",
        code: "IN"
    },
    {
        name: "Indonesia",
        dial_code: "+62",
        code: "ID"
    },
    {
        name: "Iran, Islamic Republic of Persian Gulf",
        dial_code: "+98",
        code: "IR"
    },
    {
        name: "Iraq",
        dial_code: "+964",
        code: "IQ"
    },
    {
        name: "Ireland",
        dial_code: "+353",
        code: "IE"
    },
    {
        name: "Isle of Man",
        dial_code: "+44",
        code: "IM"
    },
    {
        name: "Israel",
        dial_code: "+972",
        code: "IL"
    },
    {
        name: "Italy",
        dial_code: "+39",
        code: "IT"
    },
    {
        name: "Jamaica",
        dial_code: "+1876",
        code: "JM"
    },
    {
        name: "Japan",
        dial_code: "+81",
        code: "JP"
    },
    {
        name: "Jersey",
        dial_code: "+44",
        code: "JE"
    },
    {
        name: "Jordan",
        dial_code: "+962",
        code: "JO"
    },
    {
        name: "Kazakhstan",
        dial_code: "+77",
        code: "KZ"
    },
    {
        name: "Kenya",
        dial_code: "+254",
        code: "KE"
    },
    {
        name: "Kiribati",
        dial_code: "+686",
        code: "KI"
    },
    {
        name: "Korea, Democratic People's Republic of Korea",
        dial_code: "+850",
        code: "KP"
    },
    {
        name: "Korea, Republic of South Korea",
        dial_code: "+82",
        code: "KR"
    },
    {
        name: "Kuwait",
        dial_code: "+965",
        code: "KW"
    },
    {
        name: "Kyrgyzstan",
        dial_code: "+996",
        code: "KG"
    },
    {
        name: "Laos",
        dial_code: "+856",
        code: "LA"
    },
    {
        name: "Latvia",
        dial_code: "+371",
        code: "LV"
    },
    {
        name: "Lebanon",
        dial_code: "+961",
        code: "LB"
    },
    {
        name: "Lesotho",
        dial_code: "+266",
        code: "LS"
    },
    {
        name: "Liberia",
        dial_code: "+231",
        code: "LR"
    },
    {
        name: "Libyan Arab Jamahiriya",
        dial_code: "+218",
        code: "LY"
    },
    {
        name: "Liechtenstein",
        dial_code: "+423",
        code: "LI"
    },
    {
        name: "Lithuania",
        dial_code: "+370",
        code: "LT"
    },
    {
        name: "Luxembourg",
        dial_code: "+352",
        code: "LU"
    },
    {
        name: "Macao",
        dial_code: "+853",
        code: "MO"
    },
    {
        name: "Macedonia",
        dial_code: "+389",
        code: "MK"
    },
    {
        name: "Madagascar",
        dial_code: "+261",
        code: "MG"
    },
    {
        name: "Malawi",
        dial_code: "+265",
        code: "MW"
    },
    {
        name: "Malaysia",
        dial_code: "+60",
        code: "MY"
    },
    {
        name: "Maldives",
        dial_code: "+960",
        code: "MV"
    },
    {
        name: "Mali",
        dial_code: "+223",
        code: "ML"
    },
    {
        name: "Malta",
        dial_code: "+356",
        code: "MT"
    },
    {
        name: "Marshall Islands",
        dial_code: "+692",
        code: "MH"
    },
    {
        name: "Martinique",
        dial_code: "+596",
        code: "MQ"
    },
    {
        name: "Mauritania",
        dial_code: "+222",
        code: "MR"
    },
    {
        name: "Mauritius",
        dial_code: "+230",
        code: "MU"
    },
    {
        name: "Mayotte",
        dial_code: "+262",
        code: "YT"
    },
    {
        name: "Mexico",
        dial_code: "+52",
        code: "MX"
    },
    {
        name: "Micronesia, Federated States of Micronesia",
        dial_code: "+691",
        code: "FM"
    },
    {
        name: "Moldova",
        dial_code: "+373",
        code: "MD"
    },
    {
        name: "Monaco",
        dial_code: "+377",
        code: "MC"
    },
    {
        name: "Mongolia",
        dial_code: "+976",
        code: "MN"
    },
    {
        name: "Montenegro",
        dial_code: "+382",
        code: "ME"
    },
    {
        name: "Montserrat",
        dial_code: "+1664",
        code: "MS"
    },
    {
        name: "Morocco",
        dial_code: "+212",
        code: "MA"
    },
    {
        name: "Mozambique",
        dial_code: "+258",
        code: "MZ"
    },
    {
        name: "Myanmar",
        dial_code: "+95",
        code: "MM"
    },
    {
        name: "Namibia",
        dial_code: "+264",
        code: "NA"
    },
    {
        name: "Nauru",
        dial_code: "+674",
        code: "NR"
    },
    {
        name: "Nepal",
        dial_code: "+977",
        code: "NP"
    },
    {
        name: "Netherlands",
        dial_code: "+31",
        code: "NL"
    },
    {
        name: "Netherlands Antilles",
        dial_code: "+599",
        code: "AN"
    },
    {
        name: "New Caledonia",
        dial_code: "+687",
        code: "NC"
    },
    {
        name: "New Zealand",
        dial_code: "+64",
        code: "NZ"
    },
    {
        name: "Nicaragua",
        dial_code: "+505",
        code: "NI"
    },
    {
        name: "Niger",
        dial_code: "+227",
        code: "NE"
    },
    {
        name: "Nigeria",
        dial_code: "+234",
        code: "NG"
    },
    {
        name: "Niue",
        dial_code: "+683",
        code: "NU"
    },
    {
        name: "Norfolk Island",
        dial_code: "+672",
        code: "NF"
    },
    {
        name: "Northern Mariana Islands",
        dial_code: "+1670",
        code: "MP"
    },
    {
        name: "Norway",
        dial_code: "+47",
        code: "NO"
    },
    {
        name: "Oman",
        dial_code: "+968",
        code: "OM"
    },
    {
        name: "Pakistan",
        dial_code: "+92",
        code: "PK"
    },
    {
        name: "Palau",
        dial_code: "+680",
        code: "PW"
    },
    {
        name: "Palestinian Territory, Occupied",
        dial_code: "+970",
        code: "PS"
    },
    {
        name: "Panama",
        dial_code: "+507",
        code: "PA"
    },
    {
        name: "Papua New Guinea",
        dial_code: "+675",
        code: "PG"
    },
    {
        name: "Paraguay",
        dial_code: "+595",
        code: "PY"
    },
    {
        name: "Peru",
        dial_code: "+51",
        code: "PE"
    },
    {
        name: "Philippines",
        dial_code: "+63",
        code: "PH"
    },
    {
        name: "Pitcairn",
        dial_code: "+872",
        code: "PN"
    },
    {
        name: "Poland",
        dial_code: "+48",
        code: "PL"
    },
    {
        name: "Portugal",
        dial_code: "+351",
        code: "PT"
    },
    {
        name: "Puerto Rico",
        dial_code: "+1939",
        code: "PR"
    },
    {
        name: "Qatar",
        dial_code: "+974",
        code: "QA"
    },
    {
        name: "Romania",
        dial_code: "+40",
        code: "RO"
    },
    {
        name: "Russia",
        dial_code: "+7",
        code: "RU"
    },
    {
        name: "Rwanda",
        dial_code: "+250",
        code: "RW"
    },
    {
        name: "Reunion",
        dial_code: "+262",
        code: "RE"
    },
    {
        name: "Saint Barthelemy",
        dial_code: "+590",
        code: "BL"
    },
    {
        name: "Saint Helena, Ascension and Tristan Da Cunha",
        dial_code: "+290",
        code: "SH"
    },
    {
        name: "Saint Kitts and Nevis",
        dial_code: "+1869",
        code: "KN"
    },
    {
        name: "Saint Lucia",
        dial_code: "+1758",
        code: "LC"
    },
    {
        name: "Saint Martin",
        dial_code: "+590",
        code: "MF"
    },
    {
        name: "Saint Pierre and Miquelon",
        dial_code: "+508",
        code: "PM"
    },
    {
        name: "Saint Vincent and the Grenadines",
        dial_code: "+1784",
        code: "VC"
    },
    {
        name: "Samoa",
        dial_code: "+685",
        code: "WS"
    },
    {
        name: "San Marino",
        dial_code: "+378",
        code: "SM"
    },
    {
        name: "Sao Tome and Principe",
        dial_code: "+239",
        code: "ST"
    },
    {
        name: "Saudi Arabia",
        dial_code: "+966",
        code: "SA"
    },
    {
        name: "Senegal",
        dial_code: "+221",
        code: "SN"
    },
    {
        name: "Serbia",
        dial_code: "+381",
        code: "RS"
    },
    {
        name: "Seychelles",
        dial_code: "+248",
        code: "SC"
    },
    {
        name: "Sierra Leone",
        dial_code: "+232",
        code: "SL"
    },
    {
        name: "Singapore",
        dial_code: "+65",
        code: "SG"
    },
    {
        name: "Slovakia",
        dial_code: "+421",
        code: "SK"
    },
    {
        name: "Slovenia",
        dial_code: "+386",
        code: "SI"
    },
    {
        name: "Solomon Islands",
        dial_code: "+677",
        code: "SB"
    },
    {
        name: "Somalia",
        dial_code: "+252",
        code: "SO"
    },
    {
        name: "South Africa",
        dial_code: "+27",
        code: "ZA"
    },
    {
        name: "South Sudan",
        dial_code: "+211",
        code: "SS"
    },
    {
        name: "South Georgia and the South Sandwich Islands",
        dial_code: "+500",
        code: "GS"
    },
    {
        name: "Spain",
        dial_code: "+34",
        code: "ES"
    },
    {
        name: "Sri Lanka",
        dial_code: "+94",
        code: "LK"
    },
    {
        name: "Sudan",
        dial_code: "+249",
        code: "SD"
    },
    {
        name: "Suriname",
        dial_code: "+597",
        code: "SR"
    },
    {
        name: "Svalbard and Jan Mayen",
        dial_code: "+47",
        code: "SJ"
    },
    {
        name: "Swaziland",
        dial_code: "+268",
        code: "SZ"
    },
    {
        name: "Sweden",
        dial_code: "+46",
        code: "SE"
    },
    {
        name: "Switzerland",
        dial_code: "+41",
        code: "CH"
    },
    {
        name: "Syrian Arab Republic",
        dial_code: "+963",
        code: "SY"
    },
    {
        name: "Taiwan",
        dial_code: "+886",
        code: "TW"
    },
    {
        name: "Tajikistan",
        dial_code: "+992",
        code: "TJ"
    },
    {
        name: "Tanzania, United Republic of Tanzania",
        dial_code: "+255",
        code: "TZ"
    },
    {
        name: "Thailand",
        dial_code: "+66",
        code: "TH"
    },
    {
        name: "Timor-Leste",
        dial_code: "+670",
        code: "TL"
    },
    {
        name: "Togo",
        dial_code: "+228",
        code: "TG"
    },
    {
        name: "Tokelau",
        dial_code: "+690",
        code: "TK"
    },
    {
        name: "Tonga",
        dial_code: "+676",
        code: "TO"
    },
    {
        name: "Trinidad and Tobago",
        dial_code: "+1868",
        code: "TT"
    },
    {
        name: "Tunisia",
        dial_code: "+216",
        code: "TN"
    },
    {
        name: "Turkey",
        dial_code: "+90",
        code: "TR"
    },
    {
        name: "Turkmenistan",
        dial_code: "+993",
        code: "TM"
    },
    {
        name: "Turks and Caicos Islands",
        dial_code: "+1649",
        code: "TC"
    },
    {
        name: "Tuvalu",
        dial_code: "+688",
        code: "TV"
    },
    {
        name: "Uganda",
        dial_code: "+256",
        code: "UG"
    },
    {
        name: "Ukraine",
        dial_code: "+380",
        code: "UA"
    },
    {
        name: "United Arab Emirates",
        dial_code: "+971",
        code: "AE"
    },
    {
        name: "United Kingdom",
        dial_code: "+44",
        code: "GB"
    },
    {
        name: "United States",
        dial_code: "+1",
        code: "US"
    },
    {
        name: "Uruguay",
        dial_code: "+598",
        code: "UY"
    },
    {
        name: "Uzbekistan",
        dial_code: "+998",
        code: "UZ"
    },
    {
        name: "Vanuatu",
        dial_code: "+678",
        code: "VU"
    },
    {
        name: "Venezuela, Bolivarian Republic of Venezuela",
        dial_code: "+58",
        code: "VE"
    },
    {
        name: "Vietnam",
        dial_code: "+84",
        code: "VN"
    },
    {
        name: "Virgin Islands, British",
        dial_code: "+1284",
        code: "VG"
    },
    {
        name: "Virgin Islands, U.S.",
        dial_code: "+1340",
        code: "VI"
    },
    {
        name: "Wallis and Futuna",
        dial_code: "+681",
        code: "WF"
    },
    {
        name: "Yemen",
        dial_code: "+967",
        code: "YE"
    },
    {
        name: "Zambia",
        dial_code: "+260",
        code: "ZM"
    },
    {
        name: "Zimbabwe",
        dial_code: "+263",
        code: "ZW"
    }
], $e = Object.keys(I).map((e)=>({
        countryCode: e,
        name: I[e].name
    })).sort((e, n)=>e.name < n.name ? -1 : e.name > n.name ? 1 : 0), ca = ()=>{
    let e = [], n = [];
    return Ra.forEach((i)=>{
        let o = Number(i.dial_code.split("+")[1]);
        e.includes(o) || (e = [
            ...e,
            o
        ], n = [
            ...n,
            {
                countryCode: i.code,
                dialCode: o
            }
        ]);
    }), n.sort((i, o)=>i.dialCode < o.dialCode ? -1 : i.dialCode > o.dialCode ? 1 : 0);
}, an = ca();
var z = Object.keys(I), on = z.map((e)=>e.toLowerCase()), Ea = [
    "AF",
    "AL",
    "DZ",
    "AD",
    "AO",
    "AI",
    "AG",
    "AM",
    "BJ",
    "BT",
    "BV",
    "IO",
    "BN",
    "BF",
    "BI",
    "CX",
    "CK",
    "DM",
    "TP",
    "GQ",
    "FK",
    "FO",
    "GP",
    "GU",
    "HM",
    "LI",
    "MO",
    "MT",
    "MQ",
    "YT",
    "MS",
    "NR",
    "NC",
    "NU",
    "NF",
    "MP",
    "PW",
    "PN",
    "RE",
    "SC",
    "TK",
    "TO",
    "TV",
    "WF",
    "EH",
    "VU",
    "SZ",
    "SJ",
    "SR",
    "GS",
    "SB",
    "ST"
], rn = z.filter((e)=>!Ea.includes(e)).map((e)=>e.toLowerCase());
var ha = (e)=>new RegExp("^(?:[a-z]+:)?//", "i").test(e);
function ga(e, n) {
    var i;
    if (true) {
        var ref;
        let o = new URLSearchParams((ref = (i = window == null ? void 0 : window.location) == null ? void 0 : i.search) !== null && ref !== void 0 ? ref : "");
        for(let r in n)o.delete(r);
        return "".concat(e, "?").concat(o.toString());
    }
    return e;
}
function x(e) {
    return e.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
function Ca(e, n) {
    return x(Number(e / 100).toFixed(n || 0));
}
function Ia(e) {
    if (!e) return e;
    let n = e.replace(/[^\d]/, ""), i = n.length;
    return i < 4 ? n : i < 7 ? "(".concat(n.slice(0, 3), ") ").concat(n.slice(3)) : "(".concat(n.slice(0, 3), ") ").concat(n.slice(3, 6), "-").concat(n.slice(6, 10));
}
var { emailIsValid: pa , phoneIsValid: La , passwordIsValid: Ba , inputIsRequired: Ga , wordMatch: Pa , returnsTrue: Da  } = (U(), ea(J)), En = {
    emailValidator: pa,
    phoneValidator: La,
    passwordValidator: Ba,
    requiredValidator: Ga,
    passwordMatchValidator: Pa,
    optionalValidator: Da
};
exports.ACCOUNT_INFO = Me;
exports.ACCOUNT_INFO_ERRORS = Ae;
exports.ACCOUNT_INFO_STATE = le;
exports.AutomaticProductPlanChange = za;
exports.BILLING_INFO_ERRORS = Te;
exports.BILLING_INFO_STATE = Ne;
exports.CHECKOUT_COMPONENTS = ue;
exports.ComponentHandles = Ya;
exports.ComponentIDS = s;
exports.ComponentType = ie;
exports.DeepSleepSoftwarePricePoints = m;
exports.FIRST_COUNTRIES_SHOWN = Re;
exports.FocusSoftwarePricePoints = p;
exports.IgniteSoftwarePricePoints = T;
exports.InternationProductPlanOptions = Ja;
exports.IntlProductShippingOptions = $a;
exports.IntlSundriesShippingMap = qa;
exports.LifetimeProductHandles = xa;
exports.MastermindPricePoints = k;
exports.NuCalmLifetimePricePoints = K;
exports.NuCalmSubscriptionPricePoints = N;
exports.OneTimeShippingComponent = ee;
exports.PAYMENT_INFO_STATE = me;
exports.Plans = ka;
exports.ProductCancellation = Wa;
exports.ProductChangeHandle = t;
exports.ProductChangeMap = ae;
exports.ProductHandleDescriptionMap = Ka;
exports.ProductHandlePricingMap = Oa;
exports.ProductHandleRequiredComponents = wa;
exports.ProductHandleTitleMap = ya;
exports.ProductHandles = a;
exports.ProductPlanOptions = ja;
exports.ProductShippingOptions = Qa;
exports.Products = Ua;
exports.SHIPPING_COMPONENTS_IDS = ce;
exports.SHIPPING_INFO_STATE = Se;
exports.ShippingComponent = ne;
exports.ShippingSpeeds = na;
exports.StagingComponentIDS = d;
exports.StatusMessageMap = oe;
exports.SubscriptionState = g;
exports.SundriesShippingMap = Xa;
exports.checkChargifySupportsCard = ye;
exports.checkStepsComplete = xe;
exports.convertMsToTime = be;
exports.countries = I;
exports.countriesMap = Qe;
exports.countryCodes = z;
exports.countryCodesLowerCase = on;
exports.descendingPhoneCountryCodes = an;
exports.enrichLink = ga;
exports.extractOfferItems = De;
exports.extractProduct = _e;
exports.filteredCountryCodes = rn;
exports.formatCurrency = Ca;
exports.formatDate = ra;
exports.formatInfoForState = He;
exports.formatNumberCommas = x;
exports.formatPhoneNumber = Ia;
exports.formatStepName = F;
exports.formatString = Oe;
exports.formatToChargifyCardBrand = Ke;
exports.getUserErrors = Na;
exports.handleFirebaseAuthErrors = ze;
exports.isAbsoluteLink = ha;
exports.phoneCountryCodes = Ra;
exports.queryToParams = da;
exports.queryToString = ke;
exports.sortedCountriesArr = $e;
exports.utilMethod = En;


/***/ }),

/***/ 9359:
/***/ (function(__unused_webpack_module, exports) {



Object.defineProperty(exports, "__esModule", ({ value: true }));

var b=(t=>(t.Login="login",t.Signin="signin",t.Signup="signup",t))(b||{}),o=(r=>(r.CheckoutCompleted="checkoutCompleted",r.CheckoutStarted="checkoutStarted",r))(o||{}),M=(r=>(r.Default="DEFAULT",r.Kwik="KWIK",r))(M||{}),g=(t=>(t.EndingQuantity="ending_quantity",t.StartingQuantity="starting_quantity",t.UnitPrice="unit_price",t))(g||{}),u=(a=>(a.Ac="AC",a.Ad="AD",a.Ae="AE",a.Af="AF",a.Ag="AG",a.Ai="AI",a.Al="AL",a.Am="AM",a.An="AN",a.Ao="AO",a.Ar="AR",a.At="AT",a.Au="AU",a.Aw="AW",a.Ax="AX",a.Az="AZ",a.Ba="BA",a.Bb="BB",a.Bd="BD",a.Be="BE",a.Bf="BF",a.Bg="BG",a.Bh="BH",a.Bi="BI",a.Bj="BJ",a.Bl="BL",a.Bm="BM",a.Bn="BN",a.Bo="BO",a.Bq="BQ",a.Br="BR",a.Bs="BS",a.Bt="BT",a.Bv="BV",a.Bw="BW",a.By="BY",a.Bz="BZ",a.Ca="CA",a.Cc="CC",a.Cd="CD",a.Cf="CF",a.Cg="CG",a.Ch="CH",a.Ci="CI",a.Ck="CK",a.Cl="CL",a.Cm="CM",a.Cn="CN",a.Co="CO",a.Cr="CR",a.Cu="CU",a.Cv="CV",a.Cw="CW",a.Cx="CX",a.Cy="CY",a.Cz="CZ",a.De="DE",a.Dj="DJ",a.Dk="DK",a.Dm="DM",a.Do="DO",a.Dz="DZ",a.Ec="EC",a.Ee="EE",a.Eg="EG",a.Eh="EH",a.Er="ER",a.Es="ES",a.Et="ET",a.Fi="FI",a.Fj="FJ",a.Fk="FK",a.Fo="FO",a.Fr="FR",a.Ga="GA",a.Gb="GB",a.Gd="GD",a.Ge="GE",a.Gf="GF",a.Gg="GG",a.Gh="GH",a.Gi="GI",a.Gl="GL",a.Gm="GM",a.Gn="GN",a.Gp="GP",a.Gq="GQ",a.Gr="GR",a.Gs="GS",a.Gt="GT",a.Gw="GW",a.Gy="GY",a.Hk="HK",a.Hm="HM",a.Hn="HN",a.Hr="HR",a.Ht="HT",a.Hu="HU",a.Id="ID",a.Ie="IE",a.Il="IL",a.Im="IM",a.In="IN",a.Io="IO",a.Iq="IQ",a.Ir="IR",a.Is="IS",a.It="IT",a.Je="JE",a.Jm="JM",a.Jo="JO",a.Jp="JP",a.Ke="KE",a.Kg="KG",a.Kh="KH",a.Ki="KI",a.Km="KM",a.Kn="KN",a.Kp="KP",a.Kr="KR",a.Kw="KW",a.Ky="KY",a.Kz="KZ",a.La="LA",a.Lb="LB",a.Lc="LC",a.Li="LI",a.Lk="LK",a.Lr="LR",a.Ls="LS",a.Lt="LT",a.Lu="LU",a.Lv="LV",a.Ly="LY",a.Ma="MA",a.Mc="MC",a.Md="MD",a.Me="ME",a.Mf="MF",a.Mg="MG",a.Mk="MK",a.Ml="ML",a.Mm="MM",a.Mn="MN",a.Mo="MO",a.Mq="MQ",a.Mr="MR",a.Ms="MS",a.Mt="MT",a.Mu="MU",a.Mv="MV",a.Mw="MW",a.Mx="MX",a.My="MY",a.Mz="MZ",a.Na="NA",a.Nc="NC",a.Ne="NE",a.Nf="NF",a.Ng="NG",a.Ni="NI",a.Nl="NL",a.No="NO",a.Np="NP",a.Nr="NR",a.Nu="NU",a.Nz="NZ",a.Om="OM",a.Pa="PA",a.Pe="PE",a.Pf="PF",a.Pg="PG",a.Ph="PH",a.Pk="PK",a.Pl="PL",a.Pm="PM",a.Pn="PN",a.Ps="PS",a.Pt="PT",a.Py="PY",a.Qa="QA",a.Re="RE",a.Ro="RO",a.Rs="RS",a.Ru="RU",a.Rw="RW",a.Sa="SA",a.Sb="SB",a.Sc="SC",a.Sd="SD",a.Se="SE",a.Sg="SG",a.Sh="SH",a.Si="SI",a.Sj="SJ",a.Sk="SK",a.Sl="SL",a.Sm="SM",a.Sn="SN",a.So="SO",a.Sr="SR",a.Ss="SS",a.St="ST",a.Sv="SV",a.Sx="SX",a.Sy="SY",a.Sz="SZ",a.Ta="TA",a.Tc="TC",a.Td="TD",a.Tf="TF",a.Tg="TG",a.Th="TH",a.Tj="TJ",a.Tk="TK",a.Tl="TL",a.Tm="TM",a.Tn="TN",a.To="TO",a.Tr="TR",a.Tt="TT",a.Tv="TV",a.Tw="TW",a.Tz="TZ",a.Ua="UA",a.Ug="UG",a.Um="UM",a.Us="US",a.Uy="UY",a.Uz="UZ",a.Va="VA",a.Vc="VC",a.Ve="VE",a.Vg="VG",a.Vn="VN",a.Vu="VU",a.Wf="WF",a.Ws="WS",a.Xk="XK",a.Ye="YE",a.Yt="YT",a.Za="ZA",a.Zm="ZM",a.Zw="ZW",a.Zz="ZZ",a))(u||{}),_=(e=>(e.Aed="aed",e.Afn="afn",e.All="all",e.Amd="amd",e.Ang="ang",e.Aoa="aoa",e.Ars="ars",e.Aud="aud",e.Awg="awg",e.Azn="azn",e.Bam="bam",e.Bbd="bbd",e.Bdt="bdt",e.Bgn="bgn",e.Bhd="bhd",e.Bif="bif",e.Bmd="bmd",e.Bnd="bnd",e.Bob="bob",e.Brl="brl",e.Bsd="bsd",e.Btn="btn",e.Bwp="bwp",e.Byn="byn",e.Bzd="bzd",e.Cad="cad",e.Cdf="cdf",e.Chf="chf",e.Clp="clp",e.Cny="cny",e.Cop="cop",e.Crc="crc",e.Cve="cve",e.Czk="czk",e.Djf="djf",e.Dkk="dkk",e.Dop="dop",e.Dzd="dzd",e.Eek="eek",e.Egp="egp",e.Etb="etb",e.Eur="eur",e.Fjd="fjd",e.Fkp="fkp",e.Gbp="gbp",e.Gel="gel",e.Ghs="ghs",e.Gip="gip",e.Gmd="gmd",e.Gnf="gnf",e.Gtq="gtq",e.Gyd="gyd",e.Hkd="hkd",e.Hnl="hnl",e.Hrk="hrk",e.Htg="htg",e.Huf="huf",e.Idr="idr",e.Ils="ils",e.Inr="inr",e.Isk="isk",e.Jmd="jmd",e.Jod="jod",e.Jpy="jpy",e.Kes="kes",e.Kgs="kgs",e.Khr="khr",e.Kmf="kmf",e.Krw="krw",e.Kwd="kwd",e.Kyd="kyd",e.Kzt="kzt",e.Lak="lak",e.Lbp="lbp",e.Lkr="lkr",e.Lrd="lrd",e.Lsl="lsl",e.Ltl="ltl",e.Lvl="lvl",e.Mad="mad",e.Mdl="mdl",e.Mga="mga",e.Mkd="mkd",e.Mmk="mmk",e.Mnt="mnt",e.Mop="mop",e.Mro="mro",e.Mur="mur",e.Mvr="mvr",e.Mwk="mwk",e.Mxn="mxn",e.Myr="myr",e.Mzn="mzn",e.Nad="nad",e.Ngn="ngn",e.Nio="nio",e.Nok="nok",e.Npr="npr",e.Nzd="nzd",e.Omr="omr",e.Pab="pab",e.Pen="pen",e.Pgk="pgk",e.Php="php",e.Pkr="pkr",e.Pln="pln",e.Pyg="pyg",e.Qar="qar",e.Ron="ron",e.Rsd="rsd",e.Rub="rub",e.Rwf="rwf",e.Sar="sar",e.Sbd="sbd",e.Scr="scr",e.Sek="sek",e.Sgd="sgd",e.Shp="shp",e.Sll="sll",e.Sos="sos",e.Srd="srd",e.Std="std",e.Svc="svc",e.Szl="szl",e.Thb="thb",e.Tjs="tjs",e.Tnd="tnd",e.Top="top",e.Try="try",e.Ttd="ttd",e.Twd="twd",e.Tzs="tzs",e.Uah="uah",e.Ugx="ugx",e.Usd="usd",e.Usdc="usdc",e.Uyu="uyu",e.Uzs="uzs",e.Vef="vef",e.Vnd="vnd",e.Vuv="vuv",e.Wst="wst",e.Xaf="xaf",e.Xcd="xcd",e.Xof="xof",e.Xpf="xpf",e.Yer="yer",e.Zar="zar",e.Zmw="zmw",e))(_||{}),m=(s=>(s.PerUnit="per_unit",s.Stairstep="stairstep",s.Tiered="tiered",s.Volume="volume",s))(m||{}),d=(t=>(t.Day="day",t.Month="month",t.Never="never",t))(d||{}),I=(r=>(r.Day="day",r.Month="month",r))(I||{}),f=(r=>(r.Automatic="automatic",r.Remittance="remittance",r))(f||{}),x=(t=>(t.Child="child",t.None="none",t.Parent="parent",t))(x||{}),A=(c=>(c.Cancelled="cancelled",c.Draft="draft",c.Open="open",c.Paid="paid",c.Pending="pending",c.Voided="voided",c))(A||{}),P=(r=>(r.JourneyCompleted="journeyCompleted",r.JourneyStarted="journeyStarted",r))(P||{}),v=(r=>(r.No="no",r.Yes="yes",r))(v||{}),h=(s=>(s.Apple="apple",s.EmailPassword="emailPassword",s.Facebook="facebook",s.Google="google",s))(h||{}),k=(p=>(p.Deepsleep="deepsleep",p.Focus="focus",p.Ignite="ignite",p.Kwikstate="kwikstate",p.Reboot="reboot",p.Recharge="recharge",p.Rescue="rescue",p))(k||{}),B=(r=>(r.Explicit="explicit",r.Mature="mature",r))(B||{}),R=(y=>(y.PaymentInfoEntered="paymentInfoEntered",y))(R||{}),w=(l=>(l.AmericanExpress="american_express",l.Bogus="bogus",l.Dankort="dankort",l.DinersClub="diners_club",l.Discover="discover",l.Forbrugsforeningen="forbrugsforeningen",l.Jcb="jcb",l.Laser="laser",l.Maestro="maestro",l.Master="master",l.Solo="solo",l.Switch="switch",l.Visa="visa",l))(w||{}),U=(n=>(n.Authorizenet="authorizenet",n.Beanstream="beanstream",n.Bogus="bogus",n.BraintreeBlue="braintree_blue",n.Eway="eway",n.PaymentExpress="payment_express",n.Paypal="paypal",n.Quickpay="quickpay",n.Stripe="stripe",n.StripeConnect="stripe_connect",n.TrustCommerce="trust_commerce",n.Wirecard="wirecard",n))(U||{}),L=(t=>(t.BankAccount="bank_account",t.CreditCard="credit_card",t.PaypalAccount="paypal_account",t))(L||{}),T=(t=>(t.Active="active",t.Inactive="inactive",t.None="none",t))(T||{}),D=(s=>(s.Basic="basic",s.Free="free",s.Lifetime="lifetime",s.Premium="premium",s))(D||{}),N=(r=>(r.CreatedAt="created_at",r.UpdatedAt="updated_at",r))(N||{}),E=(r=>(r.Kwikstate="kwikstate",r.Nucalm="nucalm",r))(E||{}),F=(i=>(i.DemoMonthly="demo_monthly",i.FamilyMonthly="family_monthly",i.KwikstateAnnual="kwikstate_annual",i.LifetimeLifetimeNucalm="lifetime_lifetime_nucalm",i.MastermindFiveyearsNucalm="mastermind_fiveyears_nucalm",i.MastermindFiveyearsPro="mastermind_fiveyears_pro",i.MastermindLifetimeNucalm="mastermind_lifetime_nucalm",i.MastermindLifetimePro="mastermind_lifetime_pro",i.MilitaryLifetimeNucalm="military_lifetime_nucalm",i.NucalmDeepsleepSoftwareMonthly="nucalm_deepsleep_software_monthly",i.Premium_6month="premium_6month",i.PremiumAnnual="premium_annual",i.PremiumFamilyMonthly="premium_family_monthly",i.PremiumMonthly="premium_monthly",i.PremiumPro_2year="premium_pro_2year",i.PremiumSoftware_12months="premium_software_12months",i.Pro_2year="pro_2year",i.ProLifetimeNucalm="pro_lifetime_nucalm",i.ProMonthly="pro_monthly",i.StandardAnnual="standard_annual",i.StandardMonthly="standard_monthly",i))(F||{}),G=(t=>(t.Delayed="delayed",t.Immediate="immediate",t.Prorated="prorated",t))(G||{}),z=(s=>(s.StepCompleted="stepCompleted",s.StepUpdateCompleted="stepUpdateCompleted",s.StepUpdating="stepUpdating",s.StepViewed="stepViewed",s))(z||{}),K=(S=>(S.ActivatedAt="activated_at",S.CanceledAt="canceled_at",S.CreatedAt="created_at",S.CurrentPeriodEndsAt="current_period_ends_at",S.CurrentPeriodStartsAt="current_period_starts_at",S.ExpiresAt="expires_at",S.TrialEndedAt="trial_ended_at",S.TrialStartedAt="trial_started_at",S.UpdatedAt="updated_at",S))(K||{}),Q=(t=>(t.Automatic="automatic",t.Prepaid="prepaid",t.Remittance="remittance",t))(Q||{}),O=(c=>(c.CreatedAt="created_at",c.NextAssessment="next_assessment",c.PeriodEnd="period_end",c.PeriodStart="period_start",c.SignupDate="signup_date",c.UpdatedAt="updated_at",c))(O||{}),q=(n=>(n.Active="active",n.Canceled="canceled",n.Expired="expired",n.ExpiredCards="expired_cards",n.OnHold="on_hold",n.PastDue="past_due",n.PendingCancellation="pending_cancellation",n.PendingRenewal="pending_renewal",n.Suspended="suspended",n.TrialEnded="trial_ended",n.Trialing="trialing",n.Unpaid="unpaid",n))(q||{});

exports.AuthAnalyticsType = b;
exports.CheckoutAnalyticsType = o;
exports.Client = M;
exports.ComponentCustomPricePrices = g;
exports.CountryCode = u;
exports.CurrencyCode = _;
exports.CustomPriceScheme = m;
exports.ExpirationIntervalUnit = d;
exports.IntervalUnit = I;
exports.InvoiceCollectionMethod = f;
exports.InvoiceConsolidationLevel = x;
exports.InvoiceStatus = A;
exports.JourneyAnalyticsType = P;
exports.JourneyRepeatedType = v;
exports.LoginMethods = h;
exports.ManifestJourney = k;
exports.ManifestMaturityRatings = B;
exports.PaymentAnalyticsType = R;
exports.PaymentProfileCardTypes = w;
exports.PaymentProfileCurrentVault = U;
exports.PaymentType = L;
exports.PlanStatus = T;
exports.Plans = D;
exports.ProductFamilyDateField = N;
exports.ProductFamilyHandle = E;
exports.ProductHandle = F;
exports.ReactivationCharge = G;
exports.StepAnalyticsType = z;
exports.SubscriptionDateField = K;
exports.SubscriptionPaymentCollectionMethod = Q;
exports.SubscriptionSortKeys = O;
exports.SubscriptionState = q;


/***/ }),

/***/ 19121:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var c=Object.defineProperty;var R=Object.getOwnPropertyDescriptor;var N=Object.getOwnPropertyNames;var S=Object.prototype.hasOwnProperty;var D=(a,e)=>{for(var i in e)c(a,i,{get:e[i],enumerable:!0})},y=(a,e,i,A)=>{if(e&&typeof e=="object"||typeof e=="function")for(let n of N(e))!S.call(a,n)&&n!==i&&c(a,n,{get:()=>e[n],enumerable:!(A=R(e,n))||A.enumerable});return a};var _=a=>y(c({},"__esModule",{value:!0}),a);var M={};D(M,{chargifyErrorCodes:()=>m,chargifyErrorsMap:()=>u,checkoutErrorCodes:()=>r,checkoutErrorsMap:()=>l,discPurchaseErrorCodes:()=>E,discPurchaseErrorMap:()=>h,errorCodeToMessage:()=>b,firebaseAuthErrors:()=>U,firebaseCodeErrors:()=>o,firebaseCodeErrorsMap:()=>f,formCodeErrors:()=>s,formErrorsMap:()=>I,genericErrorCodes:()=>d,genericErrorsMap:()=>P,pageErrorCodes:()=>T,pageErrorsMap:()=>g,shippingErrorCodes:()=>C,shippingErrorsMap:()=>O,subscriptionErrorCodes:()=>p,subscriptionErrorsMap:()=>v});module.exports=_(M);var m={PAY_PAL:{MISSING:"chargify-001"}};var u=new Map([[m.PAY_PAL.MISSING,{message:"Please Log into your PayPal account using the provided button",html:"<div>Please Log into your PayPal account using the provided button</div>"}]]);var r={CHECKOUT:{COUNTRY:{NOT_SUPPORTED:"checkout-001",CHINA_NOT_SUPPORTED:"checkout-002"},PRODUCT:{NOT_SUPPORTED:"checkout-003"},SHIPPING:{NOT_REQUIRED:"checkout-004"},UNEXPECTED:"checkout-005",DECLINED:"checkout-006",REMAINING_STEPS:"checkout-007",PROMO_CODE_INVALID:"checkout-008",PROMO_CODE_VALID:"checkout-009",ERRORS:"checkout-010",CARD:{NOT_SUPPORTED:"checkout-011"},TERMS_AND_SERVICES:"checkout-012"}};var l=new Map([[r.CHECKOUT.COUNTRY.NOT_SUPPORTED,{message:"The country you have selected is not supported",html:"<div>The country you have selected is not supported</div>"}],[r.CHECKOUT.COUNTRY.CHINA_NOT_SUPPORTED,{message:"We have a partner in China so no orders can be placed there",html:"<div>Please click <a href='http://nucalm.com.cn/'>here</a> to purchase your product directly from our Chinese partner.</div>"}],[r.CHECKOUT.PRODUCT.NOT_SUPPORTED,{message:"The product you have selected is not supported in your country",html:"<div>Sorry, this product is not supported outside of the United States. Please click <a href='https://nucalm.com/pricing?locale=international'>here</a> to view all available international plans</div>"}],[r.CHECKOUT.UNEXPECTED,{message:"There was an issue processing your subscription, please try again. If you continue to encounter an issue please contact us at support@nucalm.com",html:"<div>There was an issue processing your subscription, please try again. If you continue to encounter an issue please contact us at support@nucalm.com</div>"}],[r.CHECKOUT.DECLINED,{message:"Your card has been declined. Please add another payment method and try again",html:"<div>Your card has been declined. Please add another payment method and try again.</div>"}],[r.CHECKOUT.REMAINING_STEPS,{message:"Please press 'Continue' on any remaining steps - ",html:"<div>Please press 'Continue' on any remaining steps - </div>"}],[r.CHECKOUT.PROMO_CODE_INVALID,{message:"Invalid promo code",html:"<div>Invalid promo code</div>"}],[r.CHECKOUT.PROMO_CODE_VALID,{message:"Promo code applied successfully",html:"<div>Promo code applied successfully </div>"}],[r.CHECKOUT.PROMO_CODE_VALID,{message:"Promo code applied successfully",html:"<div>Promo code applied successfully </div>"}],[r.CHECKOUT.ERRORS,{message:"Please correct the errors above before you continue",html:"<div>Please correct the errors above before you continue</div>"}],[r.CHECKOUT.CARD.NOT_SUPPORTED,{message:"This type of card is not supported. Please provide any one of these cards: Visa, Master Card, American Express, Diners Club, JCB, Discover",html:"<div>This type of card is not supported. Please provide any one of these cards: Visa, Master card, American Express, Diners Club International, JCB Card, Discover</div>"}],[r.CHECKOUT.TERMS_AND_SERVICES,{message:"Please agree to the Terms & Services",html:"<div>Please agree to the Terms & Services</div>"}]]);var E={DISC_PURCHASE:{PAYMENT:{INVALID:"disc-purchase-001"}}};var h=new Map([[E.DISC_PURCHASE.PAYMENT.INVALID,{message:"The payment method attached to your subscription is invalid. Please update your payment information",html:"<div>The payment method attached to your subscription is invalid. Please update your payment information</div>"}]]);var o={EMAIL:{INVALID:"firebase-email-001",MISSING:"firebase-email-002",IN_USE:"firebase-email-003"},PASSWORD:{INVALID:"firebase-password-001"},USER:{DISABLED:"firebase-user-001",NOT_FOUND:"firebase-user-002"},ACCOUNT:{TOO_MANY_REQUEST:"firebase-account-001",DIFFERENT_CREDENTIALS:"firebase-account-002"},LOGIN:{FAIL:"firebase-login-001"}},U={"auth/missing-email":o.EMAIL.MISSING,"auth/invalid-email":o.EMAIL.INVALID,"auth/email-already-in-use":o.EMAIL.IN_USE,"auth/user-disabled":o.USER.DISABLED,"auth/user-not-found":o.USER.NOT_FOUND,"auth/invalid-password":o.PASSWORD.INVALID,"auth/too-many-requests":o.ACCOUNT.TOO_MANY_REQUEST,"auth/wrong-password":o.PASSWORD.INVALID,"auth/account-exists-with-different-credential":o.ACCOUNT.DIFFERENT_CREDENTIALS,general:o.LOGIN.FAIL};var t=__webpack_require__(70971),f=new Map([[t.AuthErrorCodes.INVALID_EMAIL,{message:"Please provide a valid email address",html:"<div>Please provide a valid email address </div>"}],[t.AuthErrorCodes.EMAIL_EXISTS,{message:"This email is already in use",html:"<div>This email is already in use<div>"}],[t.AuthErrorCodes.INVALID_PASSWORD,{message:"Your email or password is incorrect",html:"<div>Your email or password is incorrect</div>"}],[t.AuthErrorCodes.USER_DISABLED,{message:"Unable to log in. Please contact support for more information",html:"<div>Unable to log in. Please contact support for more information</div>"}],[t.AuthErrorCodes.USER_DELETED,{message:"Could not find a user with that email, Please sign up",html:"<div>Could not find a user with that email, Please sign up</div>"}],[t.AuthErrorCodes.TOO_MANY_ATTEMPTS_TRY_LATER,{message:"Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later",html:"<div>Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later</div>"}],[t.AuthErrorCodes.NEED_CONFIRMATION,{message:"Unable to process log in request",html:"<div>Unable to process log in request</div>"}],[t.AuthErrorCodes.NEED_CONFIRMATION,{message:"Your account exists, but you signed up with a different method",html:"<div>Your account exists, but you signed up with a different method</div>"}]]);var s={INPUT:{REQUIRED:"form-input-001",EMAIL:"form-input-002",PHONE:"form-input-003",PASSWORD:"form-input-004",PASSWORD_MATCH:"form-input-005",OPTION:"form-input-006"},VALIDATION:{GREATER_THAN_8:"form-validation-001",INCLUDE_UPPER_CASE_LETTER:"form-validation-002",INCLUDE_ONE_NUMBER:"form-validation-003",INCLUDE_ONE_SPECIAL_CHAR:"form-validation-004"}};var I=new Map([[s.INPUT.REQUIRED,{message:"This field is required",html:"<div>This field is required<div>"}],[s.INPUT.EMAIL,{message:"Please provide a valid email",html:"<div>Please provide a valid email<div>"}],[s.INPUT.PHONE,{message:"Please provide a valid phone number",html:"<div>Please provide a valid phone number<div>"}],[s.INPUT.PASSWORD,{message:"Please ensure your password is valid",html:"<div>Please ensure your password is valid<div>"}],[s.INPUT.PASSWORD_MATCH,{message:"Your passwords do not match",html:"<div>Your passwords do not match<div>"}],[s.VALIDATION.GREATER_THAN_8,{message:"Your password must be at least 8 characters in length or longer",html:"<div>Your password must be at least 8 characters in length or longer<div>"}],[s.VALIDATION.INCLUDE_ONE_NUMBER,{message:"Your password must contain at least one number",html:"<div>Your password must contain at least one number<div>"}],[s.VALIDATION.INCLUDE_UPPER_CASE_LETTER,{message:"Your password must contain at least one capital letter",html:"<div>Your password must contain at least one capital letter<div>"}],[s.VALIDATION.INCLUDE_ONE_SPECIAL_CHAR,{message:"Your password must contain at least one special character (!@#$%)",html:"<div>Your password must contain at least one special character (!@#$%)<div>"}]]);var d={ERROR:{PROCESSING_REQUEST:"generic-001",PAGE_LOADING:"generic-002"}};var P=new Map([[d.ERROR.PROCESSING_REQUEST,{message:"An error has occurred while processing your request. If this issue continues to occur please contact us."}],[d.ERROR.PAGE_LOADING,{message:"An issue has occurred while loading the page. Please contact support if this issue persists."}]]);var T={ERROR:{FORM_ERRORS_REMAINING:"page-001"}};var g=new Map([[T.ERROR.FORM_ERRORS_REMAINING,{message:"Please complete any remaining  fields",html:"<div>Please complete any remaining  field</div>"}]]);var C={ADDRESS:{PO_BOX:"shipping-001"}};var O=new Map([[C.ADDRESS.PO_BOX,{message:"International shipments are only permitted to actual, physical addresses. PO Boxes are not permitted delivery addresses.",html:"<div>International shipments are only permitted to actual, physical addresses. PO Boxes are not permitted delivery addresses.</div>"}]]);var p={CREATE:{DUPLICATE_SUBSCRIPTIONS:"subscriptions-001"},STATUS:{PAST_DUE:"subscriptions-002"}};var v=new Map([[p.CREATE.DUPLICATE_SUBSCRIPTIONS,{message:"You are already subscribed to a plan, if you would like to upgrade please manage your subscription or contact us",html:"<div>You are already subscribed, if you would like to upgrade please manage your subscription or contact us</div>"}],[p.STATUS.PAST_DUE,{message:"Your account is in past due. In order to pause discs you must pay your outstanding balance."}]]);function b(a){let e=new Map;switch(a.split("-")[0]){case"checkout":e=l;break;case"subscriptions":e=v;break;case"firebase":e=f;break;case"page":e=g;break;case"form":e=I;break;case"disc-purchase":e=h;break;case"chargify":e=u;break;case"generic":e=P;break;case"shipping":e=O;break;default:}return e.get(a)}0&&(0);
//# sourceMappingURL=index.cjs.map

/***/ }),

/***/ 76303:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A$": function() { return /* binding */ oo; },
/* harmony export */   "AN": function() { return /* binding */ j; },
/* harmony export */   "HJ": function() { return /* binding */ ri; },
/* harmony export */   "II": function() { return /* binding */ We; },
/* harmony export */   "Ph": function() { return /* binding */ Vn; },
/* harmony export */   "SO": function() { return /* binding */ Qa; },
/* harmony export */   "UW": function() { return /* binding */ pe; },
/* harmony export */   "Vu": function() { return /* binding */ lo; },
/* harmony export */   "W2": function() { return /* binding */ mr; },
/* harmony export */   "XZ": function() { return /* binding */ In; },
/* harmony export */   "__": function() { return /* binding */ D; },
/* harmony export */   "e5": function() { return /* binding */ C; },
/* harmony export */   "f6": function() { return /* binding */ Ge; },
/* harmony export */   "fh": function() { return /* binding */ Yo; },
/* harmony export */   "iC": function() { return /* binding */ Zo; },
/* harmony export */   "iz": function() { return /* binding */ yn; },
/* harmony export */   "kY": function() { return /* binding */ so; },
/* harmony export */   "l2": function() { return /* binding */ Il; },
/* harmony export */   "rB": function() { return /* binding */ Mo; },
/* harmony export */   "zx": function() { return /* binding */ J; }
/* harmony export */ });
/* unused harmony exports AcceptedCardsBadge, AppleAppStore, AppleButton, Bars, Card, CarouselSlider, CreditCard, DisplayCheckoutInfo, ErrorInput, FacebookButton, GoogleButton, Icon, InputPassword, InputPhoneNumber, LabelCheckbox, LabelInputPhoneNumber, ListItem, Loader, Logo, Markdown, Mastercard, NavDropDown, NavLink, NavbarMessage, NuCalmWhite, PasswordCriteriaHelper, PayPal, Radio, SecondaryBtn, Section, SkeletonLoader, StepDisplay, StripeBadge, TextArea, UserImage, Visa */
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72779);
/* harmony import */ var next_link_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39097);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52322);
/* harmony import */ var _blueprintjs_core__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(1300);
/* harmony import */ var _blueprintjs_core__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(91942);
/* harmony import */ var _blueprintjs_core__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47866);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2784);
/* harmony import */ var pure_react_carousel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98402);
/* harmony import */ var next_image_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96577);
/* harmony import */ var content__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63521);
/* harmony import */ var next_head_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97729);
/* harmony import */ var utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98727);
/* harmony import */ var _blueprintjs_popover2__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(40680);
/* provided dependency */ var process = __webpack_require__(34406);














function j(e){let t="my-2 flex justify-center outline-none border-none shadow-none no-underline",a=()=>{switch(e.variant){case"primary":return "bg-primary-100 text-white";case"secondary":return "bg-secondary-100 text-white";case"disabled":return "bg-slate-100 text-black";case"update":case"continue":return "bg-[#001828] text-white";default:return ""}},r="text-base py-2 px-3 font-bold rounded-md mt-[5px] mb-2";e.small?r="text-small py-[5px] px-3 font-medium rounded-md mt-[5px] mb-2":e.large&&(r="text-lg py-2 px-4 font-bold rounded-md mt-[5px] mb-2");let o=e.fill?"w-full":"max-w-max",i=e.variant==="default"?"":classnames__WEBPACK_IMPORTED_MODULE_0__(r,o,a(),t);return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(next_link_js__WEBPACK_IMPORTED_MODULE_1__,{href:e.href,as:e.as,replace:e.replace,scroll:e.scroll,shallow:e.shallow,prefetch:e.prefetch,target:e.target,legacyBehavior:!0,children:(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("a",{className:classnames__WEBPACK_IMPORTED_MODULE_0__(e.className,i),children:e.children})})}var Kt=e=>jsx("svg",{xmlns:"http://www.w3.org/2000/svg",width:28,height:24,viewBox:"0 0 28 24",fill:"none",...e,children:jsx("path",{d:"M27.25 3.574H.75A.758.758 0 010 2.81V.766C0 .343.336 0 .75 0h26.5c.414 0 .75.343.75.766v2.043a.758.758 0 01-.75.765zm0 10.213H.75a.758.758 0 01-.75-.766V10.98c0-.423.336-.766.75-.766h26.5c.414 0 .75.343.75.766v2.042a.758.758 0 01-.75.766zm0 10.213H.75a.758.758 0 01-.75-.766v-2.043c0-.422.336-.765.75-.765h26.5c.414 0 .75.343.75.766v2.042a.758.758 0 01-.75.766z",fill:"#fff"})});var pe=e=>(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_blueprintjs_core__WEBPACK_IMPORTED_MODULE_9__/* .Callout */ .UW,{...e,className:classnames__WEBPACK_IMPORTED_MODULE_0__("text-[16px]  mb-[8px]",e.className??"",_blueprintjs_core__WEBPACK_IMPORTED_MODULE_10__.FILL)}),C=e=>(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(pe,{...e,intent:"danger"}),Zo=e=>(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(pe,{...e,intent:"warning"}),Yo=e=>(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(pe,{...e,intent:"success"});var J=e=>{let{fill:t=!0}=e,a="rounded-md mt-[5px] mb-2 justify-center text-center transition-none outline-none border-none shadow-none bg-none",r=()=>{switch(e.variant){case"primary":return "bg-primary-100 text-white";case"update":case"continue":return "bg-[#001828] text-white";case"monthly":return "bg-[#707070]";case"secondary":return "bg-secondary-500";case"danger":return "bg-red-600";case"warning":return "bg-[#F76800]";default:return ""}},o=()=>e.small?"text-base py-1 px-3 font-medium":e.large?"text-lg py-2 px-4 font-bold":"text-[18px] py-2 px-4 font-bold",i=classnames__WEBPACK_IMPORTED_MODULE_0__({["disabled:opacity-75 bg-gray-900"]:e.disabled,[e.className]:!e.disabled,[o()]:!0,[r()]:!e.disabled,"w-full":t,"max-w-max":!t,[a]:!0});return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment,{children:[(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_blueprintjs_core__WEBPACK_IMPORTED_MODULE_9__/* .Button */ .zx,{...e,type:e.type,className:i}),e.errormessage&&(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(C,{children:e.errormessage})]})},Ge=e=>(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(J,{variant:"primary",...e}),rn=e=>jsx(J,{variant:"secondary",...e});var ln=({children:e,className:t,onClick:a})=>jsx("div",{id:"card",className:ge(" shadow-md  rounded-md bg-white hover:cursor-pointer",t),onClick:a,children:e});var lr=e=>{var i,s;let[t]=useState(0),[a,r]=useState(null),o=()=>{let n=window.innerWidth;return n>1800?r(4):n>1200?r(3):n>800?r(2):(r(1))};return useEffect(()=>(window&&o(),window.addEventListener("resize",o),()=>window.removeEventListener("resize",o)),[]),jsx("div",{children:jsx(CarouselProvider,{totalSlides:(i=e.slides)==null?void 0:i.length,naturalSlideWidth:NaN,naturalSlideHeight:NaN,isIntrinsicHeight:!0,visibleSlides:a,currentSlide:t,infinite:!0,dragEnabled:!1,step:a,hasMasterSpinner:e.isLoading,children:jsxs("div",{className:"relative max-w-[100%] m-auto",children:[jsx(Slider,{className:"lg:pl-[49px] pb-8 pt-2",children:(s=e.slides)==null?void 0:s.map((n,g)=>jsx(Slide,{index:g,children:n},g))}),e.slides.length<=a?null:jsxs(Fragment,{children:[jsx(ButtonBack,{className:"absolute left-0 h-[145px] top-[125px] md:top-[50%] translate-y-[-80%] z-10  sm:h-6/12  bg-black rounded-md  pl-1 opacity-50  hover:opacity-90",children:jsx("i",{className:"fa-solid fa-chevron-left text-6xl flex align-center  text-white"})}),jsx(ButtonNext,{className:"absolute h-[145px] top-[125px] md:top-[50%] translate-y-[-80%] right-0 z-10 md:h-6/12  bg-black rounded-md opacity-50 pr-1 hover:opacity-90 ",children:jsx("i",{className:"fa-solid fa-chevron-right text-6xl flex align-center  text-white"})})]})]})})})};var mr=e=>(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div",{className:classnames__WEBPACK_IMPORTED_MODULE_0__("container px-6 mx-auto",e.className),children:e.children});var yn=e=>(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div",{className:e.className,style:{width:"100%",border:"1px solid #D6D6D6",margin:"1.5rem 0"}});var In=e=>(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div",{children:[(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_blueprintjs_core__WEBPACK_IMPORTED_MODULE_9__/* .Checkbox */ .XZ,{...e,large:!0,type:"checkbox",id:e.id,name:e.id,"aria-label":e.label,value:e.value,className:classnames__WEBPACK_IMPORTED_MODULE_0__(_blueprintjs_core__WEBPACK_IMPORTED_MODULE_10__.CHECKBOX,e.error?"border-2 border-solid border-secondary-500":"","text-base text-[18px] mb-3",e.classname),children:e.children}),e.error&&e.errorMessage&&(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(C,{children:e.errorMessage})]});var We=e=>{let{showErrorMessage:t=!0}=e;return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div",{className:classnames__WEBPACK_IMPORTED_MODULE_0__("flex flex-col",e.className),children:[(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("input",{...e,type:e.type,id:e.id,name:e.id,"aria-label":e.placeholder,value:e.value,className:classnames__WEBPACK_IMPORTED_MODULE_0__(e.errormessage?"border-2 border-solid border-secondary-500":"",_blueprintjs_core__WEBPACK_IMPORTED_MODULE_10__.FILL,_blueprintjs_core__WEBPACK_IMPORTED_MODULE_10__.INPUT,"text-[18px] h-[40px] mb-3",e.className)}),e.errormessage&&t&&(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(C,{children:e.errormessage})]})},Xe=e=>jsx("input",{...e,name:e.name,value:e.value,type:e.type,className:ge(e.errormessage?"border-2 border-solid border-secondary-500":"",Classes.INPUT,Classes.FILL,e.className)});var br={background:"#ffffff",border:"none",borderRadius:"3px",boxShadow:"0 0 0 0 rgb(19 124 189 / 0%), 0 0 0 0 rgb(19 124 189 / 0%), inset 0 0 0 1px rgb(16 22 26 / 15%), inset 0 1px 1px rgb(16 22 26 / 20%)",color:"#182026",fontSize:" 14px",fontWeight:"400",height:"30px",lineHeight:"30px",outline:"none",paddingLeft:"5px",paddingRight:"10px"},Vn=e=>(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div",{className:classnames__WEBPACK_IMPORTED_MODULE_0__("flex flex-col",e.className),children:[(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("select",{...e,id:e.id,name:e.id,placeholder:e.placeholder,"aria-label":e.placeholder,value:e.value,style:br,className:classnames__WEBPACK_IMPORTED_MODULE_0__(e.errormessage?"border-2 border-solid border-secondary-500 shadow-md":"",_blueprintjs_core__WEBPACK_IMPORTED_MODULE_10__.FILL,_blueprintjs_core__WEBPACK_IMPORTED_MODULE_10__.HTML_SELECT,"text-[18px] h-[40px] mb-3",e.className),autoComplete:"on",children:e.children}),e.errormessage&&(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(C,{children:e.errormessage})]});function rt(e,t){var a={};for(var r in e)Object.prototype.hasOwnProperty.call(e,r)&&t.indexOf(r)<0&&(a[r]=e[r]);if(e!=null&&typeof Object.getOwnPropertySymbols=="function")for(var o=0,r=Object.getOwnPropertySymbols(e);o<r.length;o++)t.indexOf(r[o])<0&&Object.prototype.propertyIsEnumerable.call(e,r[o])&&(a[r[o]]=e[r[o]]);return a}var ae;(function(e){e.event="event",e.props="prop";})(ae||(ae={}));function O(){}function oe(e){return !!(e||"").match(/\d/)}function Qe(e){return e==null}function yr(e){return typeof e=="number"&&isNaN(e)}function wr(e){var t=useRef(e);t.current=e;var a=useRef(function(){for(var r=[],o=arguments.length;o--;)r[o]=arguments[o];return t.current.apply(t,r)});return a.current}function je(e,t){return Array(t+1).join(e)}function Pr(e){var t=e+"",a=t[0]==="-"?"-":"";a&&(t=t.substring(1));var r=t.split(/[eE]/g),o=r[0],i=r[1];if(i=Number(i),!i)return a+o;o=o.replace(".","");var s=1+i,n=o.length;return s<0?o="0."+je("0",Math.abs(s))+o:s>=n?o=o+je("0",s-n):o=(o.substring(0,s)||"0")+"."+o.substring(s),a+o}function he(e,t){if(e.value=e.value,e!==null){if(e.createTextRange){var a=e.createTextRange();return a.move("character",t),a.select(),!0}return e.selectionStart||e.selectionStart===0?(e.focus(),e.setSelectionRange(t,t),!0):(e.focus(),!1)}}function Mr(e,t){for(var a=0,r=0,o=e.length,i=t.length;e[a]===t[a]&&a<o;)a++;for(;e[o-1-r]===t[i-1-r]&&i-r>a&&o-r>a;)r++;return {from:{start:a,end:o-r},to:{start:a,end:i-r}}}function Cr(e,t,a){return Math.min(Math.max(e,t),a)}function et(e){return Math.max(e.selectionStart,e.selectionEnd)}function Lr(){return typeof navigator<"u"&&!(navigator.platform&&/iPhone|iPod/.test(navigator.platform))}function Sr(e){return {from:{start:0,end:0},to:{start:0,end:e.length},lastValue:""}}function at(e,t){return e===void 0&&(e=" "),typeof e=="string"?e:e[t]||" "}function Ir(e,t,a,r,o,i){var s=o.findIndex(function(k){return k}),n=e.slice(0,s);!t&&!a.startsWith(n)&&(a=n+a,r=r+n.length);for(var g=a.length,y=e.length,f={},v=new Array(g),m=0;m<g;m++){v[m]=-1;for(var p=0,x=y;p<x;p++)if(a[m]===e[p]&&f[p]!==!0){v[m]=p,f[p]=!0;break}}for(var h=r;h<g&&(v[h]===-1||!i(a[h]));)h++;var l=h===g||v[h]===-1?y:v[h];for(h=r-1;h>0&&v[h]===-1;)h--;var b=h===-1||v[h]===-1?0:v[h]+1;return b>l?l:r-b<l-r?b:l}function ne(e,t,a,r){var o=e.length;if(t=Cr(t,0,o),r==="left"){for(;t>=0&&!a[t];)t--;t===-1&&(t=a.indexOf(!0));}else {for(;t<=o&&!a[t];)t++;t>o&&(t=a.lastIndexOf(!0));}return t===-1&&(t=o),t}function Br(e){for(var t=Array.from({length:e.length+1}).map(function(){return !0}),a=0,r=t.length;a<r;a++)t[a]=Boolean(oe(e[a])||oe(e[a-1]));return t}function Tr(e,t,a,r,o,i){i===void 0&&(i=O);var s=useRef(),n=wr(function(m){var p,x;return Qe(m)||yr(m)?(x="",p=""):typeof m=="number"||a?(x=typeof m=="number"?Pr(m):m,p=r(x)):(x=o(m,void 0),p=m),{formattedValue:p,numAsString:x}}),g=useState(function(){return n(t)}),y=g[0],f=g[1],v=function(m,p){f({formattedValue:m.formattedValue,numAsString:m.value}),i(m,p);};return useMemo(function(){Qe(e)?s.current=void 0:(s.current=n(e),f(s.current));},[e,n]),[y,v]}function kr(e){return e.replace(/[^0-9]/g,"")}function Ar(e){return e}function zr(e){var t=e.type;t===void 0&&(t="text");var a=e.displayType;a===void 0&&(a="input");var r=e.customInput,o=e.renderText,i=e.getInputRef,s=e.format;s===void 0&&(s=Ar);var n=e.removeFormatting;n===void 0&&(n=kr);var g=e.defaultValue,y=e.valueIsNumericString,f=e.onValueChange,v=e.isAllowed,m=e.onChange;m===void 0&&(m=O);var p=e.onKeyDown;p===void 0&&(p=O);var x=e.onMouseUp;x===void 0&&(x=O);var h=e.onFocus;h===void 0&&(h=O);var l=e.onBlur;l===void 0&&(l=O);var b=e.value,k=e.getCaretBoundary;k===void 0&&(k=Br);var A=e.isValidInputCharacter;A===void 0&&(A=oe);var me=rt(e,["type","displayType","customInput","renderText","getInputRef","format","removeFormatting","defaultValue","valueIsNumericString","onValueChange","isAllowed","onChange","onKeyDown","onMouseUp","onFocus","onBlur","value","getCaretBoundary","isValidInputCharacter"]),ke=Tr(b,g,Boolean(y),s,n,f),Ae=ke[0],H=Ae.formattedValue,ze=Ae.numAsString,kt=ke[1],de=useRef(),At=function(c,d){de.current=c.formattedValue,kt(c,d);};useEffect(function(){var c=s(ze);if(de.current===void 0||c!==de.current){var d=ue.current;De({formattedValue:c,numAsString:ze,input:d,setCaretPosition:!0,source:ae.props,event:void 0});}});var Ee=useState(!1),zt=Ee[0],Et=Ee[1],ue=useRef(null),G=useRef({setCaretTimeout:null,focusTimeout:null});useEffect(function(){return Et(!0),function(){clearTimeout(G.current.setCaretTimeout),clearTimeout(G.current.focusTimeout);}},[]);var Ht=s,He=function(c,d){var u=parseFloat(d);return {formattedValue:c,value:d,floatValue:isNaN(u)?void 0:u}},$=function(c,d,u){he(c,d),G.current.setCaretTimeout=setTimeout(function(){c.value===u&&he(c,d);},0);},Z=function(c,d,u){return ne(c,d,k(c),u)},Re=function(c,d,u){var P=k(d),M=Ir(d,H,c,u,P,A);return M=ne(d,M,P),M},De=function(c){var d=c.formattedValue;d===void 0&&(d="");var u=c.input,P=c.setCaretPosition;P===void 0&&(P=!0);var M=c.source,N=c.event,S=c.numAsString,B=c.caretPos;if(u){if(B===void 0&&P){var Y=c.inputValue||u.value,fe=et(u);u.value=d,B=Re(Y,d,fe);}u.value=d,P&&B!==void 0&&$(u,B,d);}d!==H&&At(He(d,S),{event:N,source:M});},Rt=function(c,d,u){var P=Mr(H,c),M=Object.assign(Object.assign({},P),{lastValue:H}),N=n(c,M),S=Ht(N);if(v&&!v(He(S,N))){var B=d.target,Y=et(B),fe=Re(c,H,Y);return $(B,fe,H),!1}return De({formattedValue:S,numAsString:N,inputValue:c,event:d,source:u,setCaretPosition:!0,input:d.target}),!0},Dt=function(c){var d=c.target,u=d.value,P=Rt(u,c,ae.event);P&&m(c);},Ft=function(c){var d=c.target,u=c.key,P=d.selectionStart,M=d.selectionEnd,N=d.value;N===void 0&&(N="");var S;if(u==="ArrowLeft"||u==="Backspace"?S=Math.max(P-1,0):u==="ArrowRight"?S=Math.min(P+1,N.length):u==="Delete"&&(S=P),S===void 0||P!==M){p(c);return}var B=S;if(u==="ArrowLeft"||u==="ArrowRight"){var Y=u==="ArrowLeft"?"left":"right";B=Z(N,S,Y);}else u==="Delete"&&!A(N[S])?B=Z(N,S,"right"):u==="Backspace"&&!A(N[S])&&(B=Z(N,S,"left"));B!==S&&$(d,B,N),c.isUnitTestRun&&$(d,B,N),p(c);},Vt=function(c){var d=c.target,u=d.selectionStart,P=d.selectionEnd,M=d.value;if(M===void 0&&(M=""),u===P){var N=Z(M,u);N!==u&&$(d,N,M);}x(c);},Ot=function(c){c.persist();var d=c.target;ue.current=d,G.current.focusTimeout=setTimeout(function(){var u=d.selectionStart,P=d.selectionEnd,M=d.value;M===void 0&&(M="");var N=Z(M,u);N!==u&&!(u===0&&P===M.length)&&$(d,N,M),h(c);},0);},_t=function(c){ue.current=null,clearTimeout(G.current.focusTimeout),clearTimeout(G.current.setCaretTimeout),l(c);},Gt=zt&&Lr()?"numeric":void 0,Fe=Object.assign({inputMode:Gt},me,{type:t,value:H,onChange:Dt,onKeyDown:Ft,onMouseUp:Vt,onFocus:Ot,onBlur:_t});if(a==="text")return o?U.createElement(U.Fragment,null,o(H,me)||null):U.createElement("span",Object.assign({},me,{ref:i}),H);if(r){var $t=r;return U.createElement($t,Object.assign({},Fe,{ref:i}))}return U.createElement("input",Object.assign({},Fe,{ref:i}))}function Er(e,t){var a=t.format,r=t.allowEmptyFormatting,o=t.mask,i=t.patternChar;if(i===void 0&&(i="#"),e===""&&!r)return "";for(var s=0,n=a.split(""),g=0,y=a.length;g<y;g++)a[g]===i&&(n[g]=e[s]||at(o,s),s+=1);return n.join("")}function Hr(e,t,a){t===void 0&&(t=Sr(e));var r=a.format,o=a.patternChar;o===void 0&&(o="#");var i=t.from,s=t.to,n=t.lastValue;n===void 0&&(n="");var g=function(l){return r[l]===o},y=function(l,b){for(var k="",A=0;A<l.length;A++)g(b+A)&&oe(l[A])&&(k+=l[A]);return k},f=function(l){return l.replace(/[^0-9]/g,"")};if(!r.match(/\d/))return f(e);if(n===""&&e.length===r.length){for(var v="",m=0;m<e.length;m++)if(g(m))v+=e[m];else if(e[m]!==r[m])return f(e);return v}var p=n.substring(0,i.start),x=e.substring(s.start,s.end),h=n.substring(i.end);return ""+y(p,0)+f(x)+y(h,i.end)}function Rr(e,t){var a=t.format,r=t.mask,o=t.patternChar;o===void 0&&(o="#");var i=Array.from({length:e.length+1}).map(function(){return !0}),s=0,n=-1,g={};a.split("").forEach(function(m,p){var x=void 0;m===o&&(s++,x=at(r,s-1),n===-1&&e[p]===x&&(n=p)),g[p]=x;});for(var y=function(m){return a[m]===o&&e[m]!==g[m]},f=0,v=i.length;f<v;f++)i[f]=f===n||y(f)||y(f-1);return i[a.indexOf(o)]=!0,i}function Dr(e){var t=e.mask;if(t){var a=t==="string"?t:t.toString();if(a.match(/\d/g))throw new Error("Mask "+t+" should not contain numeric character;")}}function Fr(e){e.mask;e.allowEmptyFormatting;var r=e.format,o=e.inputMode;o===void 0&&(o="numeric");var i=e.onKeyDown;i===void 0&&(i=O);var s=e.patternChar;s===void 0&&(s="#");var n=rt(e,["mask","allowEmptyFormatting","format","inputMode","onKeyDown","patternChar"]);Dr(e);var g=function(f){return Rr(f,e)},y=function(f){var v=f.key,m=f.target,p=m.selectionStart,x=m.selectionEnd,h=m.value;if(p!==x){i(f);return}var l=p;if(v==="Backspace"||v==="Delete"){var b="right";if(v==="Backspace"){for(;l>0&&r[l-1]!==s;)l--;b="left";}else {for(var k=r.length;l<k&&r[l]!==s;)l++;b="right";}l=ne(h,l,g(h),b);}else r[l]!==s&&v!=="ArrowLeft"&&v!=="ArrowRight"&&(l=ne(h,l+1,g(h),"right"));l!==p&&he(m,l),i(f);};return Object.assign(Object.assign({},n),{inputMode:o,format:function(f){return Er(f,e)},removeFormatting:function(f,v){return Hr(f,v,e)},getCaretBoundary:g,onKeyDown:y})}function ot(e){var t=Fr(e);return U.createElement(zr,Object.assign({},t))}var nt=e=>jsx(ot,{id:"number",...e,format:"(###) ###-####",mask:"_",customInput:e.error?Xe:We});var D=e=>(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_blueprintjs_core__WEBPACK_IMPORTED_MODULE_9__/* .Label */ .__,{className:classnames__WEBPACK_IMPORTED_MODULE_0__("font-medium",e.className||""),children:(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react__WEBPACK_IMPORTED_MODULE_3__.Fragment,{children:[e.label,e.children]})});var lt=e=>(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("textarea",{...e,className:classnames__WEBPACK_IMPORTED_MODULE_0__(e.className,_blueprintjs_core__WEBPACK_IMPORTED_MODULE_10__.INPUT,_blueprintjs_core__WEBPACK_IMPORTED_MODULE_10__.FILL,e.error?"border-2 border-solid border-secondary-500":"")});var i1=e=>jsxs(Label,{className:ge("cursor-pointer",e.labelclassname),children:[jsx("input",{...e,type:"radio",className:ge(e.error?"border-2 border-solid border-secondary-500":"",Classes.RADIO,"text-[18px]  cursor-pointer",e.className),value:e.value,name:e.name}),jsxs("p",{className:"font-bold mb-1 text-[18px]",children:[" ",e.title]}),jsxs("p",{className:"text-[18px]",children:[" ",e.text]})]});var z=e=>jsx(Icon,{icon:e.iconName,onClick:e.onClick,className:e.className,size:e.size});var h1=e=>{let{showErrorMessage:t=!0}=e;return jsxs("div",{className:ge("flex flex-col",e.className),children:[jsx(InputGroup,{onChange:e.onChange,onBlur:e.onBlur,type:e.showPassword?"text":"password",id:e.id,name:e.id,"aria-label":e.placeholder,value:e.value,placeholder:e.placeholder,rightElement:jsx("button",{type:"button",className:"focus:outline-none p-2",onClick:e.toggleShowPassword,children:jsx(z,{iconName:e.showPassword?"eye-open":"eye-off"})}),style:{fontSize:"18px !important"},className:ge(e.errormessage?"border-2 border-solid border-secondary-500":"",Classes.FILL,Classes.LARGE,"mb-3",e.className)}),e.errormessage&&t&&jsx(C,{children:e.errormessage})]})};var y1=({children:e,className:t})=>jsx("li",{className:ge("list-none",t),children:e});var C1=({className:e,children:t})=>jsx("div",{id:"spinner",className:e??"",children:jsx(Spinner,{children:t})});var B1=e=>jsx("div",{className:ge("bp3-skeleton py-30",e.className),children:e.children});var xe=({width:e=105,height:t=30,url:a,onClick:r})=>(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(next_image_js__WEBPACK_IMPORTED_MODULE_5__,{src:a,width:e,height:t,alt:"Logo",className:"my-auto hover:cursor-pointer",quality:100,onClick:r});var ca=({children:e})=>jsx(la,{components:{ol:({children:t})=>jsx("ol",{className:"list-disc ml-4 mt-4 text-base",children:t}),ul:({children:t})=>jsx("ul",{className:"list-disc ml-4 mt-4 text-base",children:t})},remarkPlugins:[sa],children:e});var ft=({href:e,text:t,className:a})=>jsx("li",{className:"list-none pb-[2px]",children:jsx(Ut,{href:e,className:ge("text-base font-medium text-text-100",a),children:t})});var X1=e=>jsx(Navbar,{fixedToTop:!1,className:ge(e.className,"w-full px-0 text-sm"),style:{height:"auto"},children:e.children});var pt=e=>jsx("section",{...e,className:ge("w-full rounded-md p-[20px]",e.className),children:e.children});var ri=e=>{var i,s,n,g,y,f,v,m,p;let t=(0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(()=>{switch(e.tenent){case"KwikState":return "KwikState Powered by NuCalm";case"NuCalm":default:return "NuCalm"}},[e.tenent]),a=`${(i=e.page)==null?void 0:i.title} | ${t}`,r=(n=(s=e.page)==null?void 0:s.image)!=null&&n.asset?(0,content__WEBPACK_IMPORTED_MODULE_6__.urlFor)((y=(g=e.page)==null?void 0:g.image)==null?void 0:y.asset).width(1200).height(600).url():"https://firebasestorage.googleapis.com/v0/b/nucalmv3-dev.appspot.com/o/Mastermind%2FIgniteScreen.png?alt=media&token=1fd39db7-f560-445e-9c8d-09597cd8de5b",o=typeof window<"u"?window.location.origin:process.env.NEXT_PUBLIC_ORIGIN;return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(next_head_js__WEBPACK_IMPORTED_MODULE_7__,{children:[(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("title",{children:a}),(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta",{name:"title",content:a}),((f=e.page)==null?void 0:f.description)&&(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta",{name:"description",content:e.page.description}),e.noindex&&(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta",{name:"robots",content:"noindex"}),(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta",{property:"og:type",content:"website"}),e.path&&(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta",{property:"og:url",content:`${o}${e.path}`}),(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta",{property:"og:title",content:a}),((v=e.page)==null?void 0:v.description)&&(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta",{property:"og:description",content:(m=e.page)==null?void 0:m.description}),r&&(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta",{property:"og:image",content:r}),e.path&&(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta",{property:"twitter:url",content:`${o}${e.path}`}),(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta",{property:"twitter:title",content:a}),((p=e.page)==null?void 0:p.description)&&(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta",{property:"twitter:description",content:e.page.description}),r&&(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("meta",{property:"twitter:image",content:r})]})};var si=e=>jsxs(Fragment,{children:[jsxs(Button,{type:"button",id:"google",onClick:e.onClick,className:ge(Classes.LARGE,"bg-white font-medium mb-2 shadow-none w-full"),loading:e.isLoading,icon:jsxs("svg",{xmlns:"http://www.w3.org/2000/svg",width:20,height:30,viewBox:"0 0 30 30",fill:"none",className:"my-auto",children:[jsxs("g",{clipPath:"url(#prefix__clip0)",children:[jsx("path",{d:"M29.4 15.333a14.633 14.633 0 01-4.467 11.034h-4.85V22.6a6.85 6.85 0 002.984-4.533H15v-5.8h14.133c.175 1.013.264 2.038.267 3.066z",fill:"#3E82F1"}),jsx("path",{d:"M25 26.367A14.366 14.366 0 0115 30a15 15 0 01-13.333-8.333v-3.884h5A8.95 8.95 0 0015 23.967a9.05 9.05 0 005-1.434l5 3.834z",fill:"#32A753"}),jsx("path",{d:"M6.666 12.15a8.933 8.933 0 000 5.7l-5 3.817a15 15 0 010-13.467h5v3.95z",fill:"#F9BB00"}),jsx("path",{d:"M25 3.9l-4.3 4.317a8.05 8.05 0 00-5.733-2.25 8.95 8.95 0 00-8.333 6.183L1.667 8.333A15 15 0 0115 0a14.417 14.417 0 0110 3.9z",fill:"#E74235"})]}),jsx("defs",{children:jsx("clipPath",{id:"prefix__clip0",children:jsx("path",{fill:"#fff",d:"M0 0h29.4v30H0z"})})})]}),children:[e.text," Google"]}),e.errorMessage&&jsx(C,{children:e.errorMessage})]});var pi=e=>jsxs(Fragment,{children:[jsxs(Button,{type:"button",id:"apple",onClick:e.onClick,className:ge(Classes.LARGE,"bg-white font-medium mb-2 shadow-none w-full"),loading:e.isLoading,icon:jsxs("svg",{xmlns:"http://www.w3.org/2000/svg",width:20,height:30,viewBox:"0 0 26 30",fill:"none",className:"my-auto",children:[jsx("g",{clipPath:"url(#prefix__clip0)",children:jsx("path",{d:"M21.286 15.85c-.014-2.457 1.11-4.312 3.382-5.678-1.272-1.801-3.192-2.793-5.729-2.987-2.401-.187-5.026 1.386-5.986 1.386-1.015 0-3.341-1.319-5.168-1.319C4.011 7.312 0 10.232 0 16.172c0 1.754.325 3.567.974 5.437.866 2.458 3.99 8.485 7.25 8.384 1.705-.04 2.91-1.198 5.128-1.198 2.15 0 3.267 1.198 5.168 1.198 3.287-.047 6.114-5.524 6.94-7.988-4.41-2.056-4.174-6.027-4.174-6.155zM17.458 4.855C19.304 2.685 19.135.71 19.08 0c-1.63.094-3.517 1.098-4.593 2.337-1.183 1.326-1.88 2.967-1.731 4.815 1.765.134 3.375-.764 4.7-2.297z",fill:"#000"})}),jsx("defs",{children:jsx("clipPath",{id:"prefix__clip0",children:jsx("path",{fill:"#fff",d:"M0 0h25.5v30H0z"})})})]}),children:[e.text," Apple"]}),e.errorMessage&&jsx(C,{children:e.errorMessage})]});var Ni=e=>jsxs(Fragment,{children:[jsxs(Button,{type:"button",id:"facebook",onClick:e.onClick,className:ge(Classes.LARGE,"bg-white font-medium mb-2 shadow-none w-full"),loading:e.isLoading,icon:jsxs("svg",{xmlns:"http://www.w3.org/2000/svg",width:"20",height:"30",viewBox:"0 0 30 30",fill:"none",className:"my-auto",children:[jsx("path",{d:"M30 15C30 6.71572 23.2843 0 15 0C6.71572 0 0 6.71572 0 15C0 22.4868 5.48525 28.6925 12.6562 29.8178V19.3359H8.84766V15H12.6562V11.6953C12.6562 7.93594 14.8957 5.85938 18.322 5.85938C19.9626 5.85938 21.6797 6.15234 21.6797 6.15234V9.84375H19.7883C17.925 9.84375 17.3438 11.0001 17.3438 12.1875V15H21.5039L20.8389 19.3359H17.3438V29.8178C24.5147 28.6925 30 22.4868 30 15Z",fill:"#1877F2"}),jsx("path",{d:"M20.8389 19.3359L21.5039 15H17.3438V12.1875C17.3438 11.0013 17.925 9.84375 19.7883 9.84375H21.6797V6.15234C21.6797 6.15234 19.9632 5.85938 18.322 5.85938C14.8957 5.85938 12.6562 7.93594 12.6562 11.6953V15H8.84766V19.3359H12.6562V29.8178C14.2093 30.0607 15.7907 30.0607 17.3438 29.8178V19.3359H20.8389Z",fill:"white"})]}),children:[e.text," Facebook"]}),e.errorMessage&&jsx(C,{children:e.errorMessage})]});var Mi=({currentStep:e,totalStep:t,className:a})=>jsxs("p",{className:ge("mt-o text-base font-semibold text-gray-700",a),children:["Step ",e," of ",t]});function Me({width:e,height:t,alt:a,className:r}){return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(next_image_js__WEBPACK_IMPORTED_MODULE_5__,{src:"https://nucalm.com/hubfs/badges/cards/4_Card_color_horizontal.png",width:e??"250",height:t??"155",alt:a??"accepted card types",className:r})}function Da(){return jsxs("svg",{xmlns:"http://www.w3.org/2000/svg",width:"120",height:"36",viewBox:"0 0 130 40",children:[jsx("path",{fill:"#a6a6a6",d:"M110.135 0H9.535c-.367 0-.73 0-1.095.002-.306.002-.61.008-.919.013A13.215 13.215 0 005.517.19a6.665 6.665 0 00-1.9.627 6.438 6.438 0 00-1.62 1.18A6.258 6.258 0 00.82 3.617a6.601 6.601 0 00-.625 1.903 12.993 12.993 0 00-.179 2.002c-.01.307-.01.615-.015.921V31.56c.005.31.006.61.015.921a12.992 12.992 0 00.18 2.002 6.588 6.588 0 00.624 1.905A6.208 6.208 0 001.998 38a6.274 6.274 0 001.618 1.179 6.7 6.7 0 001.901.63 13.455 13.455 0 002.004.177c.31.007.613.011.919.011.366.002.728.002 1.095.002h100.6c.36 0 .724 0 1.084-.002.304 0 .617-.004.922-.01a13.279 13.279 0 002-.178 6.804 6.804 0 001.908-.63A6.277 6.277 0 00117.666 38a6.395 6.395 0 001.182-1.614 6.604 6.604 0 00.619-1.905 13.506 13.506 0 00.185-2.002c.004-.31.004-.61.004-.921.008-.364.008-.725.008-1.094V9.536c0-.366 0-.73-.008-1.092 0-.306 0-.614-.004-.92a13.507 13.507 0 00-.185-2.003 6.618 6.618 0 00-.62-1.903 6.466 6.466 0 00-2.798-2.8 6.768 6.768 0 00-1.908-.627 13.044 13.044 0 00-2-.176c-.305-.005-.618-.011-.922-.013-.36-.002-.725-.002-1.084-.002z"}),jsx("path",{d:"M8.445 39.125c-.305 0-.602-.004-.904-.01a12.687 12.687 0 01-1.87-.164 5.884 5.884 0 01-1.656-.548 5.406 5.406 0 01-1.397-1.016 5.32 5.32 0 01-1.02-1.397 5.722 5.722 0 01-.544-1.657 12.414 12.414 0 01-.166-1.875c-.007-.21-.015-.913-.015-.913v-23.1s.009-.692.015-.895a12.37 12.37 0 01.165-1.872 5.755 5.755 0 01.544-1.662 5.373 5.373 0 011.015-1.398 5.565 5.565 0 011.402-1.023 5.823 5.823 0 011.653-.544A12.586 12.586 0 017.543.887l.902-.012h102.769l.913.013a12.385 12.385 0 011.858.162 5.938 5.938 0 011.671.548 5.594 5.594 0 012.415 2.42 5.763 5.763 0 01.535 1.649 12.995 12.995 0 01.174 1.887c.003.283.003.588.003.89.008.375.008.732.008 1.092v20.929c0 .363 0 .718-.008 1.075 0 .325 0 .623-.004.93a12.731 12.731 0 01-.17 1.853 5.739 5.739 0 01-.54 1.67 5.48 5.48 0 01-1.016 1.386 5.413 5.413 0 01-1.4 1.022 5.862 5.862 0 01-1.668.55 12.542 12.542 0 01-1.869.163c-.293.007-.6.011-.897.011l-1.084.002z"}),jsxs("g",{"data-name":"<Group>",children:[jsx("g",{"data-name":"<Group>",children:jsxs("g",{fill:"#fff","data-name":"<Group>",children:[jsx("path",{d:"M24.769 20.3a4.949 4.949 0 012.356-4.151 5.066 5.066 0 00-3.99-2.158c-1.68-.176-3.308 1.005-4.164 1.005-.872 0-2.19-.988-3.608-.958a5.315 5.315 0 00-4.473 2.728c-1.934 3.348-.491 8.269 1.361 10.976.927 1.325 2.01 2.805 3.428 2.753 1.387-.058 1.905-.885 3.58-.885 1.658 0 2.144.885 3.59.852 1.489-.025 2.426-1.332 3.32-2.67a10.962 10.962 0 001.52-3.092 4.782 4.782 0 01-2.92-4.4z","data-name":"<Path>"}),jsx("path",{d:"M22.037 12.21a4.872 4.872 0 001.115-3.49 4.957 4.957 0 00-3.208 1.66A4.636 4.636 0 0018.8 13.74a4.1 4.1 0 003.237-1.53z","data-name":"<Path>"})]})}),jsx("g",{fill:"#fff",children:jsx("path",{d:"M42.302 27.14H37.57l-1.137 3.356h-2.005l4.484-12.418h2.083l4.483 12.418h-2.039zm-4.243-1.55h3.752l-1.85-5.446h-.051zM55.16 25.97c0 2.813-1.506 4.62-3.779 4.62a3.07 3.07 0 01-2.848-1.583h-.043v4.484H46.63V21.442h1.8v1.506h.033a3.212 3.212 0 012.883-1.6c2.298 0 3.813 1.816 3.813 4.622zm-1.91 0c0-1.833-.948-3.038-2.393-3.038-1.42 0-2.375 1.23-2.375 3.038 0 1.824.955 3.046 2.375 3.046 1.445 0 2.393-1.197 2.393-3.046zM65.125 25.97c0 2.813-1.506 4.62-3.779 4.62a3.07 3.07 0 01-2.848-1.583h-.043v4.484h-1.859V21.442h1.799v1.506h.034a3.212 3.212 0 012.883-1.6c2.298 0 3.813 1.816 3.813 4.622zm-1.91 0c0-1.833-.948-3.038-2.393-3.038-1.42 0-2.375 1.23-2.375 3.038 0 1.824.955 3.046 2.375 3.046 1.445 0 2.392-1.197 2.392-3.046zM71.71 27.036c.138 1.232 1.334 2.04 2.97 2.04 1.566 0 2.693-.808 2.693-1.919 0-.964-.68-1.54-2.29-1.936l-1.609-.388c-2.28-.55-3.339-1.617-3.339-3.348 0-2.142 1.867-3.614 4.519-3.614 2.624 0 4.423 1.472 4.483 3.614h-1.876c-.112-1.239-1.136-1.987-2.634-1.987s-2.521.757-2.521 1.858c0 .878.654 1.395 2.255 1.79l1.368.336c2.548.603 3.606 1.626 3.606 3.443 0 2.323-1.85 3.778-4.793 3.778-2.754 0-4.614-1.42-4.734-3.667zM83.346 19.3v2.142h1.722v1.472h-1.722v4.991c0 .776.345 1.137 1.102 1.137a5.808 5.808 0 00.611-.043v1.463a5.104 5.104 0 01-1.032.086c-1.833 0-2.548-.689-2.548-2.445v-5.189h-1.316v-1.472h1.316V19.3zM86.065 25.97c0-2.849 1.678-4.639 4.294-4.639 2.625 0 4.295 1.79 4.295 4.639 0 2.856-1.661 4.638-4.295 4.638-2.633 0-4.294-1.782-4.294-4.638zm6.695 0c0-1.954-.895-3.108-2.401-3.108s-2.4 1.162-2.4 3.108c0 1.962.894 3.106 2.4 3.106s2.401-1.144 2.401-3.106zM96.186 21.442h1.773v1.541h.043a2.16 2.16 0 012.177-1.635 2.866 2.866 0 01.637.069v1.738a2.598 2.598 0 00-.835-.112 1.873 1.873 0 00-1.937 2.083v5.37h-1.858zM109.384 27.837c-.25 1.643-1.85 2.771-3.898 2.771-2.634 0-4.269-1.764-4.269-4.595 0-2.84 1.644-4.682 4.19-4.682 2.506 0 4.08 1.72 4.08 4.466v.637h-6.394v.112a2.358 2.358 0 002.436 2.564 2.048 2.048 0 002.09-1.273zm-6.282-2.702h4.526a2.177 2.177 0 00-2.22-2.298 2.292 2.292 0 00-2.306 2.298z"})})]}),jsx("g",{"data-name":"<Group>",children:jsx("g",{fill:"#fff",children:jsx("path",{d:"M37.826 8.731a2.64 2.64 0 012.808 2.965c0 1.906-1.03 3.002-2.808 3.002h-2.155V8.73zm-1.228 5.123h1.125a1.876 1.876 0 001.967-2.146 1.881 1.881 0 00-1.967-2.134h-1.125zM41.68 12.444a2.133 2.133 0 114.248 0 2.134 2.134 0 11-4.247 0zm3.334 0c0-.976-.439-1.547-1.208-1.547-.773 0-1.207.571-1.207 1.547 0 .984.434 1.55 1.207 1.55.77 0 1.208-.57 1.208-1.55zM51.573 14.698h-.922l-.93-3.317h-.07l-.927 3.317h-.913l-1.242-4.503h.902l.806 3.436h.067l.926-3.436h.852l.926 3.436h.07l.803-3.436h.889zM53.854 10.195h.855v.715h.066a1.348 1.348 0 011.344-.802 1.465 1.465 0 011.559 1.675v2.915h-.889v-2.692c0-.724-.314-1.084-.972-1.084a1.033 1.033 0 00-1.075 1.141v2.635h-.888zM59.094 8.437h.888v6.26h-.888zM61.218 12.444a2.133 2.133 0 114.247 0 2.134 2.134 0 11-4.247 0zm3.333 0c0-.976-.439-1.547-1.208-1.547-.773 0-1.207.571-1.207 1.547 0 .984.434 1.55 1.207 1.55.77 0 1.208-.57 1.208-1.55zM66.4 13.424c0-.81.604-1.278 1.676-1.344l1.22-.07v-.389c0-.475-.315-.744-.922-.744-.497 0-.84.182-.939.5h-.86c.09-.773.818-1.27 1.84-1.27 1.128 0 1.765.563 1.765 1.514v3.077h-.855v-.633h-.07a1.515 1.515 0 01-1.353.707 1.36 1.36 0 01-1.501-1.348zm2.895-.384v-.377l-1.1.07c-.62.042-.9.253-.9.65 0 .405.351.64.834.64a1.062 1.062 0 001.166-.983zM71.348 12.444c0-1.423.732-2.324 1.87-2.324a1.484 1.484 0 011.38.79h.067V8.437h.888v6.26h-.851v-.71h-.07a1.563 1.563 0 01-1.415.785c-1.145 0-1.869-.901-1.869-2.328zm.918 0c0 .955.45 1.53 1.203 1.53.75 0 1.212-.583 1.212-1.526 0-.938-.468-1.53-1.212-1.53-.748 0-1.203.58-1.203 1.526zM79.23 12.444a2.133 2.133 0 114.247 0 2.134 2.134 0 11-4.247 0zm3.333 0c0-.976-.438-1.547-1.208-1.547-.772 0-1.207.571-1.207 1.547 0 .984.435 1.55 1.207 1.55.77 0 1.208-.57 1.208-1.55zM84.67 10.195h.855v.715h.066a1.348 1.348 0 011.344-.802 1.465 1.465 0 011.559 1.675v2.915h-.889v-2.692c0-.724-.314-1.084-.972-1.084a1.033 1.033 0 00-1.075 1.141v2.635h-.889zM93.515 9.074v1.141h.976v.749h-.976v2.315c0 .472.194.679.637.679a2.967 2.967 0 00.339-.021v.74a2.916 2.916 0 01-.484.046c-.988 0-1.381-.348-1.381-1.216v-2.543h-.715v-.749h.715V9.074zM95.705 8.437h.88v2.481h.07a1.386 1.386 0 011.374-.806 1.483 1.483 0 011.55 1.679v2.907h-.889V12.01c0-.72-.335-1.084-.963-1.084a1.052 1.052 0 00-1.134 1.142v2.63h-.888zM104.761 13.482a1.828 1.828 0 01-1.95 1.303 2.045 2.045 0 01-2.081-2.325 2.077 2.077 0 012.076-2.352c1.253 0 2.009.856 2.009 2.27v.31h-3.18v.05a1.19 1.19 0 001.2 1.29 1.08 1.08 0 001.07-.546zm-3.126-1.451h2.275a1.086 1.086 0 00-1.109-1.167 1.152 1.152 0 00-1.166 1.167z"})})})]})}var Fa=()=>jsxs("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24",style:{msFilter:""},fill:"rgba(0, 0, 0, 1)",children:[jsx("circle",{cx:"15.5",cy:"13.5",r:"2.5"}),jsx("path",{d:"M12 13.5c0-.815.396-1.532 1-1.988A2.47 2.47 0 0011.5 11a2.5 2.5 0 100 5 2.47 2.47 0 001.5-.512 2.486 2.486 0 01-1-1.988z"}),jsx("path",{d:"M20 4H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V6c0-1.103-.897-2-2-2zM4 18V6h16l.002 12H4z"})]});var Oa=()=>jsx("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24",style:{msFilter:""},fill:"rgba(0, 0, 0, 1)",children:jsx("path",{d:"M11.454 17.021c.048.041.1.082.151.122a6.173 6.173 0 01-3.42 1.03A6.17 6.17 0 012.01 12a6.175 6.175 0 019.592-5.144c-.05.043-.1.082-.138.126A6.633 6.633 0 009.166 12c0 1.925.833 3.755 2.288 5.021zm4.361-11.195a6.14 6.14 0 00-3.416 1.03c.049.043.099.082.137.126 1.462 1.263 2.299 3.094 2.299 5.018s-.835 3.753-2.288 5.021c-.049.041-.101.082-.151.122a6.162 6.162 0 003.418 1.03 6.174 6.174 0 10.001-12.347zM12 7.15A6.152 6.152 0 009.644 12 6.15 6.15 0 0012 16.853 6.157 6.157 0 0014.357 12 6.15 6.15 0 0012 7.15z"})});function _a(){return jsxs("svg",{xmlns:"http://www.w3.org/2000/svg",x:"0",y:"0",version:"1",viewBox:"0 0 468 162.7",xmlSpace:"preserve",children:[jsxs("g",{children:[jsx("g",{fill:"#FFF",children:jsx("path",{d:"M22.9 15.5h13l42.7 55.2V24.9c0-9.4 11.4-11.3 13.8-11.3v81.8H80.7l-44-56.8v46.9c0 9.9-11.5 10.8-13.8 10.8V15.5zM107.4 73.5V35.2h13.8v34.2c0 9.3 4.7 14.6 12.9 14.6 8 0 13.6-5.5 13.6-14.8v-34h13.9v61.2c-2.6 0-13.9 0-13.9-10v-.3c-3.9 5.7-9.5 10.6-18.8 10.6-13.6-.1-21.5-9.2-21.5-23.2z"})}),jsx("path",{fill:"#FFF",d:"M174.6 55.7v-.2c0-22.7 17-41.3 41-41.3 14.8 0 23.7 5.1 31.4 12.4L238 37c-6.5-5.9-13.2-9.8-22.5-9.8-15 0-26.2 12.4-26.2 28v.2c0 15.6 11.1 28.3 26.3 28.3 9.8 0 16.1-3.9 22.9-10.3l9 9.1c-8.3 8.7-17.4 14.1-32.4 14.1-23.3.1-40.5-18-40.5-40.9zM253.9 78v-.2c0-13 10.3-19.4 25-19.4 6.7 0 11.5 1 16.2 2.5v-1.5c0-8.5-5.2-13.1-14.9-13.1-6.7 0-11.7 1.5-17.2 3.8l-3.8-10.8c6.7-3 13.2-4.9 22.8-4.9 9 0 15.7 2.4 20 6.7 4.4 4.3 6.5 10.7 6.5 18.6v37.7c-2.7 0-13.5 0-13.5-9v-.5c-4.1 4.9-10.4 8.8-19.6 8.8-11.3-.1-21.5-6.6-21.5-18.7zm41.4-4.3v-4.1c-3.5-1.4-8.2-2.4-13.7-2.4-8.9 0-14.1 3.8-14.1 10v.2c0 5.8 5.1 9.1 11.7 9.1 9.2.1 16.1-5.2 16.1-12.8zm28.3-49c0-9.2 10.6-11.1 13.9-11.1v81.8h-13.9V24.7zM353 35.2h13.9v9.1c3.9-5.4 9.1-10.4 18.4-10.4 8.7 0 14.8 4.2 18 10.6 4.8-6.4 11.2-10.6 20.3-10.6 13.1 0 21.1 8.3 21.1 23v39.4c-3.3 0-13.8-.3-13.8-10V61.1c0-9.6-4.4-14.7-12.2-14.7-7.5 0-12.9 5.2-12.9 14.9v34H392V61c0-9.3-4.6-14.6-12.2-14.6s-12.9 5.7-12.9 14.9v34H353V35.2z"}),jsx("g",{fill:"#FFF",children:jsx("path",{d:"M449.2 39.3h-2v-1.1h5.5v1.1h-2v5.9h-1.5v-5.9zM453.6 38.2h1.7c.6 1.5 1.4 3.6 1.7 4.4.3-.9 1.1-3 1.7-4.4h1.7v7.1H459v-5c-.4 1.1-1.3 3.3-2 5h-.1c-.7-1.8-1.7-4-2-5 .1 1.1.1 3.3.1 5h-1.4v-7.1z"})})]}),jsx("g",{fill:"#FFF",children:jsx("path",{d:"M150.7 128.9c0 2.7-.5 5.2-1.4 7.2s-2.3 3.7-4.1 4.8-3.8 1.7-6.1 1.7c-3.5 0-6.3-1.2-8.4-3.7s-3.2-5.9-3.2-10.1v-3.1c0-2.7.5-5.1 1.4-7.2 1-2.1 2.3-3.7 4.1-4.8 1.8-1.1 3.8-1.7 6.1-1.7s4.3.6 6.1 1.7 3.1 2.7 4.1 4.7 1.5 4.4 1.5 7v3.5h-.1zm-2.5-3.2c0-3.6-.8-6.4-2.4-8.4s-3.9-3.1-6.7-3.1-5 1-6.6 3.1-2.5 4.9-2.5 8.6v3.1c0 3.5.8 6.3 2.5 8.4 1.6 2.1 3.9 3.1 6.7 3.1 2.9 0 5.1-1 6.7-3.1s2.4-4.9 2.4-8.5l-.1-3.2zM161.3 137.1l.4 1.9.5-2 5.3-17h2.1l5.3 16.8.6 2.3.5-2.2 4.6-17h2.5l-6.5 22.2h-2.1l-5.7-17.6-.3-1.2-.3 1.2-5.6 17.6h-2.1l-6.4-22.2h2.5l4.7 17.2zM189.1 120l.1 3.8c.8-1.4 1.9-2.4 3.1-3.1 1.2-.7 2.6-1.1 4.1-1.1 2.4 0 4.1.7 5.3 2s1.8 3.3 1.8 6v14.6H201v-14.6c0-2-.4-3.5-1.3-4.4s-2.1-1.5-4-1.5c-1.5 0-2.9.5-4 1.4s-2 2.2-2.6 3.8v15.2h-2.4V120h2.4zM223.9 114.4v5.7h4.6v2h-4.6v14.8c0 1.2.2 2.1.7 2.8s1.2.9 2.2.9c.4 0 1.1-.1 2-.2l.1 2c-.6.2-1.5.3-2.6.3-1.7 0-2.9-.5-3.7-1.5s-1.1-2.4-1.1-4.3V122h-4.1v-2h4.1v-5.7l2.4.1zM235 123.8c.8-1.3 1.8-2.4 3.1-3.1s2.6-1.1 4.1-1.1c2.4 0 4.1.7 5.3 2s1.8 3.3 1.8 6v14.6h-2.4v-14.6c0-2-.4-3.5-1.3-4.4-.8-1-2.2-1.5-4-1.5-1.5 0-2.9.5-4 1.4-1.2 1-2 2.2-2.6 3.8v15.2h-2.4v-31.5h2.4v13.2zM263.6 142.6c-1.9 0-3.6-.5-5.1-1.4s-2.7-2.2-3.6-3.9c-.8-1.7-1.3-3.5-1.3-5.6v-.9c0-2.1.4-4.1 1.2-5.8s2-3.1 3.5-4 3.1-1.5 4.8-1.5c2.7 0 4.8.9 6.4 2.8 1.6 1.8 2.4 4.4 2.4 7.5v1.4h-15.8v.5c0 2.5.7 4.6 2.2 6.3 1.4 1.7 3.3 2.5 5.4 2.5 1.3 0 2.5-.2 3.5-.7s1.9-1.2 2.7-2.3l1.5 1.2c-1.8 2.6-4.4 3.9-7.8 3.9zm-.5-20.9c-1.8 0-3.4.7-4.7 2-1.3 1.4-2 3.2-2.3 5.5h13.3v-.3c-.1-2.1-.7-3.9-1.8-5.2s-2.6-2-4.5-2zM285.9 130.9c0-3.4.8-6.2 2.3-8.2s3.6-3.1 6.3-3.1c3 0 5.3 1.2 6.8 3.5v-12.4h2.4v31.5h-2.3l-.1-3c-1.6 2.2-3.9 3.4-6.9 3.4-2.6 0-4.6-1-6.2-3.1s-2.3-4.8-2.3-8.3v-.3zm2.5.5c0 2.8.6 5.1 1.7 6.7 1.1 1.6 2.7 2.5 4.8 2.5 3 0 5.2-1.3 6.4-4v-10.4c-1.3-2.9-3.4-4.3-6.4-4.3-2.1 0-3.7.8-4.8 2.4-1.1 1.5-1.7 3.9-1.7 7.1zM323.5 142.2c-.2-.7-.4-1.7-.5-3.1-.9 1.1-2 2-3.3 2.6s-2.7.9-4.2.9c-2.1 0-3.9-.6-5.2-1.8s-2-2.7-2-4.5c0-2.2.9-3.9 2.7-5.1 1.8-1.3 4.3-1.9 7.5-1.9h4.5v-2.5c0-1.6-.5-2.8-1.5-3.7-1-.9-2.4-1.4-4.3-1.4-1.7 0-3.1.4-4.2 1.3s-1.7 1.9-1.7 3.2h-2.5c0-1.8.8-3.3 2.5-4.6 1.6-1.3 3.7-1.9 6-1.9 2.5 0 4.4.6 5.9 1.9 1.4 1.2 2.2 3 2.2 5.2v10.5c0 2.1.2 3.8.7 4.8v.2l-2.6-.1zm-7.7-1.7c1.6 0 3.1-.4 4.4-1.2s2.2-1.9 2.8-3.2v-4.9h-4.4c-2.4 0-4.4.5-5.7 1.3-1.4.9-2.1 2.1-2.1 3.6 0 1.2.5 2.3 1.4 3.1.9.8 2.1 1.3 3.6 1.3zM337.6 138.7l6.5-18.7h2.6l-9.5 26-.5 1.1c-1.2 2.7-3.1 4-5.6 4-.6 0-1.2-.1-1.9-.3v-2l1.3.1c1.2 0 2.2-.3 2.9-.9.7-.6 1.4-1.6 1.9-3.1l1.1-3-8.4-22h2.7l6.9 18.8zM347.5 140.7c0-.5.2-.9.5-1.2s.7-.5 1.3-.5 1 .2 1.3.5.5.7.5 1.2-.2.9-.5 1.2-.7.5-1.3.5-1-.2-1.3-.5c-.4-.3-.5-.7-.5-1.2z"})})]})}var Ga=()=>jsx("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24",style:{msFilter:""},fill:"rgba(0, 0, 0, 1)",children:jsx("path",{d:"M19.554 9.488c.121.563.106 1.246-.04 2.051-.582 2.978-2.477 4.466-5.683 4.466h-.442a.666.666 0 00-.444.166.72.72 0 00-.239.427l-.041.189-.553 3.479-.021.151a.706.706 0 01-.247.426.666.666 0 01-.447.166H8.874a.395.395 0 01-.331-.15.457.457 0 01-.09-.363c.061-.373.148-.938.267-1.689.117-.75.206-1.314.267-1.689s.15-.938.272-1.685c.121-.748.212-1.31.271-1.685.033-.248.179-.371.433-.371h1.316c.893.013 1.682-.057 2.375-.211 1.172-.262 2.134-.744 2.886-1.449.685-.637 1.203-1.462 1.56-2.473.162-.47.277-.917.352-1.338.006-.041.014-.066.025-.074.008-.011.022-.014.035-.011a.378.378 0 01.062.035c.524.398.854.941.98 1.632zm-1.728-2.836c0 .717-.154 1.508-.465 2.374-.537 1.562-1.547 2.618-3.037 3.168-.758.269-1.602.408-2.535.425 0 .006-.301.007-.904.007l-.903-.007c-.672 0-1.067.32-1.187.964-.013.053-.298 1.83-.855 5.329-.008.066-.048.102-.121.102H4.854a.473.473 0 01-.369-.165.469.469 0 01-.115-.39L6.702 3.664a.784.784 0 01.276-.483.785.785 0 01.519-.19h6.014c.228 0 .555.044.979.131.428.084.801.194 1.123.321.718.274 1.266.688 1.645 1.237.379.552.568 1.207.568 1.972z"})});function Se({width:e,height:t,alt:a,className:r}){return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(next_image_js__WEBPACK_IMPORTED_MODULE_5__,{src:"https://nucalm.com/hubfs/badges/stripe/Powered%20by%20Stripe%20-%20blurple.svg",width:e??"150",height:t??"50",alt:a??"stripe",className:r})}var Ka=()=>jsx("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24",style:{msFilter:""},fill:"rgba(0, 0, 0, 1)",children:jsx("path",{d:"M16.539 9.186a4.155 4.155 0 00-1.451-.251c-1.6 0-2.73.806-2.738 1.963-.01.85.803 1.329 1.418 1.613.631.292.842.476.84.737-.004.397-.504.577-.969.577-.639 0-.988-.089-1.525-.312l-.199-.093-.227 1.332c.389.162 1.09.301 1.814.313 1.701 0 2.813-.801 2.826-2.032.014-.679-.426-1.192-1.352-1.616-.563-.275-.912-.459-.912-.738 0-.247.299-.511.924-.511a2.95 2.95 0 011.213.229l.15.067.227-1.287-.039.009zm4.152-.143h-1.25c-.389 0-.682.107-.852.493l-2.404 5.446h1.701l.34-.893 2.076.002c.049.209.199.891.199.891h1.5l-1.31-5.939zm-10.642-.05h1.621l-1.014 5.942H9.037l1.012-5.944v.002zm-4.115 3.275l.168.825 1.584-4.05h1.717l-2.551 5.931H5.139l-1.4-5.022a.339.339 0 00-.149-.199 6.948 6.948 0 00-1.592-.589l.022-.125h2.609c.354.014.639.125.734.503l.57 2.729v-.003zm12.757.606l.646-1.662c-.008.018.133-.343.215-.566l.111.513.375 1.714H18.69v.001h.001z"})});var r0=({userImageUrl:e,width:t=30,height:a=30})=>jsx(Fragment,{children:e?jsx(na,{src:e,width:t,height:a,className:"rounded-full border-black border-2 lg:border-2 border-solid",alt:"user img"}):jsx(Icon,{icon:"person"})});var s0=e=>jsxs("section",{className:"border-2 border-black p-5 pb-3 rounded-2xl flex place-content-between items-center bg-white text-[18px] mb-5",children:[(a=>{var o;let{dataInfo:r}=e;switch(a){case"accountInfo":return jsxs("div",{className:"break-words w-[210px] ",children:[jsxs("p",{className:"font-bold mb-0",children:[r.firstName," ",r.lastName]}),jsx("p",{className:"mb-0",children:r.email}),jsxs("p",{className:"mb-0",children:[r.countryCode," ",r.phone]})]});case"shippingInfo":return jsxs("div",{className:"break-words w-[210px] ",children:[jsxs("p",{className:"font-bold mb-0",children:[" ",countries[r.country].name]}),jsx("p",{className:"mb-0",children:r.addressOne}),r.addressTwo&&jsxs("p",{className:"mb-0",children:[" ",r.addressTwo]}),jsxs("p",{className:"mb-0",children:[r.city,", ",r.state]}),jsx("p",{className:"mb-0",children:r.zip.toUpperCase()})]});case"shippingTypeInfo":return jsxs("div",{className:"break-words w-[210px] ",children:[jsx("p",{className:"font-bold mb-0 capitalize",children:r.shippingMethod}),r.shippingMethod==="standard"?jsx("p",{children:"$6.00"}):jsx("p",{children:"$29.00"})]});case"billingInfo":return e.dataInfo.sameAsAddress?jsx(Fragment,{children:jsx("p",{children:"Using shipping address."})}):jsxs("div",{className:"break-words w-[210px] md:w-full",children:[jsxs("p",{className:"font-bold mb-0",children:[r.firstNameBilling," ",r.lastNameBilling]}),jsxs("p",{className:"mb-0",children:[" ",countries[r.countryBilling].name]}),jsx("p",{className:"mb-0",children:r.addressOneBilling}),r.addressTwoBilling&&jsxs("p",{className:"mb-0",children:[" ",r.addressTwoBilling]}),jsxs("p",{className:"mb-0 capitalize",children:[r.cityBilling,", ",r.stateBilling," "]}),jsx("p",{children:r.zipBilling.toUpperCase()})]});case"paymentInfo":if(r.paymentMethod==="card")return jsxs("div",{className:"break-words w-[210px] md:w-full",children:[jsxs("p",{className:"mb-0 flex",children:[jsx(Icon,{icon:"credit-card",className:"mr-2"}),`**** **** **** ${(o=r.paymentMethodDetails)==null?void 0:o.card.last4}`]}),jsxs("div",{className:"flex",children:[" ",jsx("p",{children:`${r.paymentMethodDetails.card.expMonth}/${r.paymentMethodDetails.card.expYear}`})," "]})]});if(r.paymentMethod==="payPal")return jsx("div",{className:"break-words w-[210px] md:w-full",children:jsx("p",{children:"Using PayPal "})});break;default:return}})(e.componentType),jsx(Ge,{id:"updateButton",text:"Update",onClick:e.onClick,variant:"continue",className:"min-w-[100px] w-[100px]",fill:!1})]});var Qa=e=>(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(D,{label:e.label,className:e.className,children:[e.error&&(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(C,{className:"text-black",children:e.error}),(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("input",{...e,name:e.name,value:e.value,type:e.type,className:classnames__WEBPACK_IMPORTED_MODULE_0__(e.error?"border-2 border-solid border-secondary-500":"",_blueprintjs_core__WEBPACK_IMPORTED_MODULE_10__.INPUT,_blueprintjs_core__WEBPACK_IMPORTED_MODULE_10__.FILL)})]});var eo=e=>jsx(D,{label:e.label,className:e.error?"text-secondary-500":"",children:jsx(nt,{...e})});var oo=e=>(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_blueprintjs_core__WEBPACK_IMPORTED_MODULE_9__/* .Label */ .__,{className:e.labelclassname,children:[(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("input",{...e,type:"radio",className:classnames__WEBPACK_IMPORTED_MODULE_0__(e.error?"border-2 border-solid border-secondary-500":"",_blueprintjs_core__WEBPACK_IMPORTED_MODULE_10__.RADIO,"text-[18px]",e.className),value:e.value,name:e.name}),(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("p",{className:"font-bold mb-1 text-[18px]",children:[" ",e.title]}),(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("p",{className:"text-[18px]",children:[" ",e.text]})]});var lo=e=>(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(D,{label:e.label,className:classnames__WEBPACK_IMPORTED_MODULE_0__(e.className,e.error?"text-secondary-500":""),children:(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_blueprintjs_core__WEBPACK_IMPORTED_MODULE_9__/* .HTMLSelect */ .Lu,{disabled:e.disabled,value:e.value,name:e.name,onChange:e.onChange,id:e.id,className:classnames__WEBPACK_IMPORTED_MODULE_0__(e.error?"border-2 border-solid border-secondary-500":"",_blueprintjs_core__WEBPACK_IMPORTED_MODULE_10__.HTML_SELECT,_blueprintjs_core__WEBPACK_IMPORTED_MODULE_10__.FILL),children:e.children})});var so=e=>(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(D,{label:e.label,children:(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(lt,{...e})});var X0=e=>jsx(Checkbox,{...e,large:!0,type:"checkbox",name:e.name,value:e.value,className:ge(e.error?"border-2 border-solid border-secondary-500":"",Classes.CHECKBOX,"text-base text-[18px]",e.classname),children:jsxs(Label,{children:[e.children," "]})});var el=({navLinks:e,dropDownText:t})=>{let[a,r]=useState(!1);return jsx(Popover2,{popoverClassName:"z-50",className:"z-50 rounded-md hover:cursor-pointer",position:Position.BOTTOM,content:jsx(Menu,{className:"z-50 rounded-md text-base flex flex-col text-center shadow-md mt-[13px]",children:e.length>0?e.map((o,i)=>jsx(ft,{href:o.href,text:o.text,className:"text-left  pb-1 px-2 hover:bg-gray-100 hover:rounded-sm"},i)):null}),children:jsxs("p",{className:"bg-none outline-none shadow-none border-0 flex items-center",onClick:()=>r(o=>!o),children:[t," ",a?jsx("i",{className:"fa-solid fa-angle-up ml-1 mt-1"}):jsx("i",{className:"fa-solid fa-angle-down ml-1 mt-1"})]})})};var il=({greaterThan8State:e,includeUpperCaseLetterState:t,includesOneNumberState:a,includesOneSpecialCharState:r})=>jsxs(pt,{id:"passwordCriteriaHelper",className:ge(Classes.INPUT,"h-auto"),children:[jsxs("p",{children:[e?jsx(z,{size:25,iconName:"tick",className:"text-green-500"}):jsx(z,{size:25,iconName:"cross",className:"text-red-500"})," ","- Your password is greater than 8 characters"]}),jsxs("p",{children:[t?jsx(z,{size:25,iconName:"tick",className:"text-green-500"}):jsx(z,{size:25,iconName:"cross",className:"text-red-500"})," ","- Your password includes an uppercase letter"]}),jsxs("p",{children:[" ",a?jsx(z,{size:25,iconName:"tick",className:"text-green-500"}):jsx(z,{size:25,iconName:"cross",className:"text-red-500"})," ","- Your password includes one number"]}),jsxs("p",{children:[r?jsx(z,{size:25,iconName:"tick",className:"text-green-500"}):jsx(z,{size:25,iconName:"cross",className:"text-red-500"})," ","- Your password includes on of the following special characters:!@#$%"," "]})]});function Mo({className:e}){return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div",{className:classnames__WEBPACK_IMPORTED_MODULE_0__(e,"flex flex-row"),children:[(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Se,{}),(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Me,{})]})}var Il=({className:e,logo:{url:t,width:a,height:r,onClick:o},ctas:i,links:s,menu:n,children:g,id:y})=>{var p,x,h;let[f,v]=(0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(!1),m=(l,b)=>(l==null?void 0:l.length)>0&&(b==null?void 0:b.length)>0;return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_blueprintjs_core__WEBPACK_IMPORTED_MODULE_9__/* .Navbar */ .wp,{id:y??"navbar",className:"shadow-none h-auto p-0 sticky",fixedToTop:!0,children:[g,(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div",{className:"wrapper",children:[(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_blueprintjs_core__WEBPACK_IMPORTED_MODULE_9__/* .NavbarGroup */ .fT,{align:_blueprintjs_core__WEBPACK_IMPORTED_MODULE_11__/* .Alignment.LEFT */ .v.LEFT,className:"hidden md:flex",children:[(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(xe,{url:t,width:a,height:r,onClick:o}),(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ul",{className:"ml-[20px] flex justify-between px-4",children:(s==null?void 0:s.length)>0?s.map((l,b)=>(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_blueprintjs_core__WEBPACK_IMPORTED_MODULE_9__/* .NavbarHeading */ .ym,{children:(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(next_link_js__WEBPACK_IMPORTED_MODULE_1__,{href:l.href,children:l.text})},b)):null})]}),(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_blueprintjs_core__WEBPACK_IMPORTED_MODULE_9__/* .NavbarGroup */ .fT,{align:_blueprintjs_core__WEBPACK_IMPORTED_MODULE_11__/* .Alignment.RIGHT */ .v.RIGHT,className:"hidden md:flex",children:(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("ul",{className:"flex flex-row justify-between items-center",children:[(i==null?void 0:i.length)>0&&i.map((l,b)=>(0,react__WEBPACK_IMPORTED_MODULE_3__.createElement)(j,{...l,key:b,small:!0})),m(i??[],(n==null?void 0:n.items)??[])?(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_blueprintjs_core__WEBPACK_IMPORTED_MODULE_9__/* .NavbarDivider */ .ox,{}):null,n&&((p=n.items)==null?void 0:p.length)>0&&(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_blueprintjs_popover2__WEBPACK_IMPORTED_MODULE_12__/* .Popover2 */ .p,{content:((x=n==null?void 0:n.items)==null?void 0:x.length)>0&&(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_blueprintjs_core__WEBPACK_IMPORTED_MODULE_9__/* .Menu */ .v2,{children:n==null?void 0:n.items.map((l,b)=>(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_blueprintjs_core__WEBPACK_IMPORTED_MODULE_9__/* .MenuItem */ .sN,{...l},b))}),placement:"bottom",children:n.toggleButton?(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(J,{...n.toggleButton}):(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(J,{children:(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_blueprintjs_core__WEBPACK_IMPORTED_MODULE_9__/* .Icon */ .JO,{icon:"person"})})})]})}),(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_blueprintjs_core__WEBPACK_IMPORTED_MODULE_9__/* .NavbarGroup */ .fT,{align:_blueprintjs_core__WEBPACK_IMPORTED_MODULE_11__/* .Alignment.LEFT */ .v.LEFT,className:"md:hidden",children:(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(xe,{url:t,width:a,height:r,onClick:o})}),(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_blueprintjs_core__WEBPACK_IMPORTED_MODULE_9__/* .NavbarGroup */ .fT,{align:_blueprintjs_core__WEBPACK_IMPORTED_MODULE_11__/* .Alignment.RIGHT */ .v.RIGHT,className:"md:hidden",children:[(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_blueprintjs_core__WEBPACK_IMPORTED_MODULE_9__/* .Icon */ .JO,{icon:"menu",size:30,onClick:()=>v(l=>!l)}),(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_blueprintjs_core__WEBPACK_IMPORTED_MODULE_9__/* .Drawer */ .dy,{isOpen:f,canEscapeKeyClose:!0,canOutsideClickClose:!0,size:"70%",onClose:()=>v(l=>!l),className:"p-5 sm:hidden",children:(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_blueprintjs_core__WEBPACK_IMPORTED_MODULE_9__/* .Menu */ .v2,{className:"text-base",children:[i==null?void 0:i.map((l,b)=>(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(j,{...l,small:!0},b)),m(i??[],(n==null?void 0:n.items)??[])?(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_blueprintjs_core__WEBPACK_IMPORTED_MODULE_9__/* .MenuDivider */ .R,{}):null,s==null?void 0:s.map((l,b)=>(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_blueprintjs_core__WEBPACK_IMPORTED_MODULE_9__/* .MenuItem */ .sN,{...l},b)),m(s??[],(n==null?void 0:n.items)??[])?(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_blueprintjs_core__WEBPACK_IMPORTED_MODULE_9__/* .MenuDivider */ .R,{}):null,(h=n==null?void 0:n.items)==null?void 0:h.map((l,b)=>(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_blueprintjs_core__WEBPACK_IMPORTED_MODULE_9__/* .MenuItem */ .sN,{...l},b))]})})]})]})]})};




/***/ })

}]);